const th = {
  a: {
    accountLocked: 'บัญชีถูกล็อก',
    accountLockedSince: 'ตั้งแต่',
    accountStatus: 'สถานะบัญชี',
    addNote: 'เพิ่มหมายเหตุ',
    autoOrderSettingPerDay: 'วันเปิดใช้งานสั่งวัตถุดิบอัตโนมัติ',
    actualOrder: 'จำนวนที่สั่งจริง',
    accumulate: 'สะสม',
    accumulatedUseOfTheMonth: 'สะสมของเดือน',
    areaSiteIsNotGeofence: 'พื้นที่หน่วยงานยังไม่เป็น Geofence',
    arriveIn: 'อีก ',
    addDetail: 'เพิ่มรายละเอียด',
    addLocation: 'เพิ่มสถานที่',
    allBusiness: 'กิจการทั้งหมด',
    affiliateUnPlaces: 'สถานที่ที่ไม่มีสังกัด',
    affiliatePlaces: 'สถานที่ที่มีสังกัด',
    affiliateType: 'ประเภทสังกัด',
    allTruck: 'รถทั้งหมด',
    AppropriateImageFileSizeNoMoreThan512KB:
      'ขนาดไฟล์รูปที่เหมาะสม ไม่เกิน 512KB',
    alert_type: 'ประเภทแจ้ง Alert',
    accidentScene: 'จุดเกิดเหตุ',
    avgPerDistanceTravel: 'จำนวนครั้งเฉลี่ยต่อจำนวนระยะทางที่วิ่ง',
    avgPerTrip: 'จำนวนครั้งเฉลี่ยต่อจำนวนทริป',
    average_distance: 'ระยะทางเฉลี่ย (กิโลเมตร) (คำนวณสิ้นวัน)',
    amount_poured: 'ปริมาณที่เท (คิว)',
    actual_quantity: 'ปริมาณจริง (ลิตร)',
    amount_money: 'จำนวนเงินรวม',
    amountOilUsed: 'ปริมาณน้ำมันที่ใช้ (ลิตร)',
    averageFleet: 'ค่าเฉลี่ยทั้งฟลีท',
    allData: 'ข้อมูลทั้งหมด',
    approve: 'อนุมัติ',
    approveBy: 'อนุมัติ โดย',
    approveAt: 'อนุมัติเมื่อ',
    acceptancePoint: 'จุดรับงาน',
    accessory: 'อุปกรณ์เสริม',
    account: 'บัญชีผู้ใช้',
    accountName: 'ผู้ใช้งาน',
    ACCUMULATEEARNINGSTATISTICS: 'ACCUMULATE EARNING STATISTICS',
    action: 'ดำเนินการ',
    actionBy: 'ดำเนินการ โดย',
    actionRequired: 'แจ้งเตือนพร้อมเปิดเคส',
    actionDataTime: 'วันที่ เวลา',
    actionTime: 'เวลา',
    active: 'คงอยู่',
    activeStatusImage: 'รูปภาพแสดงสถานะกำลังใช้งาน',
    actualArrivalTime: 'เวลาที่ไปถึงจริง',
    actualReleaseTime: 'เวลาที่ออกจริง',
    actualTransitDistance: 'ระยะทางที่ขนส่งจริง',
    add: 'เพิ่ม',
    addARow: 'เพิ่มแถว',
    addDrivinglicense: 'ใบอนุญาตขับขี่อื่นๆ',
    addFromRouteMaster: 'เพิ่มจากแผนการจัดส่ง',
    addInformation: 'เพิ่มข้อมูล',
    addItemInList: 'เพิ่มข้อมูลในรายการ',
    additionalDriverInformation: 'ข้อมูลพนักงานขับขี่เพิ่มเติม',
    additionalInformation: 'ข้อมูลเพิ่มเติม',
    additionalVehicleInformation: 'ข้อมูลพาหนะเพิ่มเติม',
    address: 'ที่อยู่',
    addVehicleGroup: 'เพิ่มกลุ่มพาหนะ',
    adjustTheTable: 'ปรับตาราง',
    administrator: 'เห็นข้อมูลแบบผู้ดูแลระบบ',
    affiliation: 'ต้นสังกัด',
    african: 'แอฟริกัน',
    after1day: 'ผ่านไป 1 วัน',
    after1hour: 'ผ่านไป 1 ชั่วโมง',
    after30min: 'ผ่านไป 30 นาที',
    after4hour: 'ผ่านไป 4 ชั่วโมง',
    after5min: 'ผ่านไป 5 นาที',
    after8hour: 'ผ่านไป 8 ชั่วโมง',
    agency: 'เอเจนซี่',
    agencyNumber: 'เลขที่หน่วยงาน',
    aggressiveAccelerationAndImmediatelyBreak: 'ออกตัวกระชาก/เบรคกระทันหัน',
    aggressiveTurnWithoutLight: 'เลี้ยวกระทันหัน',
    aggressiveTurnChangeDirectionBeyondTheSpeedOfTheSpecifiedArea:
      'เลี้ยวกระทันหัน เปลี่ยนทิศทางเกินความเร็วตามพื้นที่ที่กำหนด',
    alarm: 'Alarm',
    alarmAndAlertReportClassifiedByDailyCarRegistration:
      'Alert และ Alarm แยกตามทะเบียนรายวัน',
    alarmAndAlertReportClassifiedByYearlyCarRegistration:
      'Alert และ Alarm แยกตามทะเบียน รายปี',
    alert: 'Alert',
    alert_setting_filter: 'กรุณาตั้งค่ารายงาน',
    alertAlarm: 'การแจ้งเตือนการฝ่าฝืน',
    alertNotiOnly: 'แจ้งเตือนอย่างเดียว',
    aliasTableCompany: 'ชื่อย่อ',
    all: 'ทั้งหมด',
    allowBOOMInside: 'อนุญาตให้เปิด BOOM ในสถานที่เท่านั้น',
    allowBOOMOutside: 'อนุญาตให้เปิด BOOM นอกสถานที่เท่านั้น',
    allowParkingInside: 'อนุญาตให้จอดในสถานที่เท่านั้น',
    allowParkingOutside: 'อนุญาตให้จอดนอกสถานที่เท่านั้น',
    allowPTODoorInside: 'อนุญาตให้เปิด PTO/ประตู ในสถานที่เท่านั้น',
    allowPTODoorOutside: 'อนุญาตให้เปิด PTO/ประตู นอกสถานที่เท่านั้น',
    allowSharedPartnerEdit: 'ผู้ว่าจ้างสามารถแก้ไข',
    allowWorkingTime: 'ช่วงเวลาที่อนุญาติทำงาน',
    allStatusDashCameras: 'ทั้งหมด',
    allItems: 'เพิ่มหรือแก้ไขรายการ',
    amount: 'ครั้ง',
    amountPlant: 'จำนวนแพลนต์ใกล้เคียง',
    amountPlantIsRequired: 'กรุณากรอกจำนวนแพลนต์ใกล้เคียง',
    amphur: 'เขต/อำเภอ',
    and: 'และ',
    announcement: 'การประกาศ',
    announcementBroadcast: 'กระจายข่าว / เผยแพร่ข่าว ...',
    apply: 'ปรับใช้',
    appointment_date: 'วัน-เวลานัดหมาย',
    appointment_place: 'สถานที่นัด',
    appointmentLocation: 'สถานที่นัดหมาย',
    arab: 'อาหรับ',
    arriveArriveOnSite: 'ถึงหน้างาน',
    arriveAtDestinationDateTime: 'วันที่เวลาถึงปลายทาง',
    arriveAtDestination: 'ถึงปลายทาง',
    arriveAtfactory: 'ถึงโรงงาน',
    arriveAtTheOrigin: 'ถึงต้นทาง',
    assignAt: 'กำหนดเมื่อ',
    assignFirmware: 'กำหนดเฟิร์มแวร์',
    assignment: 'งานที่มอบหมาย',
    assignmentDate: 'วันที่มอบหมาย',
    assignTo: 'ผู้รับมอบหมาย',
    attachment_type: 'ประเภทไฟล์',
    available: 'พร้อมใช้งาน',
    avgEarningJob: 'Avg. Earning/Job',
    actual: 'ตามจริง',
    alertAndAlarm: 'Alert และ Alarm',
    arrangeCar: 'จัดรถ',
    arrangeACar: 'จัดรถแล้ว',
    autoDNSwitching: 'เปลี่ยนปลายทางอัตโนมัติ',
    afterSuckingLatex: 'หลังดูดน้ำยาง',
    anotherProblemType: 'ประเภทปัญหาอื่นๆ',
    allDp: 'ใบงานทั้งหมด',
    allowAccessToInformation: 'อนุญาต ให้ดึงข้อมูล',
    accessToInformationIsNotAllowed: 'ไม่อนุญาต ให้ดึงข้อมูล',
    aSystemThatCanRetrieveData: 'ระบบที่สามารถดึงข้อมูลได้',
    amountBaht: 'จำนวนเงิน(บาท)',
    attachFile: 'แนบไฟล์',
    allVehicles: 'รถทั้งหมด',
    assigned: 'จองรถ',
    assessProductQuality: 'ประเมินคุณภาพสินค้า',
    assessProductQualityForm: 'ฟอร์ม ประเมินคุณภาพสินค้า',
    allInformation: 'ข้อมูลทั้งหมด',
    autoOrginSwitching: 'เปลี่ยนต้นทางอัตโนมัติ',
    automatic: 'อัตโนมัติ',
    assessmentResults: 'ผลการประเมิน',
    assessedThroughIsupply: 'ประเมินผ่าน iSupply',
    assessedThroughBluenet: 'ประเมินผ่าน Bluenet',
    autoGR: 'อัตโนมัติ',
    assessedBy: 'ผู้ประเมิน',
    assessedOn: 'วันที่ประเมิน',
    amountOfRawMaterialShortageExcess: 'ปริมาณวัตถุดิบ (ขาด/เกิน)',
    automaticMaterialOrderingTime: 'เวลาสั่งวัตถุดิบอัตโนมัติ',
    automaticMaterialOrderingTimeIsRequired: 'ระบุ เวลาสั่งวัตถุดิบอัตโนมัติ',
    automaticOrderingOfRawMaterials: 'สั่งวัตถุดิบอัตโนมัติ',
    ascending: 'น้อยไปมาก',
    assessed: 'ประเมินแล้ว',
    assessProductQualityHistory: 'ประวัติการประเมินคุณภาพสินค้า',
    autoOrder: 'Auto',
    actualCompressivedStrength: 'ผลิตจริง',
    accessibleLocation: 'สถานที่ที่สามารถเข้าได้',
    assignContractor: 'กำหนดผู้รับเหมา',
    assessProductQualityDashboard: 'GR รับวัตถุดิบ',
    allTicket: 'ตั๋วทั้งหมด',
    allItemList: 'รายการทั้งหมด',
    activate: 'เปิดใช้งาน',
    alwaysChooseThisSourceForThisMaterial:
      'เลือกต้นแหล่งนี้เสมอสำหรับวัตถุดิบนี้',
    addNewLocation: 'เพิ่มสถานที่ใหม่',
    approvedBy: 'อนุมัติโดย',
    appropriateImageSizeNoMoreThan: 'ขนาดรูปที่เหมาะสม ไม่เกิน',
    appropriateImageFileSizeNoMoreThan: 'ขนาดไฟล์รูปที่เหมาะสม ไม่เกิน',
    automaticallyDefineSilo: 'กำหนดไซโลอัตโนมัติ',
    approximateDistance: 'ระยะทางประมาณ',
    applyAllSilo: 'ปรับใช้ทุกไซโล',
    autoGRAt: 'Auto GR เมื่อ',
    availabilityOfRawMaterials: 'ความพร้อมของวัตถุดิบ',
    applyToUserGroup: 'เพิ่มกลุ่มผู้ใช้งาน',
    activateSAPNo: 'เปิดใช้งาน SAP No.',
    acceptingWorkInTheAreaOnly: 'รับงานในพื้นที่เท่านั้น',
    arrangeSecondarySources: 'จัดลำดับแหล่งรอง',
    applyToAutoOrder: 'ปรับใช้กับ auto order',
    auto_order_afternoon_delivery_morning: 'สั่งวัตถุดิบบ่ายส่งเช้า',
    approveTestAt: 'วันที่อนุมัติ',
    approvalDate: 'วันที่อนุมัติ',
    approveResult: 'อนุมัติผล',
    availableVehicle: 'รถพร้อม',
  },
  b: {
    beginingStockForPlant: 'ข้อมูลสต๊อก เช้าของโรงงาน',
    bluenetAccessToInformation: 'ดึงข้อมูลจาก bluenet',
    bluenetNotAccessToInformation: 'ไม่ดึงข้อมูลจาก bluenet',
    bluenetTransportDistance: 'ระยะขนส่ง Bluenet',
    building_time: 'เวลาสร้าง',
    before_litre: 'ก่อนเติม (ลิตร)',
    businesspartner: 'คู่ธุรกิจ',
    boxnumber: 'หมายเลขกล่อง',
    bluenet_other: 'อื่นๆ',
    is_bluenet_car: 'จาก Bluenet',
    back: 'กลับ',
    baht_defult: 'บาท',
    baht: '(บาท)',
    baht_km: '(บาท/กิโลเมตร)',
    bahtPerkm: '(บาท/กม.)',
    baht_trip: '(บาท/เที่ยว)',
    baht_ton_km: '(บาท/ตัน/กม.)',
    baht_unit_km: '(บาท/หน่วย/กม.)',
    baht_litre_km: '(บาท/ลิตร/กม.)',
    baht_litre: '(บาท/ลิตร)',
    base: 'พื้นฐาน',
    baseTemplate: 'Template พื้นฐาน',
    battery: 'แบตเตอรี่',
    battery_is_charge: 'ชาร์จอยู่',
    battery_not_charge: 'ไม่ได้ชาร์จอยู่',
    battery_status: 'สถานะการชาร์จแบต',
    behavior: 'พฤติกรรม',
    behavior_report_menu: 'พฤติกรรม',
    BehaviordrivingbycompanyReport:
      'สรุปพฤติกรรมการขับรถของ เจ้าหน้าที่บริการและจัดส่ง แต่ละผู้รับเหมา',
    BehaviordrivingReport: 'สรุปพฤติกรรมการขับรถของ เจ้าหน้าที่บริการและจัดส่ง',
    boatDeliveryDashboard: 'ระบบติดตามสถานะเรือ',
    boatDeliveryReport: 'การเดินทางเรือ',
    body_email: 'ข้อความเพิ่มเติม',
    bodyNo: 'หมายเลขตัวถังพาหนะ',
    bodyNoOfInstall: 'หมายเลขตัวรถที่ติดตั้ง',
    bookedDate: 'วันที่จอง',
    booking: 'งานจอง',
    bookingDate: 'วันที่จอง',
    bookingOverview: 'ภาพรวมงานจอง',
    bookingPool: 'งานจอง',
    bookingRemark: 'Booking Remark',
    BOOKINGSTATISTICS: 'สถิติการจอง',
    BOOM: 'BOOM',
    boxID: 'รหัสกล่อง',
    boxNumber: 'เบอร์กล่อง',
    brand: 'ยี่ห้อ',
    broken: 'เสีย',
    busStop1: 'Bus Stop 1',
    busStop2: 'Bus Stop 2',
    busStopPoint: 'Bus Stop Point',
    button: 'ปุ่ม',
    business: 'กิจการ',
    bookAnAppointmentWithCDAS: 'จองคิวกับ CDAS',
    bookAnAppointment: 'จองคิว',
    behindTheCar: 'ท้ายกระบะ',
    besideTheCar: 'ข้างตัวรถ',
    beforeSuckingTheLatex: 'ก่อนดูดน้ำยาง',
    business_group: 'กลุ่มธุรกิจ',
    bookingDate: 'วันที่งานจอง',
    bookingNo: 'เลขที่ใบงาน',
    bookingContactName: 'ชื่อ-นามสกุลผู้จอง/บริษัท',
    bookingContactNameIsRequired: 'กรุณาระบุ ชื่อ-นามสกุลผู้จอง/บริษัท',
    bookingContactPhone: 'เบอร์โทรติดต่อผู้จอง',
    bookingContactPhoneIsRequired: 'กรุณาระบุ เบอร์โทรติดต่อผู้จอง',
    bookAcar: 'จองรถ',
    bookingDetails: 'รายละเอียดการจอง',
    bluenetResponseAt: 'วันที่-เวลาตอบกลับจาก bluenet',
    bluenetResponseMsg: 'ข้อความตอบกลับจาก bluenet',
    beginingStockv2: 'Stock เช้าของโรงงาน',
    beginingStock: 'ยอดเคาะเช้า',
    beginingStockAt1stOfMonth: '(วันที่ 1 ของเดือน)',
  },
  c: {
    calculateDeliveryDistance: 'คำนวณระยะทาง',
    calculateDeliveryDistanceDone: 'คำนวณระยะทางสำเร็จ',
    calculateDeliveryDistanceFail: 'คำนวณระยะทางไม่สำเร็จ',
    calculateDeliveryDistancePleaseSelect: 'กรุณาเลือกสัญญาก่อนคำนวณ',
    calculateDeliveryDistancePleaseSelectLocation:
      'กรุณาเลือกต้นทางและโรงงานก่อนคำนวณ',
    calculateFromMap: 'คำนวณจากแผนที่',
    calculateFromMapHint: 'กดคำนวณจากแผนที่ หรือพิมพ์ตัวเลขเอง',
    calculateDeliveryDistanceUpdated: 'อัปเดต',
    fromCalculation: 'จากการคำนวน',
    confirmUnlockAccount: 'ยืนยันปลดล็อกบัญชีนี้?',
    confirmDelete: 'ยืนยันการลบ',
    currentDate: 'วันที่ปัจจุบัน',
    createdAtDateTime: 'วันที่และเวลาสร้าง',
    cancelOrder: 'จำนวนที่ยกเลิก',
    createdDate: 'วันที่สร้าง',
    ownedBy: 'เจ้าของข้อมูล',
    createdBy: 'สร้างโดย',
    cancelRouting: 'ยกเลิกการนำทาง',
    chooseYourRoute: 'เลือกเส้นทางของท่าน',
    chooseRouteType: 'เลือกประเภทเส้นทาง',
    commentList: 'รายการความคิดเห็น',
    comment_text: 'กรอกรายละเอียดเพิ่มเติม',
    carParkedOutsideTheDesignatedArea: 'รถจอดนอกพื้นที่ที่กำหนด',
    concreteMixerFinished: 'คอนกรีตผสมเสร็จ',
    countIncorrectAvg: 'จำนวนครั้งการทำผิดเฉลี่ย/วัน',
    countEvent3: 'ขับรถความเร็วเกิน (พื้นที่ทั่วไป) 60 กม./ชม.',
    countEvent4: 'ขับรถความเร็วเกิน (พื้นที่ทั่วไป) 45 กม./ชม.',
    countEvent5:
      'ขับรถความเร็วเกิน โค้งหักศอก โค้งอันตราย โค้งที่เกิดอุบัติเหตุบ่อยครั้ง 20 กม./ชม.',
    countEvent6: 'ขับรถความเร็วเกิน (พื้นที่ทั่วไป) 30 กม./ชม.',
    countEvent7: 'ขับรถความเร็วเกิน (พื้นที่ทั่วไป) 10 กม./ชม.',
    companyName: 'สังกัดผู้ร่วมธุรกิจรถโม่',
    codejbs: 'รหัสจบส.',
    closeTimeFormat: 'ดับเครื่องยนต์ (วัน-เวลา)',
    count_spee_over_policy: 'ความเร็วเกินนโยบาย (ครั้ง)',
    cement_time: 'ระยะเวลาเทปูน (ชั่วโมง)',
    contractors: 'บริษัทผู้รับเหมา',
    concreteOutsideSpecifiedPoint: 'เทปูนนอกจุดที่กำหนด',
    concreteOutsideSpecifiedPointDetail: 'กรณีมีการเทปูนนอกจุดที่กำหนด',
    concretePointOverlap: 'เทปูนที่จุดคาบเกี่ยว',
    concretePointOverlapDetail:
      'กรณีที่รถเข้าถูกจุดแต่พื้นที่ของจุดนั้นทับซ้อนกับหน่วยงานอื่น',
    chooseList: 'กรุณาเลือกรายการ',
    cements: 'เทปูน',
    calculatedeliveryArea: 'คำนวนพื้นที่จัดส่ง',
    createaNewTicket: 'สร้างตั๋วใหม่',
    canDeliverOutsideTheArea: 'ส่งนอกพื้นที่ได้',
    canChangeDestination: 'เปลี่ยนปลายทางได้',
    cmd: 'cmd',
    chooseMaterialType: 'เลือกประเภทวัตถุดิบ',
    chooseReportType: 'กรุณาเลือกประเภทรายงาน',
    chooseDriverCodePls: 'กรุณาเลือกรหัสคนขับ',
    chooseDriverNamePls: 'กรุณาเลือกชื่อคนขับ',
    chooseBusinessPls: 'กรุณาเลือกกิจการ',
    chooseSitePls: 'กรุณาเลือกหน่วยงาน',
    chooseDatePls: 'กรุณาเลือกวันที่',
    chooseDepartmentPls: 'กรุณาเลือกแผนก',
    chooseSectionPls: 'กรุณาเลือกฝ่าย/ส่วน',
    chooseSitePls: 'กรุณาเลือกกลุ่มไซต์งาน',
    chooseBusiness: 'เลือกกิจการ',
    chooseDepartment: 'เลือกแผนก',
    chooseSection: 'เลือกฝ่าย/ส่วน',
    chooseSite: 'เลือกกลุ่มไซต์งาน',
    confirmToCloseThisItem: 'ยืนยัน การปิดรายการนี้',
    confirmToChangeStatus: 'ยืนยัน การเปลี่ยนสถานะใบงานแจ้งซ่อม',
    callQueue: 'เรียกคิว',
    camera_back: 'กล้องในรถ',
    camera_extra: 'กล้องเสริม',
    camera_position: 'ตำแหน่งกล้อง',
    cancel: 'ยกเลิก',
    cancelAt: 'ยกเลิกเมื่อ',
    cancelled: 'ยกเลิก',
    cancelReason: 'เหตุผลการยกเลิก',
    carNotOnline: 'รถไม่ออนไลน์',
    carService: 'ศูนย์บริการ',
    carTax: 'ภาษีรถยนต์',
    category: 'หมวด',
    cc_email: 'สำเนา',
    certificateNumber: 'หมายเลข คำร้องขอใบรับรอง',
    certificateRequestDate: 'วันที่ขอใบรับรอง',
    changeLanguage: 'เปลี่ยนภาษา',
    changePassword: 'เปลี่ยนรหัสผ่าน',
    changeProduct: 'เปลี่ยนสินค้า',
    channel: 'ช่องทาง',
    chasisSerialNumber: 'หมายเลขตัวถัง',
    chauffeur: 'พนักงานขับขี่',
    chauffeurData: 'ข้อมูลคนขับ',
    chineseKoreanJapanese: 'จีน/ กาหลี/ญี่ปุ่น',
    clear: 'ล้าง',
    clearStatus: 'คืนสถานะ',
    clearUp: 'ล้างค่า',
    clearSearch: 'ล้างค่าการค้นหา',
    close: 'ปิด',
    closed: 'ปิด',
    closeFixed: 'เรียบร้อย-ปิดตั๋ว',
    closeNotAvailable: 'รถไม่พร้อม-ปิดตั๋ว',
    cmd: 'CMD',
    collapse: 'ย่อ',
    collapseExpand: 'ย่อ/ขยาย',
    Color: 'สี',
    comment: 'รายละเอียด',
    communityArea: 'เขตชุมชน',
    company: 'บริษัท',
    company_partner: 'บริษัทผู้ร่วมกิจการ',
    companyBilling: 'บริษัทที่เรียกเก็บเงิน',
    companyCode: 'รหัสบริษัท',
    companyPartner: 'ผู้รับเหมา',
    CompareVehicleSccoReport: 'รายงาน เปรียบเทียบพาหนะ SCCO',
    complete: 'เสร็จเรียบร้อย',
    completeIsupply: 'จัดส่งสำเร็จ',
    complete_date: 'วันที่เสร็จ',
    compulsory: 'ประกันภัยรถยนต์ภาคบังคับ (พ.ร.บ.)',
    concreteDeliveryDashboard: 'การจัดส่งคอนกรีต',
    concreteDeliveryManagerDashboard: 'การจัดส่งคอนกรีต',
    concretePlant: 'โรงงานคอนกรีต',
    configuration: 'ปรับค่า',
    confirm: 'ยืนยัน',
    confirm_appointment_place: 'อาจมีการเปลี่ยนแปลงจังหวัด และอำเภอ',
    confirm_type: 'ยืนยันการส่งโดย',
    confirmNewPassword: 'ยืนยันรหัสผ่านใหม่',
    confirmPassword: 'ยืนยันรหัสผ่าน',
    confirmSendingBy: 'ยืนยันการส่งโดย',
    confirmToUpdateThisItem: 'ยืนยัน การแก้ไขรายการนี้',
    confirmToAddThisItem: 'ยืนยัน ต้องการเพิ่มรายการนี้',
    confirmToCancelThisItem: 'ยืนยัน ต้องการยกเลิกรายการนี้',
    confirmToRemoveThisItem: 'ยืนยัน ต้องการนำรายการออกนี้',
    confirmToCloseStatus: 'ยืนยัน รายการนี้ซ่อมเสร็จเรียบร้อยแล้ว',
    confirmToDeleteThisItem: 'ยืนยัน ต้องการลบรายการนี้',
    confirmToEditThisItem: 'ยืนยัน ต้องการแก้ไขรายการนี้',
    confirmToReceiveStatus: 'ยืนยัน ต้องการรับเรื่องรายการนี้',
    confirmToSendTheseItems: 'ยืนยัน ต้องการส่งรายการเหล่านี้',
    connection: 'เชื่อมต่อสัญญาณ',
    connectionLost: 'ขาดการติดต่อ',
    consignee: 'ผู้รับสินค้า',
    consigneePhone: 'เบอร์โทรศัพท์ผู้รับสินค้า',
    contact: 'ติดต่อ',
    contact_name: 'ชื่อบุคคลติดต่อ',
    contact_telno: 'เบอร์ติดต่อ',
    Contactmanagement: 'เบอร์โทรศัพท์พาหนะ',
    contactName: 'ชื่อบุคคลติดต่อ',
    contactSupportForUserThisMenu:
      'เนื่องจากมีข้อมูลสถานที่เป็นจำนวนมาก กรุณาติดต่อซัพพอร์ทเพื่อใช้งานเมนูนี้',
    contactTelno: 'เบอร์ติดต่อ',
    continuationOfEvents: 'ความต่อเนื่องของเหตุการณ์ (นาที)',
    continuousDrive: 'ทำงานต่อเนื่องได้ไม่เกิน',
    continuousDriveInADay: 'ทำงานต่อเนื่องในหนึ่งวันได้ไม่เกิน',
    continuousDriving: 'ขับรถต่อเนื่อง',
    continuousDrivingLongTime: 'ขับรถต่อเนื่องนาน (ครั้ง)',
    continuousDrivingLongTimeDate: 'ขับรถต่อเนื่องนาน (เวลา)',
    contractor: 'ผู้รับจ้าง',
    contractorName: 'ชื่อ ผรม.',
    contractShippingRate: 'อัตราค่าขนส่งตามสัญญา',
    coordinates: 'พิกัด',
    coordinatesGPS: 'พิกัด GPS',
    copyLink: 'คัดลอกลิงก์',
    couldNotDisplayDirections: 'ไม่สามารถแสดงเส้นทางได้เนื่องจาก: ไม่พบผลลัพธ์',
    courseName: 'ชื่อหลักสูตร',
    cpacPolicy: 'นโยบายความปลอดภัย',
    create_trip: 'สร้างทริป',
    created_by: 'สร้างโดย',
    createdAt: 'สร้างเมื่อ',
    createdBy: 'สร้างโดย',
    createFrimware: 'สร้างเฟิร์มแวร์',
    creator: 'ผู้สร้าง',
    criteria: 'เงื่อนไข',
    criterionAndDeductMarksForTripSuccess:
      'เกณฑ์และการหักคะแนน ด้านความสำเร็จทริป',
    criticality: 'ภาวะวิกฤต',
    criticalLevel: 'ระดับความรุนแรง',
    crossroad: 'ในทางแยก',
    crushingPlant: 'ต้นทาง',
    currentAddress: 'ที่อยู่ปัจจุบัน',
    currentLocation: 'ตำแหน่งปัจจุปัน',
    currentQueue: 'คิวปัจจุบัน',
    currentVehicle: 'พาหนะปัจจุบัน',
    custom: 'ปรับแต่ง',
    customer: 'ลูกค้า',
    customerDetail: 'รายละเอียดลูกค้า',
    customerID: 'Customer ID',
    customerName: 'ชื่อลูกค้า',
    customerType: 'ประเภทลูกค้า',
    cycleOfDrumRotation: ' จำนวนรอบการหมุนของโม่',
    concreteTrip: 'การส่งคอนกรีต',
    confirmed: 'สำเร็จ',
    cement: 'ซีเมนต์',
    changeDestination: 'เปลี่ยนปลายทาง',
    changeOrigin: 'เปลี่ยนต้นทาง',
    changeHistoryOfData: 'ประวัติการเปลี่ยนแปลงข้อมูล',
    changeHistoryOfTheLatestInformation:
      'ประวัติการเปลี่ยนแปลงของข้อมูล ล่าสุด',
    changeHistoryOfTheAllInformation: 'ประวัติการเปลี่ยนแปลงของข้อมูล ทั้งหมด',
    changeHistoryOfPreviousInformation:
      'ประวัติการเปลี่ยนแปลงของข้อมูล ก่อนปัจจุบัน',
    clearTicketStatus: 'เคลียร์สถานะตั๋ว',
    contact_phone: 'เบอร์ติดต่อ/เบอร์พนักงานขับขี่',
    contact_phone_require: 'กรุณากรอกเบอร์ติดต่อ/เบอร์พนักงานขับขี่',
    contact_phone_length_max:
      'กรุณากรอกเบอร์ติดต่อ/เบอร์พนักงานขับขี่ต้องมีความยาวไม่เกิน 15 ตัวอักษร',
    contact_phone_length_min:
      'กรุณากรอกเบอร์ติดต่อ/เบอร์พนักงานขับขี่ต้องมีความยาวไม่ต่ำกว่า 8 ตัวอักษร',
    contact_phone_invalid: 'กรุณากรอกเบอร์ติดต่อ/เบอร์พนักงานขับขี่ให้ถูกต้อง',
    contact_name_require: 'กรุณากรอกชื่อบุคคลติดต่อ',
    contract: 'สัญญา',
    csv: 'CSV',
    changeOriginLocation: 'เปลี่ยนต้นทาง',
    changeDestinationLocation: 'เปลี่ยนสถานที่ปลายทาง',
    contractNumber: 'เลขที่สัญญา',
    contractValidityPeriod: 'ระยะเวลาที่สามารถใช้งานสัญญาได้',
    conditionsForAcceptingWork: 'เงื่อนไขการรับงาน',
    close: 'ปิด',
    conditionsForSubmittingWork: 'เงื่อนไขการส่งงาน',
    changeDestinationByDriver: 'เปลี่ยนปลายทางโดยพนักงานขับขี่',
    condition: 'เงื่อนไข',
    cancelALocationFromAnotherSystem: 'ยกเลิกสถานที่จากระบบอื่น',
    codeComparativeRawMaterials: 'รหัส วัตถุดิบเทียบ',
    closeWork: 'ปิดงาน',
    cdas: 'CDAS',
    codeComparativeRawMaterials: 'รหัสวัตถุดิบเทียบ',
    comparativeRawMaterials: 'วัตถุดิบเทียบ',
    comparativeMaterialsRequired: 'ระบุ วัตถุดิบ',
    countPlantMiningContract: 'จำนวนสัญญาขนส่งวัตถุดิบ',
    countVehicle: 'จำนวนพาหนะ',
    contractStartDate: 'วันที่เริ่มต้นใช้สัญญา',
    contractExpirationDate: 'วันที่สิ้นสุดใช้สัญญา',
    cer: 'ใบ Cer.',
    closeBy: 'ปิดงานโดย',
    confirmWantToCloseThisItem: 'ยืนยัน ต้องการปิดงานรายการนี้',
    cannotFix: 'ไม่สามารถแก้ไขได้',
    code: 'รหัส',
    contractPeriod: 'ระยะเวลาสัญญา',
    contractStatus: 'สถานะสัญญา',
    contractActive: 'คงอยู่',
    contractInactive: 'หมดอายุ',
    cardNumber: 'เลขบัตร',
    cardNoIsRequired: 'ระบุ card no.',
    createBookingOrder: 'สร้างงานจอง',
    confirmationOfBooking: 'ยืนยันการจอง',
    currentJobStatus: 'สถานะงานปัจจุบัน',
    chooseTheDateYouWantToSend: 'เลือกวันที่ต้องการส่ง',
    cancelBooking: 'ยกเลิกการจอง',
    customTime: 'กำหนดเอง',
    calculateRouteBack: 'คำนวณเส้นทางย้อนหลัง',
    carRental: 'รถเช่า',
    changeOriginCalForm:
      'คำนวณจากข้อมูลการเข้าพื้นที่ที่ใกล้กับเวลาขึ้นชั่งมากที่สุด',
    changeHistoryOfStockBalace: 'ประวัติการเปลียนวัตถุดิบคงเหลือ',
    chemicalSolution: 'น้ำยา',
    calculatedFromTheSystem: 'คำนวณจากระบบ',
    cumulativeQuantity: 'ปริมาณสะสม',
    chooseDivision: 'เลือกกิจการ',
    chooseCompany: 'เลือกบริษัท',
    chooseDepartments: 'เลือกฝ่ายส่วน',
    chooseSections: 'เลือกแผนก',
    choosePlants: 'เลือกโรงงาน',
    chooseCompanyPlease: 'กรุณาเลือกบริษัท',
    chooseDivisionPlease: 'กรุณาเลือกกิจการ',
    chooseDepartmentsPlease: 'กรุณาเลือกฝ่ายส่วน',
    chooseSectionsPlease: 'กรุณาเลือกแผนก',
    choosePlantsPlease: 'กรุณาเลือกโรงงาน',
    capacity: 'กำลังผลิต',
    cubicMeter: 'ลบ.ม.',
    confirmReceipt: 'ยืนยันรับ',
    chooseDate: 'เลือกวันที่',
    chooseData: 'เลือกข้อมูล',
    central_operation: 'ศูนย์ทดสอบ',
    calculate: 'คำนวณข้อมูล',
    cu_m_retain: 'เปอร์เซ็นต์ค้างตะแกรงสะสม',
    cu_m_pass: 'เปอร์เซ็นต์ผ่านตะแกรงสะสม',
    contractType: 'ประเภทสัญญา',
    chooseNewOriginLocation: 'เลือกต้นทางใหม่',
    cpacOrgChart: 'CPAC Org Chart',
    compressiveStrength: 'กำลังอัด',
    cumulativeQuantityBackWard: 'ปริมาณสะสม (ประเมินย้อนหลัง)',
    copy: 'สำเนา',
    calculateDailyRawMaterialsRemainingLatestRetrospective:
      'คำนวณวัตถุดิบคงเหลือรายวันย้อนหลัง',
    contractorQuota: 'โควตาผู้ขนส่ง',
    commandCenterDashboard: 'Command center',
    confirmToApplyThisValueToAllItems: 'กดยืนยันเพื่อนำค่านี้ไปใช้กับทุกรายการ',
    companyGroupNo: 'รหัสกลุ่มบริษัท',
    create: 'สร้าง',
    checkedBy: 'ตรวจสอบโดย',
    customLocation: 'ระบุสถานที่เอง',
    clearSiloNo: 'เคลียร์ Silo No.',
    cutOffTime: 'เวลาตัดรอบ',
    closeNow: 'ปิดทันที',
    closeSpecifyDateRange: 'ปิดระบุช่วงวันที่',
    calculationFormula: 'สูตรคำนวณ',
    chlorideTestResult: 'ผลทดสอบคลอไรด์',
    chlorideSand: 'ผลทดสอบคลอไรด์ทราย',
    chlorideSandValue: 'ค่าคลอไรด์ทราย',
    chlorideWater: 'ผลทดสอบคลอไรด์น้ำ',
    chlorideWaterValue: 'ค่าคลอไรด์น้ำ',
    chlorideSetting: 'ตั้งค่าการทดสอบคลอไรด์',
    chlorideMultiplier: 'ตัวคูณคลอไรด์',
    chlorideSandNotRequire: 'ทรายแม่น้ำไม่ต้องทดสอบคลอไรด์',
    chlorideWaterNotRequire: 'น้ำประปาไม่ต้องทดสอบคลอไรด์',
    chlorideECTestSection: 'ทดสอบด้วย EC',
    chlorideSandECResult: 'ทดสอบด้วย EC',
    chlorideWaterECResult: 'ทดสอบด้วย EC',
    chlorideSandStripResult: 'ทดสอบด้วย Strip',
    chlorideWaterStripResult: 'ทดสอบด้วย Strip',
    chlorideResultPass: 'ผ่าน',
    chlorideResultFail: 'ไม่ผ่าน',
    contractCondition: 'เงื่อนไขสัญญา',
    combineLab: 'รวมผลทดสอบคุณภาพ',
    combineQualityTestResultsByRatio: 'รวมผลทดสอบคุณภาพตามอัตราส่วน',
    chooseRatio: 'เลือกอัตราส่วน',
    confirmToSaveThisItem: 'ยืนยัน ต้องการบันทึกรายการนี้',
    combineLabLog: 'ประวัติการรวมผลทดสอบคุณภาพ',
    combineMainSource: 'วัตถุดิบหลัก',
    combineMixSource: 'วัตถุดิบผสม',
    cannotPreview: 'ไม่สามารถแสดงตัวอย่างได้',
    certifyResult: 'อัปโหลดผล',
    certificationDate: 'วันที่รับรองผลทดสอบ',
    chlorideTestResultWithEC: 'ผลทดสอบคลอไรด์ด้วย EC',
    chlorideTestResultWithStrip: 'ผลทดสอบคลอไรด์ด้วย Strip',
    copyToken: 'คัดลอกโทเค็น',
    chlorideComputedValue: 'ผลคำนวณคลอไรด์',
    chlorideSandComputedValue: 'ผลคำนวณคลอไรด์ทราย',
    chlorideWaterComputedValue: 'ผลคำนวณคลอไรด์น้ำ',
    chlorideFailCriteria: 'ไม่ผ่านเกณฑ์',
    chlorideThresholdHint: 'เกณฑ์มาตรฐาน ค่าคลอไรด์ไม่เกิน',
    chlorideComputedResult: 'ผลคำนวณคลอไรด์ (x{multiplier}) คือ {value}',
    contractorInContract: 'ในสัญญา',
    contractorOutOfContract: 'นอกสัญญา',
    chlorideSandCoarse: 'ค่าคลอไรด์ทราย (หยาบ)',
    chlorideWaterCoarse: 'ค่าคลอไรด์น้ำ (หยาบ)',
    chlorideCoarseMoreThan3000: 'มากกว่า 3000',
    chlorideSandFine: 'ค่าคลอไรด์ทราย (ละเอียด)',
    chlorideWaterFine: 'ค่าคลอไรด์น้ำ (ละเอียด)',
    chlorideComputedResultNoMultiplier: 'ผลคำนวณคลอไรด์ (ไม่ได้กำหนดตัวคูณ ใช้ x{multiplier}) คือ {value}',
  },
  d: {
    dataAsOf: 'ข้อมูลเมื่อ {datetime} (ข้อมูลอัปเดตทุก 2 ชั่วโมง)',
    downloadFile: 'ดาวน์โหลดไฟล์',
    dueDate: 'วันครบกำหนด',
    dueDateStatus: 'สถานะวันครบกำหนด',
    dueDateNotDue: 'ยังไม่ครบกำหนด',
    dueDateNearDue3months: 'ใกล้ครบกำหนด (< 3 เดือน)',
    dueDateOverdue: 'เกินกำหนด',
    distanceFromDue: 'ห่าง',
    distance1Month: '1 เดือน',
    distance2Months: '2 เดือน',
    distance3Months: '3 เดือน',
    distance1Year: '1 ปี',
    distance3Years: '3 ปี',
    distanceOverdue: 'เกินกำหนด',
    downloadImgAssessment: 'ดาวน์โหลดรูปประเมินรับสินค้า',
    DoYouWantToTurnOffYesOrNo: 'คุณต้องการปิดใช่หรือไม่',
    DoYouWantToTurnOnYesOrNo: 'คุณต้องการเปิดใช่หรือไม่',
    deliverySuccessfull: 'จัดส่งแล้ว',
    doYouWantToUpdateTheseItems: 'คุณต้องการอัพเดทรายการเหล่านี้หรือไม่',
    desiredQuantity: 'ที่ต้องการ',
    deliveryDate2: 'วันที่จัดส่งสินค้า',
    deliveryDate: 'วันที่จัดส่ง',
    dpNotCounting: 'ไม่นับ DP',
    dpCounting: 'นับ DP',
    direction: 'นำทาง',
    drawSmallTruckRoute: 'วาดเส้นทางโม่เล็ก',
    drawSmallTruckRouteDoNotEnter: 'วาดเส้นทางรถโม่เล็กห้ามเข้า',
    detail: 'รายละเอียด',
    destinationPoint: 'จุดจอดปลายทาง',
    dpNumber: 'หมายเลข DP',
    drivingTime: 'เวลาขับ',
    distance_speed_over_policy: 'ความเร็วเกินนโยบาย (กม.)',
    duration_speed_over_policy: 'ความเร็วเกินนโยบาย (นาที)',
    diffTime: 'ระยะเวลา (ชั่วโมง:นาที)',
    distanceOnSite: 'ระยะทางในไซต์',
    distanceDifferenceKm: 'ผลต่างระยะทาง (กม.) User/GPS',
    distance_return_plant: 'ระยะทางขากลับแพลนต์ (กิโลเมตร) (คำนวณสิ้นวัน)',
    distance_from_plant_to_Site:
      'ระยะทางจากแพลนต์ถึงไซต์งาน (กิโลเมตร) (คำนวณสิ้นวัน)',
    day_in_month: 'จำนวนวันทำงานทั้งหมด',
    document_number: 'เลขที่เอกสารแจ้งซ่อม',
    diff_date: 'รวมเวลาแก้ไข (วัน:ชั่วโมง)',
    disconnected_total: 'รวมเวลาขาดการติดต่อ (นาที)',
    disconnected_begin: 'เวลาเริ่มขาดการติดต่อ',
    disconnected_end: 'เวลาสิ้นสุดการขาดการติดต่อ',
    durationDisconnected: 'ระยะเวลาที่ขาดการติดต่อ',
    dpReleaseDate: 'วันที่ออกดีพี',
    downloadTemplate: 'โหลดเทมเพลต',
    drivingSafety: 'ความปลอดภัยในการขับขี่',
    drivingDetail: 'รายละเอียดการขับขี่',
    deleteRoute: 'ลบเส้นทาง',
    departure: 'ออกจากแพลนต์',
    datetimeloadingcement: 'วัน/เวลาที่โหลดปูน',
    dashbordmatterial: 'แดชบอร์ดวัตถุดิบคงเหลือ',
    dashboarddelivery: 'แดชบอร์ดการจัดส่ง',
    defaultfilter: 'ค่ากรองตั้งต้น',
    department: 'ฝ่ายส่วน',
    department_code: 'รหัสฝ่ายส่วน',
    department_truckincorrectpoint: 'แผนก',
    departmentPart: 'ฝ่าย/ส่วน',
    division: 'กิจการ',
    division_code: 'รหัสกิจการ',
    distancereport: 'ระยะทางการจัดส่งคอนกรีต',
    details: 'รายละเอียด',
    drivinglog: 'บันทึกการขับขี่',
    distanceByPoint: 'ระยะทางจุดต่อจุด',
    driverKpiDashboard: 'สรุปการใช้พาหนะ',
    driverName: 'ชื่อคนขับ',
    daily: 'รายวัน',
    DailyAlarmAndAlertReportByDriver:
      'Alert และ Alarm แยกตามพนักงานขับขี่รายวัน',
    dailyCarStatusReport: 'สรุปสถานะพาหนะรายวัน',
    dailyDrivingBehaviorReport: 'พฤติกรรมการขับขี่รายวัน',
    DailyiconsiamReport: 'การให้บริการเรือ / รถ แบบรายวัน',
    DailyReport: 'สรุปการวิ่งประจำวัน',
    dangerous: 'อันตราย',
    dashboard: 'แดชบอร์ด',
    dashCamera: 'ระบบเฝ้าดูผ่านแดชแคม',
    data: 'ข้อมูล',
    dataForDLT: 'Data For DLT',
    dataSource: 'แหล่งที่มาของข้อมูล',
    dataType: 'ชนิดข้อมูล',
    dataVisibility: 'การมองเห็นข้อมูล',
    date: 'วันที่',
    dateIsRequired: 'กรุณาระบุ วันที่',
    date_entry: 'วันที่เข้า',
    date_out: 'วันที่ออก',
    date_time: 'วันที่และเวลา',
    date_time_entry: 'วันที่-เวลาเข้า',
    date_time_out: 'วันที่-เวลาออก',
    dateEnd: 'วันที่สิ้นสุด',
    dateOfBirth: 'วันเกิด',
    dateofRawMaterialRequirement: 'วันที่ต้องการวัตถุดิบ',
    dateOfSubmission: 'วันที่ยื่นคำขอ',
    dateRange: 'ช่วงวันที่',
    dateRangeMode: 'แบบช่วงวันที่',
    dateRangeNotBeMoreThan31Days: 'ช่วงวันที่ที่เลือกไม่ควรมากกว่า 31 วัน',
    dateRangeNotBeMoreThan3Days: 'ช่วงวันที่ที่เลือกต้องไม่เกิน 3 วัน',
    dateStart: 'วันที่เริ่มต้น',
    dateSubmit: 'วันที่ส่งเอกสาร',
    dateTime: 'วัน/เวลา',
    day: 'วัน',
    daYouWantToReActive: 'คุณต้องการที่จะเปิดใช้งานอีกครั้งหรือไม่',
    daYouWantToReTicketStatus: 'คุณต้องการที่จะเคลียร์สถานะตั๋วหรือไม่',
    daysBeforeNotification: 'จำนวนวันก่อนแจ้งเตือน',
    dayTime: 'ช่วงเวลากลางวัน',
    ddHhMm: '(วัน:ชม:นาที)',
    deduct: 'หัก',
    default: 'ค่าเริ่มต้น',
    defaultImageBylocationType: 'รูปค่าเริ่มต้น ตามชนิดสถานที่',
    defaultLang: 'Default lang',
    defaultLatitude: 'Default latitude',
    defaultLongitude: 'Default longitude',
    delete: 'ลบ',
    deleteFail: 'ลบข้อมูลไม่สำเร็จ',
    destinationIsupply: 'จัดส่งที่ปลายทาง',
    deletedAt: 'ลบข้อมูลเมื่อ',
    deletedBy: 'ลบข้อมูลโคย',
    deleteInformation: 'ลบข้อมูล',
    deleteReason: 'เหตุผลการลบ',
    deliver: 'การจัดส่ง',
    deliver_duration: 'เวลาเริ่ม - เวลาสิ้นสุด',
    deliver_status: 'สถานะส่งของ',
    deliveryStatusIsupply: 'สถานะการจัดส่ง',
    Delivered: 'ส่งของแล้ว',
    deliverPoint: 'จุดส่งของ',
    delivery: 'จัดส่ง',
    deliveryAddress: 'ที่อยู่สำหรับการจัดส่ง',
    deliveryAvailable: 'กำลังเข้าโรงงาน',
    deliveryBillNo: 'เลขที่ใบส่งของ',
    deliveryContractWasNotFound: 'ไม่พบสัญญาการจัดส่งวัตถุดิบในระบบ',
    dashboardDeliveryDashboard: 'แดชบอร์ดการขนส่งวัตถุดิบ',
    deliveryDashboard: 'การขนส่งวัตถุดิบ',
    deliveryDistance: 'วิ่งงาน',
    deliveryItem: 'การส่งอุปกรณ์',
    deliveryItemDeleteHistoryPool: 'ประวัติงานส่งอุปกรณ์ (EZY GPS)',
    deliveryItemPool: 'งานส่งอุปกรณ์ (EZY GPS)',
    deliveryOutsideTheArea: 'ส่งนอกพื้นที่',
    deliveryPoint: 'จุดส่งของ',
    deliveryReport: 'การขนส่งวัตถุดิบ',
    DeliveryReport: 'การส่งสินค้า',
    deliveryStatus: 'สถานะการจัดส่ง',
    deliverySuccess: 'ส่งเรียบร้อยแล้ว',
    deliveryLocation: 'ตำแหน่งส่งของ',
    discontinuedVehiclesShouldNotExceed: 'พาหนะที่เลิกไม่ควรเกิน ',
    deliverytrip: 'ทริปการส่งของ',
    descrip: 'รายละเอียด',
    description: 'รายละเอียด',
    destination: 'จุดหมาย',
    destinationDetail: 'รายละเอียดจุดหมาย',
    destinationLocation: 'สถานที่ปลายทาง',
    destinationLocation_duplicate_require: 'สถานที่ปลายทางนี้มีในทริปนี้แล้ว',
    destinationLocation_require: 'กรุณากรอกสถานที่ปลายทาง',
    destinationLocationcode: 'รหัสสถานที่ปลายทาง',
    detail: 'รายละเอียด',
    detail_problem: 'อาการของปัญหา(อื่นๆ โปรดระบุ)',
    detailOfConcreteTruck: 'รายละเอียดสำหรับรถบรรทุกคอนกรีต',
    detailproblem: 'วิธีการแก้ไข',
    detailProblemServiceMoveDevice: 'อาการของปัญหาที่ได้รับแจ้ง',
    device: 'อุปกรณ์',
    deviceName: 'ชื่ออุปกรณ์',
    devicePhone: 'เบอร์โทรกล่อง',
    deviceType: 'ประเภทอปกรณ์',
    diff: 'Diff',
    dischargeDenominator: 'ค่าคำนวณปริมาณในการเท',
    disconnected: 'ขาดการติดต่อ',
    displayTime: 'เวลาการแสดงผล',
    distance: 'ระยะทาง',
    distance_less_than: 'ระยะทางน้อยกว่า',
    distance_more_than: 'ระยะทางที่ถือว่าทำงานต่อวัน (กม.)',
    distanceWithKm: 'ระยะทาง (กิโลเมตร)',
    DistfromlastmaintenanceReport: 'พาหนะที่มีระยะทางวิ่งสะสมล่าสุด',
    doc_no: 'เลขเอกสาร',
    document: 'เอกสาร',
    done: 'เสร็จสิ้น',
    doNotInstall: 'ยังไม่ติดตั้ง',
    doNotParkBesideTheRoad: 'ห้ามจอดไหล่ทาง',
    doNotSwipeCardsOrDamageCards: 'ไม่รูดบัตรหรือบัตรเสียหายหนัก',
    doNumber: 'Do Number',
    download: 'ดาวน์โหลด',
    downloadcertificate: 'ดาวน์โหลดใบรับรอง',
    downloadSampleFiles: 'ดาวน์โหลดไฟล์ตัวอย่าง',
    doYouNeedToRebootTheseItems: 'คุณต้องการรีบูตรายการเหล่านี้หรือไม่',
    doYouWantToAddTheseItems: 'คุณต้องการเพิ่มรายการเหล่านี้หรือไม่',
    doYouWantToCancel: 'คุณต้องการยกเลิกหรือไม่',
    doYouWantToConfirmSend: 'คุณต้องการยืนยันการส่งหรือไม่',
    doYouWantToDeleteTheseItems: 'คุณต้องการลบรายการเหล่านี้หรือไม่',
    doYouWantToEditTheseItems: 'คุณต้องการแก้ไขรายการเหล่านี้หรือไม่',
    doYouWanttoReActive: 'คุณต้องการที่จะเปิดใช้งานอีกครั้งหรือไม่',
    doYouWantToSendAnEmailToUsersToVerifyTheirIdentity:
      'คุณต้องการส่งอีเมลไปยังผู้ใช้งานเพื่อยืนยันตัวตนหรือไม่',
    DozeoffriskReport: 'เสี่ยงหลับใน',
    draft: 'ดราฟต์',
    draw: 'วาด',
    driveContinuouslyForMoreThan10HoursDay: 'ปฏิบัติงาน > 10 ชม./วัน',
    driveContinuouslyForMoreThan4Hours: 'ขับต่อเนื่อง > 4 ชม.',
    driveContinuouslyForMoreThan4HourWithoutRestingFor30Minute:
      'ขับต่อเนื่องเกิน 4 ชั่วโมงโดยไม่พัก 30 นาที',
    driveMoreThanTheSpeedLimitInTheBend:
      'ขับรถเกินความเร็วที่กำหนดในทางโค้งทั่วไป',
    driveOverTheSpeedLimitForDangerousCurves:
      'ขับรถเกินความเร็วที่กำหนดในทางโค้งอันตราย',
    driveOverTheSpeedLimitInTheCrossroads: 'ขับขี่ความเร็วเกินกำหนด ในทางแยก',
    driver: 'พนักงานขับขี่',
    driverTracking: 'คนขับขี่',
    driver1: 'พนักงานขับขี่ 1',
    driver2: 'พนักงานขับขี่ 2',
    driverBlacklist: 'พนักงานห้ามเข้าพื้นที่',
    driverCode: 'รหัสพนักงานขับขี่',
    driverHistory: 'ประวัติพนักงานขับขี่',
    DriverinformationReport: 'ข้อมูลพนักงานขับขี่',
    driverNameJBS: 'ชื่อ-นามสกุลจบส.',
    driverName: 'ชื่อพนักงานขับขี่',
    driverPhoneNumber: 'เบอร์โทรพนักงานขับขี่',
    driveTooFastInTheCommunity: 'ขับเร็วเกินกำหนด ในเขตชุมชน',
    driveTooFastInTheNormalRoute: 'ขับขี่เร็วเกินกำหนด ในเส้นทางปกติ',
    driving: 'ขับพาหนะ',
    drivingLogDescription:
      'ค่าน้ำมันที่แสดงมาจากการตั้งค่าเบื้องต้นของระบบหากต้องการความแม่นยำรบกวนแจ้ง',
    drivingLogDescription1: '1.ความจุถัง',
    drivingLogDescription2: '2.วันที่เติมน้ำมันเต็มถัง',
    drivingLogDescription3:
      '3.จำนวนลิตรที่เติมกับผู้ให้บริการเพื่อทำการตั้งค่าน้ำมันใหม่',
    DrivingdistanceReport: 'สรุประยะทางการวิ่งประจำวัน',
    DrivinghourReport: 'พฤติกรรมการขับขี่',
    drivingIiceneType: 'ประเภทใบขับขี่',
    drivingIicenseNumber: 'หมายเลขใบขับขี่',
    drivinglicense: 'ใบอนุญาตขับขี่',
    drivingLicenseNumberMustBeNumber: 'หมายเลขใบขับขี่ต้องเป็นตัวเลข',
    DrivinglicensescanlogReport: 'การรูดใบขับขี่',
    DrivingNamelicensescanlogReport: 'ชื่อจากการรูดใบขับขี่',
    DrivingAddresslicensescanlogReport: 'สถานที่รูดใบขับขี่',
    DrivinglogReport: 'บันทึกการขับขี่',
    DrivinglogReport2: 'บันทึกการขับขี่ 2',
    DrivinglogspecialReport: 'บันทึกการขับขี่ (ใหม่)',
    drivingOver10HrsDay: 'ขับรถนานเกิน 10 ชม./วัน',
    drivingOver4Hrs: 'ขับรถนานเกิน 4 ชม.',
    DrivingoverlimitReport: 'พาหนะวิ่งงานเกินเวลาที่กำหนด',
    drivingOverSpeedLimitInNormalRoute:
      'ขับรถเกินความเร็วที่กำหนดในเส้นทางทั่วไป',
    drivingOverSpeedLimitInUrbanArea: 'ขับรถเกินความเร็วที่กำหนดในเขตชุมชน',
    drivingPeriodRange: 'ช่วงระยะเวลาการขับขี่(นาที)',
    drivingTime: 'เวลาการขับขี่',
    drumCapacity: 'ความจุโม่',
    duration: 'ระยะเวลา',
    duration_time: 'ช่วงเวลาของข้อมูล',
    durationOfPTOGate1On: ' ระยะเวลาเปิด PTO/ประตู1',
    duringDelivery: 'ระหว่างการจัดส่ง',
    mdvrdownloadfile: 'ดาวน์โหลดวิดีโอย้อนหลัง MDVR',
    drivingSummary: 'ภาพรวมสรุปการขับขี่รายคัน',
    duration_repair: 'ระยะเวลาการแจ้งซ่อม',
    drumRpm: 'ความเร็วโม่',
    dataTimeGR: 'วันที่เวลา GR',
    dashboard: 'แดชบอร์ด',
    doYouWantToChangeVehicleStatus: 'คุณต้องการจะเปลี่ยนสถานะพาหนะใช่หรือไม่?',
    driverPhone: 'เบอร์โทรศัพท์',
    dispatch_name: 'ชื่อ Dispatch',
    dispatch_code: 'รหัส Dispatch',
    dispatch_name_code: 'รหัส/ชื่อ Dispatch',
    duplicateRawMaterialCode: 'รหัสวัตถุดิบซ้ำกัน',
    deleteSuccess: 'ลบข้อมูลสำเร็จ',
    dontBookAnAppointment: 'ไม่ต้องจองคิว',
    deliveryBeyondTheSpecifiedTime: 'จัดส่งเกินเวลาที่กำหนด',
    destinationChangeStatus: 'สถานะการเปลี่ยนปลายทาง',
    deliveredInThePickupArea: 'ส่งในจุดรับสินค้าเท่านั้น',
    donArrangeACar: 'ไม่จัดรถ',
    duplicateRawMaterialAndSourceCode: 'รหัสวัตถุดิบและต้นทางซ้ำกัน',
    district: 'อำเภอ',
    doYouWantToChangeBookingOrderStatus:
      'คุณต้องการเปลี่ยนสถานะใบงานจองใช่หรือไม่?',
    doYouWantToCancelBookingOrder: 'คุณต้องการยกเลิกใบงานจองใช่หรือไม่?',
    destinationView: 'มุมมองปลายทาง',
    dataNotFound: 'ไม่พบข้อมูล',
    descending: 'มากไปน้อย',
    doNotAccept: 'ไม่ยืนยันรับ',
    destinationQualityEvaluation: 'ประเมินคุณภาพ (ปลายทาง)',
    destinationWeightTotal: 'น้ำหนักปลายทาง',
    deliverTime: 'เวลาที่ต้องการสินค้า',
    deliverDate: 'วันที่สั่ง',
    deletingWorksheetWillOnlyBeEffectiveOnTheISupplySystem:
      'การลบใบงาน จะมีผลเฉพาะบนระบบ iSupply เท่านั้น',
    dustPercentage: '% ฝุ่น',
    dustPercentageQuickTest: '% ฝุ่น (Quick test)',
    deliveryTicketInShippingTicket: 'ตั๋วรถลงเรือ',
    dailyStock: 'วัตถุดิบคงเหลือรายวัน',
    doYouWantToDeleteThisItem: 'คุณต้องการลบรายการนี้หรือไม่',
    doYouWantToRemoveThisItem: 'คุณต้องการนำรายการนี้ออกหรือไม่',
    doYouWantToCopyTheseItems: 'คุณต้องการสำเนารายการนี้หรือไม่',
    deliveryDateTime: 'วันที่เวลาส่งของ',
    deliveryTime2: 'เวลาส่งสินค้า',
    deliveryTime: 'เวลาส่งของ',
    doYouWantToApplyThisValueToAllItems:
      'คุณต้องการนำค่านี้ไปใช้กับทุกรายการหรือไม่',
    destinationWeightGreaterThan0: 'น้ำหนักปลายทางมากกว่า 0',
    documentNo: 'เลขที่เอกสาร',
    detailSendMorningStockToBluenet: 'รายละเอียดการส่งยอดเคาะเช้าไป Bluenet',
    duplicateData: 'ข้อมูลซ้ำ',
    deleteThisTicketHasBeenCreatedOnAnotherSystem:
      'ใบงานนี้ถูกนำไปสร้างบนระบบอื่นแล้ว',
    deliverStatus: 'สถานะจัดส่ง',
    deliveryDateFallsOnTheCarrierIsHoliday:
      'วันที่ต้องการวัตถุดิบตรงกับวันหยุดของผู้ขนส่ง',
    deliveryCutoffDate: 'วันตัดรอบจัดส่งสินค้า',
    deleteAt: 'ลบตั๋วเมื่อ',
    deleteBy: 'ลบตั๋วโดย',
    dynamicSidebar: 'ปรับแต่งเมนู',
    doYouWantToSaveThisItem: 'คุณต้องการบันทึกรายการนี้หรือไม่',
    dustPercentageThresholdHint: 'เกณฑ์มาตรฐาน % ฝุ่น ไม่เกิน',
  },
  dashboard_summary: {
    close: 'ดับเครื่อง',
    date: 'วันที่',
    distance: 'ระยะทางรวม',
    enginePanel: 'การใช้ประโยชน์รถ',
    fuelAvgPanel: 'อัตราการใช้น้ำมันเฉลี่ย',
    fuelAvgPanelUsage: 'อัตราการใช้น้ำมัน (กิโลเมตร/ลิตร)',
    fuelSummary: 'ปริมาณการใช้น้ำมันรวม',
    fuelToBath: 'คิดเป็นเงิน (B10)',
    fuelUse: 'น้ำมันใช้ไป',
    hours: 'ชม.',
    lite: 'ลิตร',
    lost: 'ไม่ส่งข้อมูล',
    maxSpeed: 'ความเร็วสูงสุด',
    minute: 'นาที',
    hour: 'ชั่วโมง',
    parking: 'จอดไม่ดับเครื่อง',
    parkingPanel: 'จอดไม่ดับเครื่องรวม',
    pick_date: 'กรุณาเลือกช่วงวัน',
    point: 'คะแนน',
    rangeAvg: 'ค่าเฉลี่ยของช่วงเวลาที่เลือก',
    safetyPanel: 'สรุปการขับขี่แบบปลอดภัย',
    savePanel: 'สรุปการขับขี่แบบประหยัด',
    speedOver: 'ความเร็วเกิน(รวม)',
    speedPanel: 'ความเร็วเกินค่าปลอดภัย',
    start: 'วิ่ง',
    title: 'สรุป ณ วันที่',
    to: 'ถึง',
    unit: 'คัน',
  },
  e: {
    empty: 'ว่างเปล่า',
    editedBy: 'แก้ไขโดย',
    editTable: 'แก้ไขตาราง',
    exampleData: 'ตัวอย่างข้อมูล',
    exampleForData: 'แสดงตัวอย่างข้อมูล',
    editRoute: 'แก้ไขเส้นทาง',
    earning: 'Earning',
    earningOverview: 'ภาพรวมรายได้',
    EarningReceivedSTATISTICS: 'Earning/Received STATISTICS',
    earningType: 'Earning Type',
    edit: 'แก้ไข',
    editPassword: 'แก้ไขรหัสผ่าน',
    editProfile: 'แก้ไขโปรไฟล์',
    editStatus: 'สถานะ',
    efficiency_report_menu: 'ประสิทธิภาพ',
    email: 'อีเมล',
    email_invalid: 'อีเมลที่กรอกไม่ถูกต้อง',
    email_require: 'กรุณากรอกอีเมล',
    email_subject: 'หัวข้ออีเมล',
    email_subject_require: 'กรุณากรอกหัวข้ออีเมล',
    emailAE: 'อีเมล์ AE',
    emailIsInvalid: ' อีเมลไม่ถูกต้อง',
    emailVerification: 'การยืนยันอีเมล',
    emailVerificationStatus: 'สถานะการยืนยันอีเมล',
    emailVerificationSuccessful: 'ยืนยันอีเมลแล้ว',
    emergencyCase: 'กรณีฉุกเฉิน',
    emergencyStatus: 'สถานะฉุกเฉิน',
    employeeID: 'รหัสพนักงาน',
    employeeInformation: 'ข้อมูลพนักงาน',
    employee: 'พนักงาน',
    endAt: 'เวลาสิ้นสุด',
    endDate: 'วันสิ้นสุด',
    endDestinationCode: 'รหัสปลายทาง',
    endDestinationName: 'ชื่อปลายทาง',
    endLocationCode: 'รหัสปลายทาง',
    endLocationName: 'ชื่อปลายทาง',
    endValidDate: 'วันที่สิ้นสุดการใช้พาหนะ',
    energy_report_menu: 'พลังงาน',
    engine: 'เครื่องยนต์',
    engine_off_time_end_at: 'เวลาดับเครื่องสิ้นสุด',
    engine_off_time_start_at: 'เวลาดับเครื่องเริ่มต้น',
    engine_on_time_end_at: 'เวลาติดเครื่องสิ้นสุด',
    engine_on_time_start_at: 'เวลาติดเครื่องเริ่มต้น',
    engineOff: 'ดับเครื่อง',
    engineOffDesc: 'ตำแหน่งที่ส่งข้อมูล GPS ขณะดับเครื่อง',
    engineOn: 'ติดเครื่อง',
    engineOnCombine: 'ติดเครื่อง',
    engineOnDesc: 'ตำแหน่งที่ส่งข้อมูล GPS ขณะติดเครื่อง',
    engineOnDuration: 'ระยะเวลาติดเครื่องยนต์',
    engineOnWithImg: 'ติดเครื่องพร้อมข้อมูลรูปภาพ',
    engineOnWithImgDesc:
      'ตำแหน่งที่ส่งข้อมูล GPS พร้อมรูปภาพจาก Dash camera ขณะติดเครื่อง',
    engineStatus: 'สถานะเครื่องยนต์',
    estFare: 'ค่าโดยสาร',
    estimatedDeliveryTime: 'เวลาจัดส่งโดยประมาณ',
    estTransitDistance: 'ระยะทางการเดินทาง',
    estTransitDuration: 'ระยะเวลาการเดินทาง',
    etc: 'อื่นๆ',
    europeAmerican: 'ยุโรป/อเมริกัน',
    event: 'เหตุการณ์',
    eventAlarm: 'Event Alarm',
    eventEnd: 'จบเหตุการณ์',
    eventMap: 'ภาพรวมพิกัดการฝ่าฝืน',
    EventReport: 'เหตุการณ์พาหนะรายคัน',
    excel: 'Excel',
    expand: 'ขยาย',
    expense: 'ค่าใช้จ่าย',
    expenseBaht: 'ค่าใช้จ่าย (บาท)',
    expireDate: 'วันที่หมดอายุ',
    expiryDate: 'วันหมดอายุ',
    export: 'ส่งออกข้อมูล',
    export_date_at: 'วันที่ออก',
    extra: 'เพิ่มเติม',
    getVehicles: 'แสดงพาหนะ',
    SafetyEventReport: 'ความปลอดภัยพาหนะ',
    enterEmailToReceiveCredentials: 'ระบุ email เพื่อรับหนังสือรับรอง',
    exportUpTo50000RowsAtaTime: 'Export ได้สูงสุดครั้งละ 50000 rows',
    editItemsOnly: 'แก้ไขข้อมูลเท่านั้น',
    end: 'สิ้นสุด',
    emptyCar: 'รถว่าง',
    endTime: 'เวลาสิ้นสุด',
    excessExpenses: 'ค่าบริการส่วนเกิน',
    excessExpenseForm: 'แบบฟอร์มค่าบริการส่วนเกิน',
    excessExpenseFormAlreadyInTheSystem:
      'แบบฟอร์มค่าบริการส่วนเกิน มีอยู่แล้วในระบบ',
    examiner: 'ผู้ตรวจสอบ',
    estTodayEndingStock: 'Est. Today ending stock',
    errorItems: 'รายการที่ผิดพลาด',
    evening: 'เย็น',
    editLocation: 'แก้ไขสถานที่',
    enable: 'เปิดใช้งาน',
    enterAccountToGenerateToken: 'ป้อนบัญชีเพื่อสร้างโทเค็น',
    expiredAt: 'หมดอายุเมื่อ',
  },
  event: {
    eventSetting: 'ตั้งค่าเหตุการณ์',
    acc: 'ความเร่งผิดปกติ',
    approaching_point: 'ใกล้ถึงจุดหมาย',
    approaching_point_but_late: 'รถใกล้ถึงแต่สาย',
    arrival_but_late_departure: 'รถอยู่ที่หมายแต่จะออกจากจุดสาย',
    arrival_point: 'รถอยู่ที่หมาย',
    blackbox_restart: 'กล่องรีสตาท',
    boom_ready: 'ยกบูม',
    discharge_concrete: 'หมุนเทปูน',
    driver_rest_lower_than_10_hours: 'Driver rest lower than 10 hours',
    engineoff: 'ดับเครื่องยนต์',
    engineon: 'ติดเครื่องยนต์',
    fuel_anomaly: 'ปริมาณน้ำมันผิดปกติ',
    hard_brake: 'เบรคแรง',
    hard_turn: 'เข้าโค้งแรง',
    high_beam_off: 'ปิดไฟสูง',
    high_beam_on: 'เปิดไฟสูง',
    high_rpm: 'รอบเครื่องสูงเกินกำหนด',
    hit_the_brake: 'เหยียบเบรค',
    honk: 'บีบแตร',
    into_and_out_of_specific_areas: 'เข้าออกพื้นที่เฉพาะ',
    late: 'ถึงจุดหมายสาย',
    long_idle_time: 'ติดเครื่องอยู่กับที่',
    low_beam_off: 'ปิดไฟต่ำ',
    low_beam_on: 'เปิดไฟต่ำ',
    low_speed_more_than_10_minute: 'วิ่งความเร็วต่ำต่อเนื่องมากกว่า 10 นาที',
    mixing_concrete: 'หมุนโหลดปูน',
    move_in_point_late: 'Move in point late',
    move_out_load_point_with_out_ticket: 'ออกจากแพล้นโดยไม่มีตั๋ว',
    move_out_point_late: 'Move out point late',
    off_route: 'ออกนอกเส้นทาง',
    open_door: 'เปิดตู้',
    open_door_outside_point: 'เปิดตู้นอกจุดส่ง',
    over_driving_hour_limit: 'วิ่งต่อเนื่องเกินกำหนด',
    poweroff: 'ปิดเครื่องส่งสัญญาณ',
    poweron: 'เปิดเครื่องส่งสัญญาณ',
    pto_off: 'ปิด PTO',
    pto_on: 'เปิด PTO',
    pump_on: 'เปิดปั๊ม',
    refuel: 'เติมน้ำมัน',
    refuel_full: 'เติมน้ำมันเต็มถัง',
    refuel_not_full: 'เติมน้ำมันไม่เต็มถัง',
    release_the_brake: 'หยุดเหยียบเบรค',
    reversing_light_off: 'ปิดไฟถอยหลัง',
    reversing_light_on: 'เปิดไฟถอยหลัง',
    shock: 'สะเทือน',
    speed_anomaly: 'ความเร็วผิดปกติ',
    stop_honk: 'หยุดบีบแตร',
    stop_in_area: 'จอดรถในพื้นที่ที่กำหนด',
    stop_mixing_concrete: 'โม่หยุดหมุน',
    summary_idle_limit: 'สรุปรถติดเครื่องอยู่กับที่',
    summary_low_speed_more_than_10_minute:
      'สรุปวิ่งความเร็วต่ำต่อเนื่องมากกว่า 10 นาที',
    summary_over_driving_hour_limit: 'สรุปวิ่งต่อเนื่องเกินกำหนด',
    temperature_anomaly: 'อุณภูมิผิดปกติ',
    truck_stay_in_plant_more_than_limit: 'Truck stay in plant more than limit',
    turn_signal_off: 'ปิดไฟเลี้ยว',
    turn_signal_on: 'เปิดไฟเลี้ยว',
    unauthorized_discharge: 'เทปูนนอกไซต์งาน',
    windshield_wipers_off: 'ปิดที่ปัดน้ำฝน',
    windshield_wipers_on: 'เปิดที่ปัดน้ำฝน',
    work_longer_than_the_time_limit: 'Work longer than the time limit',
    working_distance_less_than_the_rule: 'Working distance less than the rule',
    working_over_limit: 'Working over limit',
    working_within_a_given_period: 'Working within a given period',
  },
  f: {
    failedLoginCount: 'จำนวนครั้งที่ใส่รหัสผ่านผิด',
    fetchDataFailed: 'ดึงข้อมูลล้มเหลว',
    fillYourNote: 'ระบุหมายเหตุของท่าน',
    filterIcons: 'ฟิลเตอร์ไอคอน',
    fast: 'เร็ว',
    freeChoice: 'ค้นหาอิสระ',
    findTheDesiredLocation: 'ค้นหาตำแหน่งที่ต้องการ',
    fillLatLng: 'กรุณากรอก: ละติจูด, ลองจิจูด',
    finished: 'เสร็จแล้ว',
    findCarThisArea: 'ค้นหารถบริเวณนี้',
    filterNode: 'กรอง Node',
    frequency: 'ความถี่',
    fullname: 'ชื่อ-นามสกุล',
    fleetName: 'ชื่อฟลีท',
    finish_date: 'วันเวลาที่ปิดเคส',
    finishedPouring: 'เทเสร็จ',
    finishedPouringConcreteDashboard: 'เทเสร็จสิ้นแล้ว',
    filterthelastdepartment: 'ใช้ค่ากรองฝ่ายส่วนครั้งล่าสุด',
    filterlatest: 'ใช้ค่ากรองครั้งล่าสุด',
    factory: 'โรงงาน',
    factoryCode: 'รหัสโรงงาน',
    favoriteMenu: 'เมนูที่ชื่นชอบ',
    facilityName: 'ชื่อสถานที่',
    facilityName2: 'ชื่อสถานที่2',
    facilityName3: 'ชื่อสถานที่3',
    fail: 'ไม่สำเร็จ',
    fare: 'ค่าโดยสาร',
    file: 'ไฟล์',
    file_location: 'สถานที่เก็บไฟล์',
    file_size: 'ขนาดไฟล์',
    fileapetition: 'ยื่นคำร้อง',
    fileMustSmallerThan2MB: 'ไฟล์ต้องมีขนาดเล็กกว่า 2MB!',
    filenotreadydownload: 'ไม่สามารถดาวน์โหลดไฟล์ได้ในขณะนี้',
    fillInfomation: 'กรอกข้อมูล',
    fillInForm: ' เติมข้อมูลลงในฟอร์ม',
    fillInFrom: 'Fill In From',
    fillPosition: 'ป้อนตำแหน่ง',
    filter: 'ค้นหา',
    filter_by: 'ค้นหาข้อมูลโดย',
    filter_type: 'รูปแบบ',
    filter_type1: 'ออกจากโรงงานครั้งแรกถึงเข้าโรงงานครั้งสุดท้าย',
    filter_type2: 'ติดเครื่องครั้งแรกถึงดับเครื่องครั้งสุดท้าย',
    findCustomer: 'ค้นหาลูกค้า',
    findDistance: 'หาระยะทาง',
    findRoute: 'หาเส้นทาง',
    findSpace: 'หาพื้นที่',
    fine: 'ปรับ',
    finish: 'เสร็จสิ้น',
    finished: 'เสร็จสิ้น',
    finishRefuel: 'จบการเติมเชื้อเพลิง',
    firmware: 'เฟิร์มแวร์',
    firmwareNumber: 'เลขเฟิร์มแวร์',
    firmwareVersion: 'เวอร์ชันเฟิร์มแวร์',
    first_dest: 'จุดเริ่มต้น',
    firstMaintenanceConditions: 'เงื่อนไขการซ่อมบำรุงครั้งแรก',
    firstName: 'ชื่อ',
    firstNameisCharacters: 'ชื่อต้องเป็นตัวอักษร',
    fixed: 'ซ่อม',
    flateNumber: 'Flate Number',
    flatRate: 'เหมา',
    floor: 'พื้น',
    forceUpdate: 'บังคับอัปเดต',
    forgot_password: 'ลืมรหัสผ่าน',
    from: 'จาก',
    front: 'กล้องนอกรถ',
    fuel: 'เชื้อเพลิง',
    fuelA: 'Fuel A',
    fuelB: 'Fuel B',
    fuelC: 'Fuel C',
    fuelFull: 'น้ำมันเต็มถัง',
    fuelRate: 'น้ำมันคงเหลือ (ลิตร)',
    fuelremainrateReport: 'น้ำมันคงเหลือ',
    fuelTankSize: 'ความจุถังเชื้อเพลิง',
    fuelType: 'ประเภทเชื้อเพลิง',
    fuelUsage: 'อัตราสิ้นเปลืองเชื้อเพลิง',
    fullScreen: 'ขยายเต็มจอ',
    Fullscreen: ' ขยายเต็มจอ',
    fullScreenExit: 'ออกจากโหมดเต็มจอ',
    fullTank: 'เต็มถัง',
    factory: 'โรงงาน',
    FueluseReport: 'การคำนวณปริมาณการใช้น้ำมันของพาหนะ',
    failed: 'ล้มเหลว',
    fleetStatus: 'สถานะกองรถ',
    fleetEfficiency: 'ประสิทธิภาพของกองรถ',
    floorWallDelivery: 'จัดส่ง พื้น-ผนัง',
    fromAnotherSystem: 'จากระบบอื่น',
    failedToOpenTicketAtTerminus: ' เปิดตั๋วที่ TERMINUS ไม่สำเร็จ',
    forceToTakePicturesSeal: 'บังคับถ่ายภาพคลุมผ้าใบ',
    forceToTakePicturesSendWork: 'บังคับถ่ายภาพส่งงาน',
    fleetManagement: 'ระบบจัดการกองรถ',
    filterRawMaterial: 'กรองข้อมูลวัตถุดิบ',
    force: 'บังคับ',
    full: 'เต็มจำนวน',
    foundAProblemConnectingToRawMaterialUsageData:
      'พบปัญหาการเชื่อมต่อข้อมูลจ่ายวัตถุดิบ',
    favourite: 'รายการโปรด',
    failedToSend: 'ส่งไม่สำเร็จ',
    filterData: 'กรองข้อมูล',
    foundAProblemSendingDataToBluenet: 'พบปัญหาการส่งข้อมูลไปยัง Bluenet',
  },
  g: {
    grDateTime: 'วันที่เวลา GR',
    gpsWorking: 'ใช้งานได้',
    gpsNotWorking: 'ใช้งานไม่ได้',
    gpsUpdateAt: 'GPS ของรถโม่อัปเดตล่าสุดเมื่อ ',
    gpsDistance: 'ระยะ GPS',
    grade: 'เกรดที่ได้',
    gpsProviderChoose: 'กรุณาเลือกผู้ให้บริการGPS',
    gpsProvider: 'ผู้ให้บริการ GPS',
    goback: 'เดินทางกลับ',
    goto: 'เดินทางไป',
    gpsStatus: 'สถานะ GPS',
    gallery: 'แกลเลอรี่',
    gallery_name: 'ชื่อ',
    gate1: 'ประตู 1',
    gate2: 'ประตู 2',
    gate3: 'ประตู 3',
    general: 'ทั่วไป',
    general_report_menu: 'ทั่วไป',
    generalCurve: 'โค้งทั่วไป',
    generalLocation: 'General Location',
    generateMap: 'สร้างแผนที่',
    goBackToUseImagesByLocationType: 'กลับไปใช้รูปภาพตามประเภทสถานที่',
    googleMapApiKey: 'Google Map Api Key',
    gps_update: 'ตำแหน่งล่าสุด',
    gpsCertification: 'ใบรับรองการติดตั้ง',
    gpsCertRequest: 'ขอใบรับรองการตืดตั้ง',
    gpsCertRequestHistory: 'ประวัติการขอใบรับรองการติดตั้ง',
    gpsNotFixed: 'GPS ไม่เกาะ',
    gpsNotFixedDesc: 'พิกัดไม่แม่นยำ อาจทำให้ตำแหน่งคลาดเคลื่อนจากความเป็นจริง',
    gpsPerformanceDashboard: 'ประสิทธิภาพ GPS',
    GpsstatusReport: 'พาหนะที่สัญญาณขาดหาย',
    gpsVendor: 'ผู้ให้บริการ GPS',
    gpsVendorPayingReport: 'สรุปค่าบริการตาม GPS Vendor',
    gpsVendorPayingSummaryReport: 'สรุปค่าบริการ GPS ทั้งหมด',
    gradeAtoF: 'เกรด (A ถึง F)',
    greater_than: 'มากกว่า',
    greaterOrEqual: 'มากกว่าเท่ากับ',
    group: 'กลุ่ม',
    group_by: 'จัดกลุ่มโดย',
    group_data: 'Group ข้อมูล',
    group_idle: 'เฉพาะจอดติดเครื่อง',
    group_speed: 'เฉพาะความเร็วเกิน',
    groupByLocation: 'จัดกลุ่มตามสถานที่',
    groupVehicleType: 'กลุ่ม/ประเภทพาหนะ',
    gpsReportLostContact: 'GPS ขาดการติดต่อ',
    gpsDisconnectOnTrip: 'GPS ขาดการติดต่อขณะวิ่งงาน',
    gpsPerformanceDesGPS:
      'คิดจากการใช้งานได้ในช่วงเวลาที่วิ่งงานแต่ละตั๋ว โดยหักเวลาก่อนแจ้งซ่อมออก ในกรณีที่ขาดการติดต่อไม่สามารถจับเวลาการทำงานได้ จะคิดเวลาการทำงานแต่ละตั๋วตั้งแต่เวลาผลิตเสร็จ + 3 ชม.',
    gpsPerformanceDesDrumSensor:
      'จำนวนตั๋วที่มีการเทปูน เทียบกับตั๋วที่มีการเข้าไซต์งาน',
    gpsPerformanceDesCard: 'จำนวนวันที่รูดบัตร เทียบกับจำนวนวันที่วิ่งงาน',
    gpsPerformanceDesRed: '< 95% (สำหรับเดือนที่ผ่านมา)',
    gpsPerformanceDesYellow: '< 95% (สำหรับเดือนปัจจุบัน)',
    gpsPerformanceDesGreen: '>= 95%',
    gpsPerformanceDesNA: 'ไม่สามารถประเมินได้เนื่องจากข้อมูลไม่พอ',
    generateqrCodeBy: 'Generate QR Code โดย',
    generateqrCodeInArea: 'Generate QR Code ในพื้นที่',
    grConditions: 'เงื่อนไข GR',
    goodsReceiveUnofficial: 'รับสินค้า (ไม่มีตั๋ว)',
    grToBluenetAt: 'วันที่-เวลาส่ง GR',
    grToBluenetMsg: 'ข้อความที่ส่งไปยัง bluenet',
    grToBluenetDetail: 'รายละเอียดการ GR ไปยัง bluenet',
    goodsReceivedIsupply: 'ผลการรับสินค้า',
    grouped: 'จัดกลุ่ม',
    grades: 'ขนาดคละ',
    gradesByEyes: 'ขนาดคละ (ด้วยสายตา)',
    graphView: 'มุมมองกราฟ',
    goodsReceiveChangeDestination: 'รับสินค้า (เปลี่ยนปลายทาง)',
    generalItems: 'รายการทั่วไป',
    gradation: 'รหัสการไล่สี',
    groupName: 'ชื่อกลุ่ม',
    generateTokenAccount: 'สร้างบัญชีโทเค็น',
    generate: 'สร้าง',
    generateToken: 'สร้างโทเค็น',
    generateTokenResult: 'ผลลัพธ์สร้างโทเค็น',
  },
  h: {
    holidaysName: 'ชื่อวันหยุด',
    history: 'ประวัติ',
    humus: 'ดินดำ',
    hideLocation: 'ซ่อนสถานที่',
    half: 'Half',
    hardwareID: 'รหัสฮาร์ดแวร์',
    header: 'หัวข้อ',
    height: 'สูง',
    help_menu: 'ช่วยเหลือ',
    high: 'สูง',
    history_servicerepairdevice: 'ประวัติ',
    home: 'หน้าหลัก',
    honeytoastdownloadfile: 'ดาวน์โหลดวิดีโอ Honey Toast',
    honeytoastlivestream: 'วิดีโอเรียลไทม์จาก Honey Toast',
    honeytoastplayback: 'วิดีโอย้อนหลัง Honey Toast',
    horsePower: 'แรงม้า',
    hotel: 'โรงแรม',
    hour: 'ชั่วโมง',
    hours: 'ชม.',
    honeyToast: 'Honey Toast',
    hasLocationCoordinates: 'มีพิกัดสถานที่',
    homePage: 'หน้าแรก',
    holidaysOfTheContractorCompany: 'วันหยุดของผู้ขนส่ง',
    holidaysOfTheContractorCompany2: 'วันหยุดของผู้รับเหมา',
  },
  i: {
    items: 'รายการ',
    isupplyHolidays: 'วันหยุดผู้ขนส่ง',
    inTransitQuantityTotal: 'กำลังขนส่ง',
    idCardNotMatch: 'เลขบัตรประชาชนไม่ตรง',
    id_card: 'เลขบัตรประชาชน',
    is_pay: 'การชำระค่าบริการ',
    informer: 'ผู้แจ้ง',
    timestampissueticket: 'เวลาออกตั๋ว',
    issueticketBy: 'ออกตั๋วโดย',
    issueticket: 'ออกตั๋ว',
    iconDesc: 'รายละเอียดไอคอน',
    iconStatus: 'รายละเอียดไอคอน',
    id: 'ID',
    idCard: 'ID_Card',
    idleFuelRate: 'Idle Fuel Rate',
    ignoredAlert: 'ไม่แจ้งเตือน',
    imageFromDashCamera: 'ภาพจากกล้อง',
    imageFromTheGallery: 'รูปจากแกลเลอรี่',
    imageMustSmallerThan5MB: 'รูปภาพต้องมีขนาดเล็กกว่า 5MB',
    imagesNotUpdate: 'รูปภาพไม่อัปเดต',
    immediatelyAcess: 'ทันที',
    immediatelyBreak: 'เบรคกระทันหัน (ครั้ง)',
    import: 'นำเข้าข้อมูล',
    include_engine_off: 'รวมข้อมูลดับเครื่อง',
    indexFilterOption_All: 'ทั้งหมด',
    indexFilterOption_Cancel: 'ยกเลิก',
    indexFilterOption_Confirm: 'ยืนยัน',
    indexFilterOption_Finish: 'เสร็จสิ้น',
    indexFilterOption_Unassign: 'ยังไม่มีพนักงานขับขี่',
    indexFilterOption_Waiting: 'รอพนักงานขับขี่ยืนยัน',
    indian: 'อินเดีย',
    inEvery: 'ในทุกๆ',
    infomation: 'ข้อมูล',
    inform_date: 'วันที่แจ้ง',
    informationFor: 'ข้อมูลของ',
    insertSuccess: 'เพิ่มข้อมูลสำเร็จ',
    insertFail: 'เพิ่มข้อมูลไม่สำเร็จ',
    informationForDate: 'ข้อมูลวันที่ต้องการสินค้า',
    inside: 'ด้านใน',
    install: 'ติดตั้ง',
    install_at: 'ติดตั้งเมื่อ',
    installDevice: 'ติดตั้งอุปกรณ์',
    installed: 'ติดตั้งแล้ว',
    installStatus: 'สถานะการติดตั้ง',
    insurance: 'ประกันภัยรถยนต์',
    insurance_report_menu: 'ประกันภัยพาหนะ',
    insuranceID: 'หมายเลขกรมธรรม์',
    InsuranceReport: 'รายงานประกันภัยพาหนะ',
    insure_report_menu: 'ประกันภัย',
    internalOperation: 'การจัดการภายใน',
    internet: 'อินเตอร์เน็ต',
    invoice_date: 'วันที่ใบส่งของ',
    invoice_number: 'เลขที่ใบส่งของ',
    issuedDate: 'วันที่ออก',
    isupplyManageVehicle: 'การจัดคิวรถ',
    itemLeft: 'เหลือ',
    itemSelected: 'เลือก',
    inMaintenance: 'รถที่ไม่พร้อมใช้งาน',
    isupplyManageQueue: 'การจัดการคิวรถ',
    informationAboutTheCarRunWall: 'ข้อมูล แผนการวิ่งรถ (ผนัง)',
    informationAboutTheCarRunFloor: 'ข้อมูล แผนการวิ่งรถ (พื้น)',
    import: 'นำเข้าข้อมูล',
    importMutipleCompany: 'นำเข้าข้อมูล (หลายบริษัท)',
    importUpTo1000RowsAtATime:
      'นำเข้าข้อมูลได้ไม่เกินครั้งละ 1,000 แถว เท่านั้น',
    isupplySource: 'ต้นทาง',
    isupplyPlant: 'ปลายทาง',
    interfaceGR: 'Interface GR',
    isupplyQR: 'สแกน QR Code',
    isupplyCDASE: 'รับค่าผ่าน API',
    isupplyFIXED: 'น้ำหนักตามสัญญา',
    isupplyMANUAL: 'ระบุโดยพนักงานขับขี่',
    isupplySeal: 'คลุมผ้าใบ',
    issupplyDP: 'ใบ DP',
    inTheSystem: 'ในระบบ',
    isupplySourceCodeRequest: 'ระบุ ปลายทาง',
    isupplySystemKey: 'Interface CDAS',
    isupplyProduct: 'สินค้า',
    inFrontOfTheCarYouCanSeeTheRegistrationPlateAndTheDropOffPoint:
      'หน้ารถเห็นทะเบียนและจุดลงสินค้า',
    InProcessOfDeliveryTheTicketGroupCannotBeEdited:
      'อยู่ระหว่างการจัดส่ง ไม่สามารถแก้ไขกลุ่มตั๋วได้',
    isupplyMultidrop: 'การจัดกลุ่มใบงาน',
    imageTitle: 'ชื่อภาพตัวอย่าง',
    isupplyBookingOrder: 'แผนงานกองรถ',
    isupplyCustomerName: 'ชื่อ-นามสกุลผู้ใช้งาน',
    isupplyCustomerNameIsRequired: 'กรุณาระบุ ชื่อ-นามสกุลผู้ใช้งาน',
    isupplyCustomerPhone: 'เบอร์โทรติดต่อผู้ใช้งาน',
    isupplyCustomerPhoneIsRequired: 'กรุณาระบุ เบอร์โทรติดต่อผู้ใช้งาน',
    isupplyCustomerInformation: 'ข้อมูลผู้ใช้งาน',
    informationMustBeUnique: 'ข้อมูลต้องไม่ซ้ำ',
    isupplyBookingDashboard: 'ปฏิทินงานกองรถ',
    isupplySaleOrder: 'รายการสั่งวัตถุดิบแบบกองงาน',
    invalidData: 'ข้อมูลไม่ถูกต้อง',
    ind_ret: 'เปอร์เซ็นต์ค้างตะแกรง',
    images: 'รูป',
    isupplyShipment: 'การขนส่งทางเรือ',
    informationAboutCreation: 'ข้อมูลการสร้าง',
    informationAboutUpdates: 'ข้อมูลการอัปเดต',
    importFailed: 'นำเข้าข้อมูลไม่สำเร็จ',
    initialQuantity: 'ปริมาณตั้งต้น',
    isupplyServiceActiveLog: 'Services',
    image: 'รูป',
    imageName: 'ชื่อรูป',
    itFallsOnTheTransporterIsHoliday: 'ตรงกับวันหยุดของผู้ขนส่ง',
    inactive: 'ยกเลิก',
    inAdvance: 'ล่วงหน้า',
    isupplyAccepted: 'รับงาน',
  },
  j: {
    job: 'งาน',
    jobDetail: 'รายละเอียดงาน',
    jobId: 'รหัสงาน',
    jobStartAt: 'เวลาเข้างาน',
    jobStatus: 'สถานะงาน',
    jobType: 'ประเภทงาน',
    jobTypeSTATISTICS: 'สถิติประเภทของงาน',
    joinDate: 'วันที่เริ่มงาน',
    jobSiteGroup: 'กลุ่มไซต์งาน',
    jobInformation: 'ข้อมูลงาน',
    jobSiteSurvey: 'ข้อมูลการสำรวจหน้างาน',
  },
  k: {
    keywordAtleast3character: 'คำหลักอย่างน้อย 2 ตัวอักษร',
    kind: 'ชนิด',
    km: 'กม.',
    kmPerLite: 'กม./ลิตร',
    kmH: 'กม./ชม.',
    kpiDateTime: 'วันที่/เวลา',
    kpiEvent: 'เหตุการณ์',
    kg: 'กก.',
  },
  l: {
    latestCalculatedDateTime: 'วันที่/เวลา ที่คำนวณล่าสุด',
    list: 'รายการ',
    LeavingPlantLateCheckThePlantGeofence:
      'ออกจากแพลนต์ช้า เช็ค geofence ของแพลนต์',
    LateToTheAgencyCheckTheAgencyGeofence:
      'ถึงหน่วยงานช้า เช็ค geofence ของหน่วยงาน',
    largeTruck: 'รถโม่ใหญ่',
    lessThan3days: 'น้อยกว่า 3 วัน',
    load_amount: 'ปริมาณที่โหลด (คิว)',
    load_time: 'ระยะเวลาโหลด (ชั่วโมง)',
    load_end: 'จบการโหลด',
    load_start: 'เริ่มโหลด',
    largeMixer: 'โม่ใหญ่',
    largeMixerAndSmallMixer: 'โม่เล็กและโม่ใหญ่',
    lastest_signal: 'สัญญาณล่าสุด',
    lastmaintenanceAt: 'การซ่อมบำรุงครั้งล่าสุด',
    lastName: 'นามสกุล',
    LastNameisCharacters: 'นามสกุลต้องเป็นตัวอักษร',
    lastQueue: 'คิวล่าสุด',
    lastRequestOn: 'คำขอล่าสุดเมื่อ',
    late: 'ที่สาย',
    latePoint: 'จุดที่เข้าสาย ค่าเกณฑ์',
    latestDriver: 'พนักงานขับขี่ล่าสุด',
    latitude: 'ละติจูด',
    latitudeIsRequired: 'กรุณากรอกละติจูด',
    latitudeIsRequiredAndCantBeEmpty: 'กรุณากรอกละติจูด',
    latlng: 'ละติจูด,ลองจิจูด',
    lazada: 'ลาซาด้า',
    leaveTheOriginLocation: 'ออกจากบริเวณต้นทาง',
    length: 'ความยาว',
    less_than: 'น้อยกว่า',
    lessOrEqual: 'น้อยกว่าเท่ากับ',
    lightStatus: 'สถานะไฟ',
    limit10Driver: 'จำนวนพนักงานขับขี่ที่เลือกต้องไม่เกิน 10 คน',
    limitAggesiveAccelerationThreshold: 'เร่งแรงได้ไม่เกิน',
    limitDrivingAggesiveThreshold: 'ขับพาหนะจี้ท้ายได้ไม่เกิน',
    limitDrivingHourTime: 'จำกัดระยะเวลาวิ่งงานต่อเนื่อง (นาที)',
    limitGoInsideArea: 'ห้ามเข้าพื้นที่เกิน',
    limitGoOutsideArea: 'ห้ามออกพื้นที่เกิน',
    limitOpenDuration: 'ห้ามเปิดเกิน',
    limitParking: 'ห้ามจอดเกิน',
    limitParkingDuration: 'ห้ามจอดเกิน',
    limitParkingInsideLocation: 'ห้ามจอดในสถานที่เกิน',
    limitParkingOutsideLocation: 'ห้ามจอดนอกสถานที่เกิน',
    limitSnoozeThreshold: 'สุ่มเสี่ยงหลับในได้ไม่เกิน',
    limitSuddenlyBreakThreshold: 'เบรคแรงได้ไม่เกิน',
    limitUsingPhoneThreshold: 'ใช้โทรศัพท์ขณะขับขี่ได้ไม่เกิน',
    link: 'ลิ้งค์',
    liveStream: 'วิดีโอเรียลไทม์',
    load: 'โหลด',
    loadAmount: 'จำนวนโหลด',
    loadpoint: 'จุดโหลดของ',
    loadStartAt: 'โหลดเมื่อ',
    location: 'สถานที่',
    Location: 'สถานที่',
    locationAndRoute: 'สถานที่และเส้นทาง',
    locationBlacklist: 'Locations Blacklist',
    locationCode: 'รหัสสถานที่',
    locationCodeIsRequired: 'กรุณากรอกรหัสสถานที่',
    locationGroup: 'กลุ่มสถานที่',
    locationGroupName: 'ชื่อกลุ่มสถานที่',
    locationGroupNameIsRequired: 'กรุณากรอกชื่อกลุ่มสถานที่',
    locationGroupTypeIsRequired: 'กรุณาเลือกประเภทกลุ่มสถานที่',
    locationInformation: 'ข้อมูลสถานที่',
    LocationInSystem: 'สถานที่ที่มีอยู่ในระบบ',
    locationName1IsRequired: 'กรุณากรอกชื่อสถานที่',
    LocationOfDeviceUser: 'สถานที่ต้นสังกัดของพนักงานขับขี่',
    LocationOfVehicle: 'สถานที่ต้นสังกัดของพาหนะ',
    locationShareFrom: 'สถานที่ที่ถูกแชร์',
    locationShareTo: 'สถานที่ที่แชร์',
    locationTemporary: 'สถานที่ชั่วคราว',
    locationType: 'ประเภทสถานที่',
    login: 'เข้าสู่ระบบ',
    login_fail: 'เข้าระบบไม่สำเร็จ',
    login_success: 'เข้าระบบสำเร็จ',
    LoginhistoryReport: 'ประวัติการเข้าใช้งานระบบรายคน',
    logout: 'ออกจากระบบ',
    longdoMapApiKey: 'Longdo Map Api Key',
    longitude: 'ลองจิจูด',
    longitudeIsRequired: 'กรุณากรอกลองจิจูด',
    LongitudeIsRequiredAndCantBeEmpty: 'กรุณากรอกลองจิจูด',
    lookingForSomething: 'ป้อนตำแหน่ง',
    lostConnectio: 'ขาดการติดต่อ',
    low: 'ต่ำ',
    linenotify: 'ตั้งค่า Line Notify',
    line_token: 'Line Token',
    line_token_require: 'กรุณากรอก Line Token',
    litre: 'ลิตร',
    litrePerTrip: 'ลิตร/เที่ยว',
    line: 'บรรทัด',
    localDelivery: 'ส่งในพื้นที่',
    localDeliveryOnly: 'ส่งในพื้นที่ เท่านั้น',
    locationSharingStatus: 'สถานะการแชร์ สถานที่',
    lineId: 'ไอดีไลน์',
    landmark: 'จุดสังเกต',
    locale: 'th-TH',
    latestUpdate: 'แก้ไขล่าสุด',
    listOfReceivingUsingRawMaterials: 'รายการรับจ่ายวัตถุดิบ',
    lab_quality_evaluation: 'ทดสอบโดย LAB CPAC',
    lasted_login: 'วันที่เข้าระบบล่าสุด',
    loading: 'กำลังโหลด',
    lastActiveDate: 'วันที่ทำงานล่าสุด',
    lastStartActiveAt: 'เริ่มทำงานล่าสุด',
    lastEndActiveAt: 'เสร็จสิ้นล่าสุด',
    lastSuccessAt: 'สำเร็จล่าสุด',
    lastConnectionAt: 'เชื่อมต่อล่าสุด',
    locationRegisterNo: 'รหัสลงทะเบียนสถานที่',
    leadTime: 'ระยะเวลาจัดส่ง',
    lock: 'ล็อก',
    lastTicketCreatedAt: 'เวลาที่สร้างตั๋วล่าสุด',
    locationNotSpecified: 'ไม่ระบุสถานที่',
    locationCoordinates: 'พิกัดสถานที่',
    loginByToken: 'ล็อคอินด้วย Token',
  },
  locationType: {
    All: 'ทั้งหมด',
    BS: 'ป้ายรถเมย์หลัก',
    BS1: 'ป้ายรถเมย์ 1',
    BS2: 'ป้ายรถเมย์ 2',
    CarService: 'ศูนย์บริการ',
    GasStation: 'ปั้มน้ำมัน',
    GasCost: 'ค่าน้ำมัน',
    GasCostBath: 'ค่าน้ำมันต่อ กม.',
    NoParking: 'จุดห้ามจอด',
    OnSite: 'แพลนท์ออนไซต์',
    ParkingLot: 'ลานจอดพาหนะ',
    Plant: 'จุดโหลดของ',
    PreparePoint: 'จุดเตรียมความพร้อม',
    RestArea: 'จุดพักพาหนะ',
    Site: 'จุดส่งของ',
    Temporary: 'สถานที่ชั่วคราว',
    Mill: 'ต้นทาง',
    MaterialPickUpPoint: 'จุดรับวัสดุ',
    Unload: 'จุดเท',
    TestCenter: 'ศูนย์ทดสอบ',
  },
  m: {
    materiaOrderlOverStock: 'สั่งวัตถุดิบเกิน',
    missingExcessQuantity: 'ปริมาณที่เกิน',
    minutesAgo: ' นาทีที่แล้ว',
    monthCount: 'เดือนที่',
    moveTime: 'เริ่มเคลื่อนที่ (วัน-เวลา,สถานที่)',
    mapview: 'มุมมองแผนที่',
    map: 'ดูแผนที่',
    mixerSize: 'ขนาดโม่',
    m: 'เมตร',
    meterConcreteDashboard: 'ม.',
    m_april: 'เมษายน',
    m_august: 'สิงหาคม',
    m_december: 'ธันวาคม',
    m_february: 'กุมภาพันธ์',
    m_january: 'มกราคม',
    m_july: 'กรกฎาคม',
    m_june: 'มิถุนายน',
    m_march: 'มีนาคม',
    m_may: 'พฤษภาคม',
    m_november: 'พฤศจิกายน',
    m_october: 'ตุลาคม',
    m_september: 'กันยายน',
    machineSerialNumber: 'หมายเลขเครื่องยนต์',
    maintenance: 'การบำรุงรักษา',
    maintenance_status: 'สถานะ',
    maintenance_type: 'ประเภทการแจ้ง',
    maintenanceConditions: 'เงื่อนไขการซ่อมบำรุง',
    maintenancedevice: 'แจ้งซ่อมอุปกรณ์',
    maintenancedevice_report_menu: 'การจัดการอุปกรณ์',
    MaintenancedeviceconcludeReport: 'การซ่อม/ถอดอุปกรณ์',
    MaintenanceReport: 'พาหนะที่ต้องบำรุงรักษา',
    manage_product: 'จัดการสินค้า',
    management_menu: 'การจัดการ',
    managementdevice_report_menu: 'การจัดการอุปกรณ์',
    manpowerRate: 'อัตรากำลัง',
    map: 'แผนที่',
    mapType: 'Map Type',
    mapView: 'มุมมองแผนที่',
    masterData: 'ข้อมูลหลัก',
    match: 'จับคู่',
    masterDataMatrial: 'วัตถุดิบ',
    material: 'วัตถุดิบ',
    materialCode: 'รหัสวัตถุดิบ',
    materialName: 'ชื่อวัตถุดิบ',
    materialCodeRequest: 'ระบุ รหัส วัตถุดิบ',
    materialNameRequest: 'ระบุ ชื่อ วัตถุดิบ',
    materialRequest: 'วันที่ต้องการวัตถุดิบ',
    materialWasNotFound: 'ไม่พบวัตถุดิบในระบบ',
    max_speed: 'ความเร็วสูงสุด (กม./ชม.)',
    maxDrumCapacity: 'ความจุโม่สูงสุด',
    mdvrdownloadfile: 'ดาวน์โหลดวิดีโอย้อนหลัง MDVR',
    medium: 'ปานกลาง',
    message: 'ข้อความ',
    meter: 'มิเตอร์',
    meterDashCameras: 'มิเตอร์',
    meterSN: 'Meter S/N',
    meterStatus: 'สถานะ Meter',
    mileNo: 'เลขไมล์',
    min: 'นาที',
    min_speed: 'ความเร็วสูงสุด(ขั้นต่ำ)',
    Minimal: 'อย่างย่อ',
    minute: 'นาที',
    miss: 'นางสาว',
    mixingDrum: 'โม่ผสมปูน',
    model: 'รุ่น',
    moisture: 'ความชื้น',
    monitoring: 'ระบบติดตาม',
    month: 'เดือน',
    monthly: 'รายเดือน',
    more_1_min: 'มากกว่า 1 นาที',
    more_10_mins: 'มากกว่า 10 นาที',
    more_10_sec: 'มากกว่า 10 วินาที',
    more_30_sec: 'มากกว่า 30 วินาที',
    more_5_mins: 'มากกว่า 5 นาที',
    more_5_sec: 'มากกว่า 5 วินาที',
    more_60_sec: 'มากกว่า 60 วินาที',
    move: 'ย้าย',
    move_in: 'เข้าจุด',
    move_out: 'ออกจุด',
    moveDevice: 'แจ้งย้ายอุปกรณ์',
    mr: 'นาย',
    mrs: 'นาง',
    materialGroupType: 'ประเภทกลุ่มวัตถุดิบ',
    multiDrop: 'ติดตามสถานะการจัดส่งทริป',
    mdvr: 'MDVR',
    menu: 'เมนู',
    maxOverLimitTime: 'เวลาสูงสุด (ชั่วโมง:นาที:วินาที)',
    multiDropDescIncomingTrip: 'กำลังเข้าจุด',
    multiDropDescIncomingTripDesc: 'พาหนะกำลังเดินทางไปยังจุดหมายที่กำหนด',
    multiDropDescIncomingLateTrip: 'กำลังเข้าจุด(สาย)',
    multiDropDescIncomingLateTripDesc:
      'พาหนะกำลังเดินทางไปยังจุดหมายที่กำหนด และล่าช้ากว่าเวลาแผน',
    multiDropDescAlreadyVisitTrip: 'เข้าจุด',
    multiDropDescAlreadyVisitTripDesc: 'พาหนะถึงจุดหมาย (ตรงเวลา)',

    multiDropDescVisited: 'ยังไม่เข้าจุด',
    multiDropDescVisitedDesc: 'พาหนะยังไม่ถึงจุดหมาย',
    multiDropDescVisitedConfirm: 'รอยืนยัน',
    multiDropDescVisitedConfirmDesc:
      'พาหนะถึงจุดหมายและอยู่ระหว่างยืนยันการเข้าจุด (อยู่ในสถานที่เกิน 3 นาที)',
    multiDropDescVisitedLate: 'เข้าจุดสาย',
    multiDropDescVisitedLateDesc: 'พาหนะถึงจุดหมายล่าช้ากว่าเวลาแผน',
    multiDropDescVisitedOnTime: 'เข้าจุด',
    multiDropDescVisitedOnTimeDesc: 'พาหนะถึงจุดหมาย (ตรงเวลา)',

    multiDropDescLeave: 'ยังไม่ออกจุด',
    multiDropDescLeaveDesc: 'พาหนะยังไม่ออกจากจุดหมาย',
    multiDropDescLeaveConfirm: 'รอยืนยัน',
    multiDropDescLeaveConfirmDesc:
      'พาหนะออกจุดหมายและอยู่ระหว่างยืนยันการออกจุด (ออกนอกสถานที่เกิน 3 นาที)',
    multiDropDescLeaveLate: 'ออกจุดสาย',
    multiDropDescLeaveLateDesc: 'พาหนะออกจุดหมายล่าช้ากว่าเวลาแผน',
    multiDropDescLeaveOnTime: 'ออกจุด',
    multiDropDescLeaveOnTimeDesc: 'พาหนะออกจุดหมาย (ตรงเวลา)',
    materialPickUpPoint: 'จุดรับวัสดุ',
    moreInformation: 'ข้อมูลเพิ่มเติม',
    multidrop: 'Multidrop',
    multidropKey: 'Multidrop Key',
    materialCodeIsRequired: 'ระบุ รหัสวัตถุดิบ',
    materialIsRequired: 'ระบุ วัตถุดิบ',
    mode: 'โหมด',
    minimumRate: 'อัตราขั้นต่ำ',
    minimumAmountOfConcreteThroughThePump: 'ปริมาณคอนกรีตผ่านปั้มขั้นต่ำ',
    minimumExcess: 'ส่วนเกินขั้นต่ำ',
    materialQualityAssessmentDetail: 'รายละเอียดการประเมินคุณภาพวัตถุดิบ',
    materialType: 'ประเภทวัตถุดิบ',
    maximum: 'สูงสุด',
    minimum: 'ต่ำสุด',
    materialQualityAssessmentHistory: 'ประวัติการประเมินคุณภาพวัตถุดิบ',
    materialStock: 'วัตถุดิบคงเหลือ',
    mattrialStockEndDay: 'วัตถุดิบคงเหลือ สิ้นวัน',
    materialUsedToCalculateTheMaximumProductionVolume:
      'วัตถุดิบที่ใช้ในการคำนวณปริมาณการผลิตสูงสุด',
    materialOrderingTime: 'เวลาสั่งวัตถุดิบ',
    materialQuantity: 'ปริมาณวัตถุดิบ',
    maxProduction: 'ผลิตได้สูงสุด',
    minimumWeightPerTrip: 'น้ำหนักบรรทุกขั้นต่ำ/เที่ยว',
    minimumWeightPerTripIsRequired: 'ระบุ น้ำหนักบรรทุกขั้นต่ำ/เที่ยว',
    minimumWeightPerTripMustBeGreaterThan0:
      'ระบุ น้ำหนักบรรทุกขั้นต่ำ/เที่ยว ต้องมากกว่า 0',
    mm: 'มม.',
    max_5_forms: 'เลือกได้สูงสุด 5 ฟอร์ม',
    materialStockDashboard: 'วัตถุดิบคงเหลือ',
    maximumNumberOfOrdersLimited: 'จำกัด จำนวนใบงานสูงสุด',
    maximumNumberOfTicket: 'จำนวนเที่ยวสูงสุด',
    maximumNumberOfTicketIsRequired: 'ระบุ จำนวนเที่ยวสูงสุด',
    materialQuota: 'โควตาวัตถุดิบ',
    manageMaterialQuota: 'จัดการโควตาวัตถุดิบ',
    materialQuotaLog: 'ประวัติการจัดการโควตาวัตถุดิบ',
    manyPlantMode: 'แบบหลายโรงงาน',
    mustNotBeANegativeNumber: 'ต้องไม่เป็นตัวเลขที่ติดลบ',
    mustNotBeANegativeNumberAndSiloMaxGreaterThanSiloMin:
      'ต้องไม่เป็นตัวเลขที่ติดลบและ silo max > silo min',
    mustBeAInteger: 'ต้องเป็นตัวเลขจำนวนเต็ม',
    materialUsage: 'Usage',
    materialRequests: 'ออกตั๋ว',
    materialOnOrder: 'รับงาน',
    materialInTransit: 'ระหว่างจัดส่ง',
    materialReceive: 'จัดส่ง',
    materialQuotaManagement: 'บริหารโควตาวัตถุดิบ',
    materialCondition: 'รหัสสภาพวัตถุดิบ',
    morning: 'เช้า',
    mustbeShipped: 'ที่ต้องจัดส่ง',
    manual: 'คู่มือ',
    menuHierarchy: 'โครงสร้างเมนู',
    matchingName: 'Matching name',
  },
  month: {
    january: 'มกราคม',
    february: 'กุมภาพันธ์',
    march: 'มีนาคม',
    april: 'เมษายน',
    may: 'พฤษภาคม',
    june: 'มิถุนายน',
    july: 'กรกฎาคม',
    august: 'สิงหาคม',
    september: 'กันยายน',
    october: 'ตุลาคม',
    november: 'พฤศจิกายน',
    december: 'ธันวาคม',
  },
  n: {
    notificationRight: 'สิทธิ์รับ Notification',
    notificationAnyRight: 'มีสิทธิ์ใดก็ได้',
    notificationAdministrative: 'ธุรการ',
    notificationProductionManager: 'ผู้จัดการโรงงาน',
    notificationConcretePlant: 'iSupply โรงงานคอนกรีต',
    notificationReceivable: 'ได้รับ Notification',
    notificationNotReceivable: 'ไม่ได้รับ Notification',
    notificationRightInfoTitle: 'เงื่อนไขการได้รับ Notification',
    notificationRightInfoBase:
      'เงื่อนไขพื้นฐาน: เป็นผู้ใช้ Bluenet (มีข้อมูล CPAC Org Chart) และสถานะยังใช้งานอยู่',
    notificationRightInfoAdministrative:
      'อยู่กลุ่มธุรการ และมีโรงงานที่รับผิดชอบ',
    notificationRightInfoProductionManager:
      'อยู่กลุ่มผู้จัดการโรงงาน และมีโรงงานที่รับผิดชอบ',
    notificationRightInfoConcretePlant:
      'อยู่กลุ่ม iSupply โรงงานคอนกรีต และรับผิดชอบไม่เกิน 3 โรงงาน',
    notesList: 'รายการหมายเหตุทั้งหมด',
    notFound: 'ไม่พบ',
    nearestPlant: 'แพลนต์ปูนที่ใกล้ที่สุด',
    notInstallGPS: 'ไม่มี GPS',
    neighborhoodInformation: 'ข้อมูลพื้นที่ใกล้เคียง',
    notFinished: 'ดำเนินการยังไม่เสร็จ',
    notFoundIdCard: 'ไม่พบเลขบัตรประชาชน',
    noDriverName: 'ไม่มีพนักงานขับขี่',
    numberSpeedsExceeded: 'จำนวนความเร็วเกินกำหนด',
    noTruckInWrongSpot: 'ไม่มีรถโม่เข้าผิดจุด/เทปูนนอกจุด',
    number: 'จำนวน',
    numberOfTruckIsReadyToUse: 'จำนวนรถโม่พร้อมใช้งาน',
    numberOfTruckIsWaitingForProduction: 'จำนวนรถโม่จอดรอผลิต',
    numberOfTruckOnTheWayAndOnSite: 'จำนวนรถโม่กำลังเดินทางและอยู่หน้างาน',
    numberOfTruckGoesBack: 'จำนวนรถโม่เดินทางกลับ',
    name: 'ชื่อ',
    nameAE: 'ชื่อ AE',
    nameAndType: 'ชื่อและประเภท',
    nameTableCompany: 'ชื่อ',
    nameTitle: 'คำนำหน้า',
    nationality: 'สัญชาติ',
    nationalityZone: 'โซนสัญชาติ',
    nearByLocation: 'สถานที่ใกล้เคียง',
    nearbyPlants: 'แพลนต์ใกล้สุด',
    nearPlants: 'แพลนต์ใกล้ๆ',
    netWeight: 'น้ำหนักสุทธิ',
    netWeightTon: 'นน.สุทธิ',
    netWeightTonDestination: 'นน.สุทธิปลายทาง',
    new: 'เพิ่ม',
    newCustomer: 'ผู้ใช้บริการใหม่',
    newJob: 'งานใหม่',
    newLocation: 'สถานที่ใหม่',
    newPassword: 'รหัสผ่านใหม่',
    newRoute: 'เส้นทางการวิ่งใหม่',
    newTicket: 'Ticket ใหม่',
    newUser: 'ผู้ใช้งานใหม่',
    newUserGroup: 'กลุ่มผู้ใช้บริการใหม่',
    next: 'ถัดไป',
    nextMaintenanceConditions: 'เงื่อนไขการซ่อมบำรุงครั้งต่อไป',
    nextQueue: 'คิวถัดไป',
    nextRegisterDate: 'วันต่ออายุประกันภัยพาหนะ',
    nightTime: 'ช่วงเวลากลางคืน',
    no: '#',
    no_filter: 'ไม่กรอง',
    noData: 'ไม่มีข้อมูล',
    noPermissionToEdit: 'ไม่มีสิทธิ์แก้ไข',
    node: 'Node',
    nodeName: 'ชื่อ Node',
    noEntry: 'ห้ามเข้า',
    noExit: 'ห้ามออก',
    nofilevideo: 'ไม่สามารถสตรีมวิดีโอในเวลาที่เลือกได้',
    none: 'ปกติ',
    noParking: 'จุดห้ามจอด',
    normalStatusImage: 'รูปภาพแสดงสถานะปกติ',
    noStatus: 'ไม่มีสถานะ',
    notAllowParking: 'จอดในพื้นที่',
    notAvailable: 'ไม่พร้อมใช้งาน',
    note: 'หมายเหตุ',
    noteFill: 'ระบุหมายเหตุ',
    notification: 'การแจ้งเตือน',
    notificationEndWhen: 'จบแจ้งเตือนเมื่อ',
    notificationPasswordNotSafeInfo:
      'แจ้งเตือนรหัสผ่านไม่ปลอดภัย ผู้ใช้สามารถเปลี่ยนรหัสผ่านด้วยตนเองที่เมนูโปรไฟล์',
    notificationTime: 'เวลาที่แจ้งเตือน',
    notificationTracking: 'การแจ้งเตือน ติดตามพาหนะ',
    notificationType: 'ประเภทการแจ้งเตือน',
    notificationTypeEvent: 'ประเภทการแจ้งเตือน (Event Type)',
    notReadyForWork: 'ไม่พร้อมรับงาน',
    notYetShipped: 'ยังไม่จัดส่ง',
    nounsCar: 'คัน',
    noVehicleSelect: 'ยังไม่เลือกพาหนะ',
    now: 'ปัจจุบัน',
    number: 'จำนวน',
    number_of_days: 'จำนวนวัน',
    numberOfAlarmsPerDay: 'จำนวนครั้งที่เกิด Alarm ต่อวัน',
    numberOfCardSwipeTimes: 'จำนวนครั้งที่รูดบัตร',
    numberOfContinuousAlarmDay: 'จำนวนวันที่เกิด Alarm ต่อเนื่อง',
    NumberofdaysworkedReport: 'จำนวนวันที่พาหนะวิ่งงาน',
    numberofEntryLatePoint: 'จำนวนจุดที่เข้าช้า (จุด)',
    numberOfExpirationDates: 'จำนวนวันที่หมดอายุ',
    numberOfVisitors: 'จำนวนผู้เข้าชม',
    numberVehiclegroup: 'จำนวน (คัน)',
    notpay: 'ไม่ต้องชำระ',
    numberOfTimes: 'จำนวน (ครั้ง)',
    noReport: 'ลำดับ',
    numberOfTrips: 'จำนวนเที่ยว',
    notify_type: 'เหตุการณ์แจ้งเตือน',
    notify_type_require: 'กรุณาเลือกเหตุการณ์แจ้งเตือน',
    netPayload: 'น้ำหนักบรรทุกสุทธิ',
    netPayloadIsRequire: 'ระบุน้ำหนักบรรทุกสุทธิ',
    newDestinationLocation: 'ปลายทางใหม่',
    newOriginLocation: 'ต้นทางใหม่',
    newTicketNumber: 'ตั๋ว (ใหม่)',
    notSubmittingWork: 'ไม่ส่งงาน',
    noQueuesOrReservations: 'ไม่มีการรับคิวหรือจองคิว',
    notifyTheTruckInCorrectPoint: 'แจ้งเตือนเข้าผิดหน่วยงาน',
    nameComparativeRawMaterials: 'ชื่อ วัตถุดิบเทียบ',
    newItemsOnly: 'รายการใหม่เท่านั้น',
    noProblemWeCanDoItItForYouButWeNeedToClearYourTicketGroupFirst:
      'ไม่มีปัญหา! เราจัดการให้คุณได้ แต่เราต้องเคลียร์กลุ่มตั๋วของคุณก่อน',
    numberOfBookings: 'จำนวนงาน',
    numberOfVehicles: 'จำนวนรถ',
    numberOfVehiclesIsReadyToUse: 'จำนวนรถที่พร้อมรับงาน',
    notesOnStockAdjustments: 'หมายเหตุการปรับวัตถุดิบคงเหลือ',
    notesOnStockAdjustmentsIsRequired: 'ระบุ หมายเหตุการปรับวัตถุดิบคงเหลือ',
    nextDay: 'วันถัดไป',
    numberOfDecimalsAllowed: 'จำนวนทศนิยมที่อนุญาต',
    noLocationCoordinates: 'ไม่มีพิกัดสถานที่',
    noMoreThan: 'ไม่เกิน',
    noDataToImport: 'ไม่มีข้อมูลที่จะนำเข้า',
    noCompressiveStrength: 'ไม่เพิ่ม/ลดกำลังอัด',
    nextActiveAt: 'เริ่มทำงานครั้งถัดไป',
    noDataQualityAssessment: 'ไม่มีข้อมูลการประเมินคุณภาพ',
    noMoreThan50Characters: 'ไม่เกิน 50 ตัวอักษร',
    notSendTheRawMaterialBalanceAtTheBeginningOfTheDayToBluenet:
      'ไม่ส่งยอดวัตถุดิบคงเหลือต้นวันไป Bluenet',
    normal: 'ปกติ',
    notificationOfRawMaterialOverstock: 'แจ้งเตือนวัตถุดิบล้นสต๊อค',
    nameTH: 'ชื่อ (TH)',
    nameEN: 'ชื่อ (EN)',
    notArrangingVehiclearWithin1Hour: 'ไม่จัดรถภายใน 1 ชม.',
    notCalculateSiloNoForCreateTicket: 'ยกเลิกการใช้ silo max',
    noText: 'ไม่ใช่',
  },
  o: {
    originalData: 'ค่าตั้งต้น',
    orderHistorySuggestAndAuto: 'ประวัติการ Suggest / Auto',
    orderDate: 'วันที่สั่ง',
    onOrderQuantityTotal: 'ยอดสั่ง',
    orderHistoryMaterial: 'ประวัติการสั่งวัตถุดิบ',
    orderOfEvents: 'ลําดับเหตุการณ์',
    ocher: 'ดินเหลือง',
    OnlyMaximum1000RowsDataCanBeImportedAtTime:
      'นำเข้าข้อมูลได้ไม่เกินครั้งละ 1,000 แถวเท่านั้น',
    openTime: 'เปิดเครื่องยนต์ (วัน-เวลา)',
    on_time: 'ตรงเวลา',
    oilPriceB10: 'ราคาน้ำมัน (B10)',
    oilConsumptionRate: 'อัตราการบริโภคน้ำมัน',
    oilUsage: 'ใช้น้ำมันไป',
    oilUsageDetails: 'รายละเอียดการใช้น้ำมัน',
    outsidePoint: 'เทปูนนอกจุด',
    obd: 'OBD',
    off: 'ดับ',
    offFilter: 'ดับ',
    offFilterMeter: 'ปิด',
    offline: 'ออฟไลน์',
    ok: 'ตกลง',
    okay: 'ตกลง',
    on: 'ติด',
    onDevelop: 'อยู่ระหว่างการพัฒนา',
    onFilter: 'ติด',
    onFilterMeter: 'เปิด',
    ongoing: 'กำลังจัดส่ง',
    online: 'ออนไลน์',
    onlineonly: 'สถานะออนไลน์เท่านั้น',
    onProcess: 'อยู่ระหว่างการส่ง',
    onProcessing: 'กำลังดำเนินการ',
    OnSite: 'หน้างาน',
    open: 'เปิด',
    opened: 'รับเรื่อง',
    openFilter: 'เปิดการค้นหา',
    operation: 'การทำงาน',
    operator: 'ผู้ประกอบการ',
    or: 'หรือ',
    orderCode: 'รหัสการสั่งซื้อ',
    ordinal_numbers: 'ครั้งที่',
    origin: 'ต้นทาง',
    originLocation: 'ต้นทาง',
    originToDestination: 'ต้นทาง-ปลายทาง',
    other: 'อื่นๆ',
    outOfFactory: 'ออกจากโรงาน',
    outOfOriginlocationDateTime: 'วันที่เวลาออกจากต้นทาง',
    outOfOriginlocation: 'ออกจากต้นทาง',
    outside: 'ด้านนอก',
    over_hour: 'พาหนะวิ่งเกิน(ชั่วโมง)',
    over12Month: 'ช่วงวันที่ที่เลือกไม่ควรเกิน 12 เดือน',
    over6Month: 'ช่วงวันที่ที่เลือกไม่ควรเกิน 6 เดือน',
    over20: 'เลือกรถได้ไม่เกิน 20 คัน',
    over15: 'เลือกรถได้ไม่เกิน 15 คัน',
    over1Month: 'ช่วงวันที่ที่เลือกไม่ควรเกิน 31 วัน',
    over7Day: 'ช่วงวันที่ที่เลือกไม่ควรเกิน 7 วัน',
    over2Month: 'ช่วงวันที่ที่เลือกไม่ควรเกิน 2 เดือน',
    over30: 'เลือกรถได้ไม่เกิน 30 คัน',
    over32Month: 'ช่วงวันที่ที่เลือกไม่ควรเกิน 3 ปี',
    over1day: 'ช่วงวันที่ที่เลือกไม่ควรเกิน 1 วัน',
    over50: 'เลือกรถได้ไม่เกิน 50 คัน',
    over100: 'เลือกรถได้ไม่เกิน 100 คัน',
    over2000: 'เลือกรถได้ไม่เกิน 2000 คัน',
    over3Days: 'เกิน 3 วัน',
    overdueSpeedInTheCommunityArea: 'ความเร็วเกินกำหนดในเขตชุมชน',
    overOneMonth: 'ช่วงวันที่ที่เลือกไม่ควรเกิน 1 เดือน',
    overSpeedInNormalRoutes: 'ความเร็วเกินกำหนดในเส้นทางปกติ',
    overSpeedInTheJunction: 'ความเร็วเกินกำหนดในทางแยก',
    overview: 'ภาพรวม',
    overviewNotificationTypeHeatMap: 'ภาพรวมประเภทการแจ้งเตือน (Heat Map)',
    ownerView: 'เจ้าของพาหนะเห็นข้อมูล',
    vehicleOffline: 'พาหนะสถานะออฟไลน์',
    other: 'อื่นๆ',
    onTheMove: 'รถที่วิ่งงาน',
    outOfTimeLimit: 'จัดส่งไม่ตรงเวลา',
    over1Day: 'ช่วงวันที่ที่เลือกไม่เกิน 1 วัน',
    otherRawMaterialCodes: 'รหัส วัตถุดิบอื่นๆ',
    only_dp: 'ออกเฉพาะที่มี DP',
    only_dps: 'เฉพาะที่มี DP',
    open: 'เปิด',
    openSettings: 'เปิดการตั้งค่า',
    openATicketAtTheCpacSystem: 'เปิดตั๋วที่ระบบ CPAC',
    orderNo: 'หมายเลขงาน',
    order: 'งาน',
    overStandard: 'ปริมาณสูงกว่าเกณฑ์',
    orderMaterial: 'สั่งวัตถุดิบ',
    owner: 'เจ้าของ',
    optionalQuota: 'โควตาเสริม',
    organicValue: 'ค่าการเจือปน',
    omitFlag: 'การยกเว้นการทดสอบ',
    orderListToday: 'สั่งวันนี้',
    onlyImageCanBeUploaded: 'สามารถอัปโหลดได้เฉพาะรูปภาพเท่านั้น',
    organizationChart: 'ผังองค์กร',
    orderAmount: 'ปริมาณที่สั่ง',
    originChangeStatus: 'สถานะการเปลี่ยนต้นทาง',
    originBeforeChange: 'ต้นทางเดิม',
    originNameBeforeChange: 'ชื่อต้นทางเดิม',
    of: 'จาก',
  },
  p: {
    periodTime: 'รอบเวลา',
    pickupSquence: 'ลำดับการจัดส่ง',
    pleaseFillYourRouteName: 'โปรดระบุชื่อเส้นทางของท่าน',
    pleaseFillRouteName: 'กรุณาตั้งชื่อเส้นทาง',
    pouringConcreteOutSideThePointList: 'รายการเทปูนนอกจุด',
    plantName: 'โรงงานที่ punch in',
    pinDoesNotExistInSystem: 'ปักหมุดหน่วยงานที่ไม่มีในระบบ',
    precastConcrete: 'คอนกรีตสำเร็จรูป',
    production: 'ยอดผลิต',
    percentage_working: '% การทำงาน',
    percentage_working_day: 'ประสิทธิภาพ GPS(%)',
    primary_location: 'โรงงานที่สังกัด',
    parkingOnRoadSide: 'จุดนอกจุดจอด',
    pendingdistrubutetask: 'รอแจกจ่ายงาน',
    pendingconfirmation: 'รอยืนยัน',
    parking: 'จอดพาหนะ',
    parkingDistance: 'ระยะทาง (กิโลเมตร)',
    parkingDuration: 'ระยะเวลาที่จอดรถ (ชั่วโมง:นาที:วินาที)',
    parkingLocation: 'สถานที่จอดรถ',
    parkingLot: 'ลานจอดพาหนะ',
    parkingOnTheRoadShoulder: 'จุดนอกจุดจอด',
    ParkingReport: 'จุดจอดพาหนะ',
    parkingSumDistance: 'ระยะทางสะสม (กิโลเมตร)',
    parkingTime: 'เวลาที่จอดรถ',
    parkingDateTime: 'วันเวลาที่จอด',
    part_type: 'อะไหล่พาหนะ',
    partgroup: 'กลุ่มอะไหล่พาหนะ',
    partiallyDamagedCard: 'บัตรเสียหายบางส่วน',
    partner: 'ผู้เช่าพาหนะ',
    partners: 'พาร์ทเนอร์',
    partnerCar: 'ผู้เช่าพาหนะ',
    partnerPerformReport: 'สรุปเรียกเก็บเงินตามผู้รับเหมา',
    partSetting: 'ตั่งค่าอะไหล่',
    partType: 'ชนิดอะไหล่พาหนะ',
    passenger: 'จำนวนผู้โดยสาร',
    password: 'รหัสผ่าน',
    passwordMustBeAtLeast6: 'รหัสผ่านอย่างน้อย 6 ตัวอักษร',
    passwordMustMatch: 'ยืนยันรหัสผ่านใหม่ไม่ตรง',
    passwordNotSafeValidateText: 'รหัสผ่านไม่ปลอดภัย',
    passwordsMustMatch: 'รหัสผ่านต้องเหมือนกัน',
    past7day: 'ย้อนหลัง 7 วัน',
    payPoint: 'จุดจ่าย',
    pdf: 'PDF',
    pdfFilesUpTo5MBInSize: 'ไฟล์ PDF ขนาดไม่เกิน 5MB',
    pending: 'รอดำเนินการ',
    period: 'ระยะเวลา',
    periodOfInsuranceYear: 'ระยะเวลาประกันภัยพาหนะ (ปี)',
    permission: 'สิทธิ์',
    personal: 'บุคคล',
    personalID: 'หมายเลขบัตรประชาชน',
    personalIDMustBeNumber: 'หมายเลขบัตรประจำตัวประชาชนต้องเป็นตัวเลข',
    personalIDTooLong: 'หมายเลขบัตรประจำตัวประชาชนต้องมี 13 ตัว!!!',
    personalIDTooShort: 'หมายเลขบัตรประจำตัวประชาชนต้องมี 13 ตัว!!!',
    personalInformation: 'ข้อมูลส่วนบุคคล',
    phoneNumber: 'เบอร์โทร 1',
    phoneNumberMustBeNumber: ' ต้องเป็นตัวเลขและอยู่ระหว่าง 8-20 ตัวอักษร',
    photo: 'รูป',
    pickup: 'จุดรับ',
    pickupData: 'วันนัด',
    pickUpDateTime: 'วัน/เวลานัด',
    pickUpDetail: 'รายละเอียดจุดรับ',
    pickUpLocation: 'สถานที่รับ',
    pickUpTheQueue: 'จองคิว',
    pickUpTime: 'เวลานัด',
    picture: 'รูปภาพ',
    pictureUpdate: 'อัปเดตรูปภาพ',
    pinDown: 'ปักหมุด',
    plan_start_deliver_at: 'เวลาเริ่มจัดส่งตามแผน',
    plan: 'ตามแผน',
    plant: 'แพลนท์',
    plantConcrete: 'แพลนต์ปูน',
    plants: 'โรงงาน',
    plantsDelivery: 'โรงงานจัดส่ง',
    plant_name: 'ชื่อแพลนต์',
    plantArrivingTime: 'เวลาเข้าแพลนต์',
    plantCode: 'รหัสแพลนต์',
    plantFactory: 'Plant/Factory',
    plantMiningContract: 'สัญญาการขนส่ง',
    plantWasNotFound: 'ไม่พบแพลนต์ในระบบ',
    plateNo: 'ทะเบียน',
    plateNoCar: 'ทะเบียนรถ',
    plateNoOrCode: 'ทะเบียน/รหัสพาหนะ',
    plateNoOfInstall: 'ทะเบียนรถที่ติดตั้ง',
    plateNoOfUninstall: 'ทะเบียนรถที่แจ้งถอด',
    plateNoVehicleCode: 'ทะเบียน, รหัสพาหนะ',
    plateNoVehicleCodeOnline: 'ทะเบียน, รหัสพาหนะ(สถานะออนไลน์เท่านั้น)',
    PleaseEnterInitialStartTime: 'กรุณากรอกเวลาติดเครื่องเริ่มต้น',
    PleaseEnterInitialEndTime: 'กรุณากรอกเวลาติดเครื่องสิ้นสุด',
    pleaseChooseDateRange: ' กรุณาเลือกช่วงวันที่',
    pleaseChooseEvent: 'กรุณาเลือกเหตุการณ์',
    pleaseChooseReport: 'กรุณาเลือกรายงาน',
    pleaseChooseVehicle: ' กรุณาเลือกรถ',
    pleaseEnterEmailAddress: 'กรุณากรอกที่อยู่อีเมล',
    PleaseFillVehicleFareHours: 'กรุณากรอกค่ารถวิ่งเกิน(ชั่วโมง)',
    pleaseEnterEmailSubject: 'กรุณากรอกหัวข้ออีเมล',
    pleaseSelect: 'กรุณาเลือก',
    pleaseSelectDriver: 'กรุณาเลือกพนักงานขับขี่',
    pleaseSelectExpirationDate: 'กรุณาเลือกจำนวนวันหมดอายุ',
    pleaseSelectLocation: 'กรุณาเลือกสถานที่',
    pleaseSelectPicture: 'กรุณาเลือกรูปภาพ',
    pleaseSelectReportType: 'กรุณาเลือกรายงาน',
    pleaseSelectTheReport: 'กรุณาเลือกรายงาน',
    pleaseSelectVehicleCode: 'กรุณาเลือกรหัสพาหนะ',
    pleaseSelectVehicleRegistration: 'กรุณาเลือกทะเบียนพาหนะ',
    pleaseSpecifyDeliveryTime: 'โปรดระบุเวลาส่งของ',
    pleaseSpecifyDeliveryTimeAndWork: 'โปรดระบุเวลาส่งของและงาน',
    pleaseSpecifyTheNumberOfVehiclesNotMoreThanTheNumberOfTasks:
      'โปรดระบุจำนวนรถให้ไม่เกินจำนวนของงาน',
    pleaseSpecifyVehicle: 'โปรดระบุพาหนะ',
    PleaseSelectStartingPoint: 'กรุณาเลือกจุดเริ่มต้น',
    PleaseSelectEndPoint: 'กรุณาเลือกจุดสิ้นสุด',
    pleaseSpecifyTicket: 'โปรดระบุตั๋ว',
    pleaseUploadACarRegistrationBookFileForGPSVendor:
      'โปรดอัปโหลดไฟล์ หน้าเล่มทะเบียนรถ เพื่อเป็นข้อมูลสำหรับผู้ให้บริการ GPS',
    po: 'ใบสั่งซื้อ',
    point: 'คะแนน',
    policy: 'นโยบาย',
    policy_report_menu: 'รายงาน นโยบาย',
    polyGonRadius: 'รัศมี',
    PONumber: 'หมายเลขใบสั่งซื้อ',
    poNumberIsrequired: ' กรุณากรอกหมายเลขใบสั่งซื้อ',
    position: 'ตำแหน่ง',
    precastDashboard: 'สถานะขนส่งพื้น-ผนัง',
    preventReDrawLocationConfirm:
      'ตำแหน่งสถานที่จะหายไปเมื่อกดปักหมุดใหม่ ต้องการยืนยัน?',
    preventRePinLocationConfirm:
      'ตำแหน่งสถานที่จะหายไปเมื่อกดปักหมุดใหม่ ต้องการยืนยัน?',
    preview: 'แสดงตัวอย่าง',
    previous: 'ย้อนกลับ',
    primary_location: 'แพลนต์ที่สังกัด',
    privilege: 'กลุ่มสิทธิ์',
    privilegegroup: 'กลุ่มสิทธิ์',
    processing: 'กำลังประมวลผล',
    product: 'สินค้า',
    product_code: 'รหัสสินค้า',
    product_code_duplicate_require: 'รหัสสินค้านี้มีอยู่แล้วในระบบ',
    product_code_require: 'กรุณากรอกรหัสสินค้า',
    product_description: 'รายละเอียด',
    product_name: 'ชื่อสินค้า',
    product_name_duplicate_require: 'ชื่อสินค้านี้มีอยู่แล้วในระบบ',
    product_name_require: 'กรุณากรอกชื่อสินค้า',
    product_type: 'ชนิดของผลิตภัณฑ์',
    product_uom_require: 'กรุณาเลือกหน่วยนับเล็กสุด',
    productType: 'ประเภทสินค้า',
    profile: 'โปรไฟล์',
    projectName: 'ชื่อโครงการ',
    province: 'จังหวัด',
    pto: 'PTO',
    publicKey: 'รหัสบริษัท',
    pullvehiclesink: 'ดึงรถจม',
    purchaseChannel: 'ช่องทางการซื้อ',
    patternThatAcceptsWeightData: 'รูปแบบการรับน้ำหนัก',
    pending: 'รอยืนยัน',
    problem: 'พบปัญหาการจัดส่ง',
    pay: 'ชำระ',
    performance: 'ประสิทธิภาพ',
    phonenumberisNotValid: 'เบอร์โทรไม่ถูกต้อง',
    phonenumberIsRequired: 'ระบุเบอร์โทร',
    pleaseEnterAnEmailToReceiveTheCertificate:
      'กรุณาระบุ email เพื่อรับหนังสือรับรอง',
    pleaseSpecifyTheNumberOfWorksNotExceedingTheNumberOfCars:
      'โปรดระบุจำนวนงานให้ไม่เกินจำนวนของรถ',
    pinCode: 'PIN Code',
    pleaseProvideCompleteInformation: 'โปรดระบุข้อมูลให้ครบ',
    pleaseSelectWorksheetMaintenance:
      'กรุณาเลือกใบงานแจ้งซ่อมที่ต้องการเปลี่ยนสถานะ',
    pleaseProvideCompleteInformationInTheFile: 'โปรดระบุข้อมูลในไฟล์ให้ครบถ้วน',
    perTrip: '/เที่ยว',
    problemType: 'ประเภทปัญหา',
    perDay: '/วัน',
    pendingApproval: 'รออนุมัติ',
    pickUpPoint: 'ตำแหน่งจองคิว',
    positionForSigning: 'ตำแหน่งเซ็นลายเซ็น',
    positionForSeal: 'ตำแหน่งคลุมผ้าใบ',
    positionForPhotographingSeal: 'ตำแหน่งถ่ายรูปคลุมผ้าใบ',
    photoLocationDuringDelivery: 'ตำแหน่งถ่ายรูปส่งของ',
    photoShoot: 'รูปแบบการถ่ายภาพ',
    previousLocation: 'สถานที่ก่อนหน้า',
    previousTicket: 'ตั๋วก่อนหน้า',
    provideCompleteInformationOfRawMaterialsForComparison:
      'ระบุ ข้อมูลวัตถุดิบเทียบให้ครบถ้วน',
    produceLocation: 'ผลิตภัณฑ์',
    primarily: 'ประจำ',
    phone: 'เบอร์โทรศัพท์',
    perTrip: '/เที่ยว',
    pleaseSpecifyNodeName: 'ระบุชื่อ Node',
    pleaseSpecifyVisibility: 'โปรดระบุ การมองเห็นข้อมูล',
    pleaseSpecifyCompany: 'โปรดระบุบริษัท',
    pleaseSelectFile: 'กรุณาระบุไฟล์',
    pleaseSetUpCompany: 'โปรดตั้งค่าบริษัท',
    postalCode: 'รหัสไปรษณีย์',
    pleaseSpecifySampleImageName: 'โปรดระบุชื่อภาพตัวอย่าง',
    plateNoIsRequired: 'ระบุ ทะเบียน',
    payment: 'การชำระเงิน',
    paymentType: 'ประเภทการชำระเงิน',
    periodIsrequired: 'กรุณาระบุ ช่วงเวลา',
    pause: 'หยุดชั่วคราว',
    pleaseProvideCompleteInformation: 'ระบุ ข้อมูลให้ครบถ้วน',
    pleaseSpecifyDestination: 'กรุณาระบุปลายทาง',
    pleaseSpecifyDate: 'กรุณาระบุวันที่',
    pleaseSpecifyDeliveryTime: 'กรุณาระบุเวลาส่งของ',
    pipeInstallationCost: 'ค่าติดตั้งท่อ',
    productQuality: 'คุณภาพสินค้า',
    pfa: 'PFA',
    productionCapability: 'ความสามารถในการผลิต',
    PleaseEnterDPNumber: 'กรุณาระบุเลขตั๋ว',
    productionCapability: 'ความสามารถในการผลิต',
    percent: 'เปอร์เซ็นต์',
    productionAmount: 'ยอดผลิตจริง',
    productionCapacity: 'ยอดผลิตได้',
    primarySource: 'แหล่งหลัก',
    primary: 'หลัก',
    pleaseSelectLocationOrigin: 'กรุณาเลือกต้นทาง',
    pendingGR: 'รอยืนยัน',
    periodEvaluation: 'งวดที่',
    pleasePressTheCalculateButtonBeforeSaving: 'กรุณากดปุ่มคำนวณก่อนบันทึก',
    pleasePressThePreviewButtonBeforeSaving: 'กรุณากดแสดงตัวอย่างก่อนบันทึก',
    primaryQuota: 'โควตาหลัก',
    previewData: 'แสดงข้อมูล',
    previewTicketDetail: 'แสดงรายละเอียดตั๋ว',
    pleaseCheckTheInformationAgain: 'มีข้อผิดพลาด กรุณาตรวจสอบข้อมูลอีกครั้ง!',
    primaryContract: 'สัญญาหลัก',
    permissionName: 'ชื่อสิทธิ์',
    precast: 'Precast',
    platform: 'แพลตฟอร์ม',
    plantProductionManager: 'ผจก.โรงงาน',
    plantAdministrativeManager: 'ผจก.ธุรการ',
    photoOther: 'รูปอื่นๆ',
    photoSandDust: 'รูปฝุ่นทราย',
    photoSandMoisture: 'รูปความชื้นทราย',
    photoSandChloride: 'รูปคลอไรด์ทราย',
    photoWaterChloride: 'รูปคลอไรด์น้ำ',
  },
  product_types: {
    animal_food: 'อาหารสัตว์',
    bag_cement: 'ถุงปูนซีเมนต์',
    bulk_cement: 'ปูนซีเมนต์ผง',
    chill: 'อาหารแช่เย็น',
    concrete_pump: 'ปั๊มคอนกรีต',
    container: 'ขนส่งด้วยตู้คอนเทนเนอร์',
    fcr: 'FCR',
    frozen: 'อาหารแช่แข็ง',
    generic: 'ส่งของทั่วไป',
    plate: 'Plate',
    readymixconcrete: 'คอนกรีตผสมสำเร็จ',
    room_temp: 'ห้องควบคุมอุณหภูมิ',
    spool: 'Spool',
    valuable: 'ของมีค่า',
  },
  q: {
    quantityDeliveryToday: 'ยอดจัดส่งวันนี้',
    qty: 'จำนวน',
    quantity: 'ปริมาณ',
    quantityIsRequired: 'กรุณาระบุ ปริมาณ',
    quantity_liter: 'ปริมาณ (ลิตร)',
    quantity_tons: 'ปริมาณ (ตัน)',
    quarter: 'Quarter',
    queueQuantity: 'ปริมาณคิว',
    queue: 'คิว',
    queueTotal: 'จำนวนคิว',
    qrCodeType: 'ประเภทการรับค่าน้ำหนัก',
    queueSystemIsNotInUse: 'ไม่ใช้งานระบบคิว',
    quantityPerTrip: 'ปริมาณต่อเที่ยว',
    quantityPerDay: 'ปริมาณต่อวัน',
    quotation: 'ใบเสนอราคา',
    quality_evaluation: 'คุณภาพวัตถุดิบ',
    quality_evaluation_data: 'ข้อมูลการทดสอบคุณภาพ',
    quality_evaluation_detail: 'รายละเอียดผลการทดสอบ',
    quality_evaluation_history: 'ประวัติการทดสอบคุณภาพสินค้า',
    quick_test: 'Quick test',
    quick_test_evaluation: 'ทดสอบคุณภาพ - Daily',
    quotaTotal: 'โควตารวม',
    quotaOverLimit: 'จำนวนโควตาเกินกำหนด',
    quotaIsComplete: 'จำนวนโควตาครบตามกำหนด',
    quotaNumber: 'จำนวนโควตา',
    quotaApproved: 'จำนวนโควตาที่จัดรถแล้ว',
    qualityTestingPeriodic: 'ทดสอบคุณภาพ - ประจำงวด',
  },
  r: {
    receiveQuantityTotal: 'จัดส่งสำเร็จ',
    responseData: 'ข้อมูลตอบกลับ',
    responseDate: 'วันที่ตอบกลับ',
    retriveQuantity: 'ปริมาณรับ',
    remainingRefAccount: 'คงเหลือตาม บ/ช',
    receiveTheAccomulatedAmountOfTheMonth: 'รับสะสมของเดือน',
    roundTripDistance: 'ระยะทางไป-กลับ (กม.)',
    redundantEvents: 'มีเหตุการณ์เดิมซ้ำๆ',
    ready_time_for_the_next_job: 'เวลาที่พร้อมรับงานครั้งถัดไป',
    return_time: 'ระยะเวลาเดินทางกลับ (ชั่วโมง)',
    remaining_quantity: 'ปริมาณคอนกรีตเหลือ (คิว)',
    refuel_position: 'ตำแหน่งเติมน้ำมัน',
    repairNoticeDate: 'วันเวลาที่แจ้งซ่อม',
    rateFuelUsagePast6MonthsKmLitre:
      'อัตราการใช้น้ำมันย้อนหลัง 6 เดือน กม./ลิตร',
    rail: 'ราง',
    readiness: 'ความพร้อม',
    rack: 'Rack-U',
    radiuns: 'รัศมี',
    radiunsM: 'รัศมี (ม.)',
    rainingTime: 'ช่วงฝนตก',
    reachTheDestination: 'ถึงปลายทาง',
    reachTheOnSite: 'ถึงหน้างาน',
    reActivate: 'เปิดใช้งานอีกครั้ง',
    receive: 'รับเรื่อง',
    receive_complete: 'รับเรื่อง หรือเสร็จเรียบร้อย',
    receive_date: 'วันที่รับเรื่อง',
    received: 'Received',
    receiveDate: 'วันที่ได้รับแจ้ง',
    receiveTheGoods: 'รับสินค้า',
    refuel: 'เติมเชื้อเพลิง',
    refuelAt: 'เติมเชื้อเพลิงเมื่อ',
    RefuelReport: 'การเติมน้ำมัน',
    reFuelTitle: 'เชื้อเพลิง',
    remainDay: 'คงเหลือ (วัน)',
    remainingDevice: 'อุปกรณ์ที่เหลืออยู่',
    remainingRequest: 'คำขอคงค้าง',
    remark: 'หมายเหตุ',
    remark1: 'หมายเหตุการจอง 1',
    remark2: 'หมายเหตุการจอง 2',
    remarkVendor: 'หมายเหตุ (Vendor)',
    remarkBooking: 'หมายเหตุการจอง',
    remindDate: 'วันแจ้งเตือน',
    reminderData: 'วันแจ้งเตือน',
    reminderTime: 'เวลาแจ้งเตือน',
    renewalDate: 'วันต่ออายุ',
    RepairDevice: 'แจ้งย้าย',
    repairingReport: 'การแจ้งซ่อม',
    replay: 'เส้นทางเดินทางย้อนหลัง',
    replayDetail: 'รายละเอียดเส้นทางเดินทางย้อนหลัง',
    replayNew: 'เส้นทางเดินทางย้อนหลัง (ใหม่)',
    replayTracking: 'เส้นทางย้อนหลัง',
    report: 'รายงาน',
    report_daily: 'รายวัน',
    report_monthly: 'รายเดือน',
    report_name: 'ชื่อรายงาน',
    report_taxifare: 'รายงานรายรับ',
    report_weekly: 'รายสัปดาห์',
    report_yearly: 'รายปี',
    reportsSortedColumns: 'รายงานเรียงตามคอลัมน์',
    reportAlarmFrequencyClassifiedByDailyDriver:
      'ความถี่ Alarm แยกตามพนักงานขับขี่ รายวัน',
    reportCardSwipeBehaviorBeforeDrivingDaily:
      'พฤติกรรมการรูดบัตรก่อนขับขี่ รายวัน',
    ReportAlarmFrequencyByDriverDaily:
      'รายงานความถี่ alarm แยกตามคนขับรถ รายวัน',
    reportSummarizingTheNumberOfOffSiteParking: 'จำนวนครั้งการจอดรถนอกพื้นที่',
    reportType: 'ประเภทรายงาน',
    requestACertificate: 'ขอใบรับรอง',
    requestList: 'รายการคำขอ',
    requestMaterial: 'รายการสั่งวัตถุดิบ',
    require: 'โปรดระบุ',
    requiredFieldCompany: 'กรุณากรอกชื่อบริษัท',
    requiredFieldConfirmPassword: 'กรุณายืนยันรหัสผ่าน',
    requiredFieldDischargeDenominator: 'กรุณากรอกค่าคำนวณปริมาณในการเท',
    requiredFieldEmail: 'กรุณากรอกอีเมล',
    requiredFieldFinishRefuel: 'กรุณาเลือกวันที่จบการเติมเชื้อเพลิง',
    requiredFieldFirstName: 'กรุณากรอกชื่อจริง',
    requiredFieldFuelTankSize: 'กรุณากรอกความจุถังเชื้อเพลิง',
    requiredFieldLastName: 'กรุณากรอกนามสกุล',
    requiredFieldLimitDrivingHourTime:
      'กรุณากรอกจำกัดระยะเวลาวิ่งงานต่อเนื่อง(นาที)',
    requiredFieldNameTitle: 'กรุณากรอกชื่อหัวข้อ',
    requiredFieldPartType: 'กรุณาเลือกชนิดอะไหล่พาหนะ',
    requiredFieldPassword: 'กรุณากรอกรหัสผ่าน',
    requiredFieldPersonalID: 'กรุณากรอกหมายเลขบัตรประจำตัวประชาชน',
    requiredFieldPhoneNumber: 'กรุณากรอกเบอร์โทรศัพท์',
    requiredFieldPlateNo: 'กรุณากรอกทะเบียนรถ',
    requiredFieldQuantity: 'กรุณากรอกปริมาณ(ลิตร)',
    requiredFieldStartRefuel: 'กรุณาเลือกวันที่เติมเชื้อเพลิง',
    requiredFieldTotalPrice: 'กรุณากรอกราคารวม(บาท)',
    requiredFieldUsername: 'กรุณากรอกชื่อผู้ใช้งาน',
    requiredFieldVehicle: 'กรุณาเลือกพาหนะ',
    requiredFieldVehicleCode: 'กรุณากรอกรหัสพาหนะ',
    requiredFieldVehicleGroupName: 'กรุณากรอกชื่อกลุ่มพาหนะ',
    requiredFieldVehicleType: 'กรุณาเลือกประเภทพาหนะ',
    requiredCompanyPartner: 'กรุณาเลือกบริษัทผู้รับเหมา',
    resendEmail: 'ส่งอีเมลอีกครั้ง',
    reset: 'รีเซ็ต',
    restArea: 'จุดพักพาหนะ',
    returnDistance: 'วิ่งเปล่า',
    rfid: 'RFID',
    risk: 'เสี่ยง',
    RiskbehaviourReport: 'พฤติกรรมการขับขี่ไม่ปลอดภัย',
    round: 'รอบ',
    route: 'เส้นทางการวิ่ง',
    route_master_name: 'ชื่อแผนการจัดส่ง',
    routemaster: 'แผนการจัดส่ง',
    routemaster_name_duplicate: 'ชื่อแผนการจัดส่งนี้มีอยู่แล้วในระบบ',
    routemaster_name_require: 'กรุณากรอกชื่อแผนการจัดส่ง',
    routeName: 'ชื่อเส้นทาง',
    routeRadius: 'รัศมีของเส้นทาง',
    routeRadiusM: 'รัศมีของเส้นทาง (ม.)',
    rpm: 'RPM',
    running: 'วิ่ง',
    requiredSite: 'กรุณาเลือกไซต์งาน',
    resetPinCode: 'Reset PIN Code',
    rawMaterialCategory: 'กลุ่มประเภทวัตถุดิบ',
    rawMaterialCategoryIsRequest: 'ระบุ กลุ่มประเภทวัตถุดิบ',
    rawMaterialsThatCanBeCarried: 'วัตถุดิบที่สามารถบรรทุกได้',
    requestToChangeDestination: 'รายการ ร้องขอเปลี่ยนผู้รับ',
    requestToChangeOriginLocationDestination:
      'รายการ ร้องขอเปลี่ยนต้นทาง/ปลายทาง',
    requesttoChangeDestination: 'ร้องขอเปลี่ยนผู้รับ',
    requesttoChangeOriginLocation: 'รายการ ร้องขอเปลี่ยนต้นทาง',
    recalculateDeliveryArea: 'คำนวนพื้นที่จัดส่งใหม่',
    recalculateOriginArea: 'คำนวนพื้นที่ต้นทางใหม่',
    requestBy: 'ร้องขอโดย',
    reject: 'ไม่อนุมัติ',
    requestAt: 'ร้องขอเมื่อ',
    randomlyWeighedEvery10Ticket: 'สุ่มชั่งน้ำหนักทุก 10 ใบงาน',
    runDNNumbersAutomatically: 'รันเลข DN อัตโนมัติ',
    rentalPrice: 'ราคาขาย',
    remarkIsRequired: 'ระบุ หมายเหตุ',
    rawMaterialUsage: 'รายการจ่ายวัตถุดิบ',
    rawMaterialUsageHistory: 'ประวัติการจ่ายวัตถุดิบ',
    rawMaterialDelivery: 'รายการรับวัตถุดิบ',
    rawMaterialDeliveryHistory: 'ประวัติการรับวัตถุดิบ',
    rawMatUsage: 'รายการใช้',
    reserve: 'ยอดจอง',
    remaining: 'คงเหลือ',
    requiredFieldDestinationLocation: 'โปรดระบุปลายทาง',
    requiredFieldOriginLocation: 'โปรดระบุต้นทาง',
    receivedAmount: 'ยอดรับ',
    reservationQuantity: 'ปริมาณงานจอง',
    rawMaterialSource: 'แหล่งวัตถุดิบ',
    radiusKm: 'รัศมี (กม.)',
    radius: 'รัศมี',
    reloadThisInformation: 'โหลดข้อมูลซ้ำ',
    receiveDateQC: 'วันที่เก็บตัวอย่าง',
    required: 'จำเป็นต้องระบุ',
    rawMaterialData: 'ข้อมูลวัตถุดิบ',
    rawMaterialTestData: 'ข้อมูลการทดสอบวัตถุดิบ',
    rock_dust: 'หินฝุ่น',
    refDoNumber: 'เลขที่ใบงานอ้างอิง',
    refDoNumberDuplicate: 'เลขที่ใบงานอ้างอิงซ้ำ',
    rockTestResults: 'ผลการทดสอบหิน',
    recommendedCompression: 'กำลังอัดแนะนำ',
    rockSandInspectionResults: 'ผลการตรวจสอบหิน/ทราย',
    rockOriginLocation: 'ต้นแหล่งหิน',
    rawMaterialQuotaManagementSystem: 'ระบบจัดการโควตาวัตถุดิบ',
    requiredNumber: 'จำนวนที่ต้องการ',
    recommend: 'แนะนำ',
    resendGR: 'ส่ง GR อีกครั้ง',
    receiveStock: 'รับเข้า',
    receiveAssessment: 'ประเมินรับ',
    retrospect: 'ย้อนหลัง',
    receiveProduct: 'รับสินค้า',
    realtimeStock: 'Realtime stock',
    redirect: 'Redirect',
    requesterNotSpecified: 'ไม่ได้ระบุผู้ร้องขอ',
    resendData: 'ส่งข้อมูลใหม่อีกครั้ง',
    resendDataSuccess: 'ส่งข้อมูลใหม่อีกครั้ง สำเร็จ',
    requestSupplyDate: 'วันที่ต้องการสินค้า',
    rejectSuccess: 'ไม่อนุมัติ สำเร็จ',
    rejectFail: 'ไม่อนุมัติ ไม่สำเร็จ',
    reason: 'เหตุผล',
    request: 'ร้องขอ',
    ratio: 'อัตราส่วน',
    registrationStatus: 'สถานะการขึ้นทะเบียน',
    review: 'ตรวจสอบ',
    risky: 'เสี่ยง',
  },
  s: {
    saveSuccess: 'บันทึกข้อมูลสำเร็จ',
    showMoreNotes: 'แสดงเพิ่มเติม',
    sourceQualityStatus: 'สถานะผลทดสอบ',
    sourceHasContract: 'แหล่งมีสัญญา',
    sourceContract: 'สัญญาต้นแหล่ง',
    sourceName: 'ชื่อแหล่ง',
    sourceType: 'ประเภทต้นแหล่ง',
    sourceType_2: 'ประเภทแหล่ง',
    statusForC581ProductionProgram: 'สถานะเปิดปิดการเชื่อมต่อโปรแกรมผลิต C581',
    suggestQuantityAndActualOrder: 'ค่าที่ระบบแนะนำและสั่งได้จริง',
    systemSuggestQuantity: 'ค่าที่ระบบแนะนำ',
    suggestTime: 'รอบการสั่ง',
    sendDate: 'วันที่ส่ง',
    sendData: 'ข้อที่มูลที่ส่ง',
    suggestQuantity: 'ปริมาณที่แนะนำ',
    stockUnbalance: 'สต๊อกไม่สมดุล',
    searchYourRoute: 'ค้นหาเส้นทางของคุณ',
    showMorePlantInformation: 'แสดงข้อมูลแพลนต์เพิ่มเติม',
    specialFilter: 'ตัวกรองพิเศษ',
    specifyName: 'ระบุชื่อ',
    siteLargeTruck: 'หน่วยงานรถโม่ใหญ่',
    siteSmallTruck: 'หน่วยงานรถโม่เล็ก',
    smallTruckRoute: 'เส้นทางรถโม่เล็ก',
    smallTruckRouteDoNotEnter: 'เส้นทางรถโม่เล็กห้ามเข้า',
    showCpacPlant: 'แสดงแพลนต์ CPAC',
    slow: 'ช้า',
    startingAtOverSpeedBrakingSuddenlyWhichCausedTheSpeedToDecreaseRapidly:
      'ออกตัวที่ความเร่งเกินกำหนด/เบรกกระทันหัน ที่ทำให้ความเร็วลดลงอย่างรวดเร็ว',
    safetyEventReport: 'รายงานความปลอดภัยพาหนะ',
    smallTruck: 'รถโม่เล็ก',
    smallTrucKAndLargeTruck: 'รถโม่เล็กและรถโม่ใหญ่',
    system: 'ระบบ',
    ShowMarkerInSimpleWay: 'แสดง Marker ในแบบเรียบง่าย',
    skip: 'ข้าม',
    selectTime: 'เวลาที่เลือก',
    selectPlay: 'เวลาที่กำลังเล่น',
    seeall: 'เห็นทั้งหมด',
    sumTotalDistance: 'จำนวนระยะทางที่วิ่ง',
    second: 'วินาที',
    stopTime: 'หยุดเคลื่อนที่ (วัน-เวลา,สถานที่)',
    setType: 'กำหนดประเภท',
    safeDriving: 'ขับขี่ปลอดภัย',
    speed60kmH: '60 กม./ชม.',
    speed80kmH: '80 กม./ชม.',
    speed100kmH: '100 กม./ชม.',
    speed120kmH: '120 กม./ชม.',
    speedOver: 'ความเร็วเกิน',
    siteName: 'ชื่อไซต์',
    siteNameSafetyDashboard: 'หน่วยงานของรถที่กำลังทำงานอยู่ (dp)',
    startPouring: 'เริ่มเท',
    servicecharge: 'ค่าบริการ',
    startproduction: 'เริ่มผลิต',
    saveTableSize: 'บันทึกขนาดตาราง',
    section: 'แผนก',
    smartDispatching: 'แผนที่บันทึกการใช้รถโม่เล็ก',
    smallMixer: 'โม่เล็ก',
    safety: 'ความปลอดภัย',
    SafetyEventReport: 'ความปลอดภัยพาหนะ',
    safetyDashboard: 'ความปลอดภัย',
    salary: 'เงินเดือน',
    salesChannels: 'ช่องทางการขาย',
    salesMan: 'พนักงานขาย',
    sand: 'ทราย',
    satellite: 'ดาวเทียม',
    save: 'บันทึก',
    saveNext: 'บันทึกและถัดไป',
    scan_date_at: 'วันที่อัปโหลด',
    SCCOCarComparisonReport: 'เปรียบเทียบพาหนะของ SCCO',
    Scoresummary: 'สรุปคะแนน',
    schedule_time: 'เวลาแจ้งเตือน',
    schedule_type: 'ชนิดการแจ้งเตือน',
    scheduled: 'นัดช่าง',
    scheduled_day: 'วันแจ้งเตือน',
    schedulereport: 'กำหนดการแจ้งเตือนรายงาน',
    scheduleWork: 'จัดตารางงาน',
    scoreEconomy: 'คะแนนความประหยัด (คะแนน)',
    scorePlanAchievement: 'คะแนนความสำเร็จตามแผน (คะแนน)',
    scoreSafety: 'คะแนนความปลอดภัย (คะแนน)',
    ScoresummaryReport: 'รูปแบบการสรุปคะแนน',
    scoreTotal: 'คะแนนรวม (คะแนน)',
    sealAtDateTime: 'วันที่เวลาคลุมผ้าใบ',
    sealAt: 'เวลาคลุมผ้าใบ',
    sealNO: 'หมายเลขแถบผนึกสินค้า',
    searchNormal: 'ค้นหา',
    search: 'ค้นหา',
    searchDashCameras: 'พิมพ์ค้นหาจากเลขทะเบียนรถ ...',
    searchDirections: 'ค้นหาเส้นทาง',
    searchPlants: 'ค้นหา',
    searchText: 'ค้นหาคำ',
    searchTextFromPlateNo: 'ค้นหาจากเลขทะเบียน ...',
    second_dest: 'จุดสิ้นสุด',
    secondaryPhoneNumber: 'เบอร์โทร 2',
    seeMap: 'ดูแผนที่',
    seenAll: 'เห็นข้อมูลทั้งหมด',
    select_event: 'เลือกเหตุการณ์',
    selectAssignTo: 'เลือกผู้รับมอบหมาย',
    selectCriticalityLevel: 'เลือกระดับความรุนแรง',
    selectDate: 'เลือกวันที่',
    selected: 'เลือก',
    selectedDevice: 'อุปกรณ์ที่เลือก',
    selectedVehicleAlready: 'พาหนะที่เลือกไว้',
    selectFile: 'เลือกไฟล์',
    selectNotificationChannel: 'เลือกช่องทางแจ้งเตือน',
    selectOne: 'เลือก 1 รายการ',
    selectPlateNo: 'เลือกทะเบียน',
    selectPlateNoOrVehicleCode: 'เลือกพาหนะ',
    selectPlateNoOrVehicleCode: 'เลือกทะเบียน/รหัสพาหนะ',
    selectStatus: 'เลือกสถานะ',
    selectTime: 'เลือกเวลา',
    selectVehicle: 'เลือกพาหนะ',
    selectVehicleGroup: 'เลือกกลุ่มพาหนะ',
    send: 'ส่ง',
    send_data_before_delivery: 'ใช้ข้อมูลวันก่อนหน้า',
    send_email: ' ส่งอีเมล',
    sendAsAGroupOfVehicles: 'ส่งแบบกลุ่มพาหนะ',
    sender: 'ผู้ส่ง',
    sendFailure: 'ส่งผิดพลาด',
    sendRequest: 'ส่งใบคำขอ',
    sendSelectedVehicles: 'ส่งแบบเลือกพาหนะ',
    sendWork: 'ส่งงาน',
    sentBy: 'ส่งโดย',
    specifyNumberDescription:
      'ระบุจำนวนครั้ง มากกว่าหรือเท่ากับ จำนวนที่เกิด Alarm ต่อวัน ที่ต้องการการไฮไลท์สี',
    sentSuccessfully: 'ส่งเรียบร้อย',
    serviceinstalldevice: 'ใบแจ้งติดตั้ง',
    servicemovedevice: 'ใบแจ้งย้าย',
    Servicerepairdevice: 'แจ้งซ่อม/ถอดอุปกรณ์',
    setTheRoute: 'กำหนดเส้นทาง',
    setting: 'ตั้งค่า',
    setting_filter: ' ตั้งค่ารายงาน',
    setup: 'ติดตั้ง',
    shaft: 'จำนวนเพลาล้อ',
    sharedAt: 'แชร์เมื่อ',
    shareFrom: 'พาหนะที่ถูกแชร์',
    shareLocation: 'แชร์สถานที่',
    shareTo: 'พาหนะที่แชร์',
    sharpBend: 'โค้งหักศอก',
    ship_to: 'รหัสไซต์งาน',
    site_name: 'ชื่อไซต์งาน',
    shipping: 'กำลังจัดส่ง',
    shippingInfo: 'ข้อมูลการส่งของ',
    shippingInformation: 'ข้อมูลการจัดส่ง',
    shippingRate: 'อัตราค่าแรงคนขับ',
    shipTo: 'ส่งไปยัง',
    shopee: 'ช้อปปี้',
    show: 'แสดง',
    showAll: 'แสดงทั้งหมด',
    showTraffic: 'แสดงการจราจร',
    showlocation: 'แสดงสถานที่',
    simNumber: 'หมายเลขซิม',
    site: 'ไซต์',
    siteCode: 'รหัสไซต์',
    sizeAndWeight: 'ขนาดและน้ำหนัก',
    slideWrongCardType: 'รูดบัตรผิดประเภท',
    slidingCard: 'รูดบัตร',
    smallTruck: 'รถบรรทุกขนาดเล็ก',
    smsNotifyTo: 'ส่ง sms แจ้งเตือนไปที่หมายเลข',
    so: 'SO',
    someparts: 'บางส่วน..',
    sort: 'เรียง',
    sortAmountAsc: 'จำนวนครั้งน้อยไปมาก',
    sortAmountDesc: 'จำนวนครั้งมากไปน้อย',
    sos: 'sos',
    southeastAsia: 'เอเชียตะวันออกเฉียงใต้',
    specialPrivilege: 'สิทธิพิเศษ',
    speed: 'ความเร็ว',
    speedAveg: 'ความเร็วเฉลี่ย (กม./ชม.)',
    speedKmPerHr: 'ความเร็ว (กม./ชม.)',
    speedLimited: 'ความเร็วเกินกำหนด',
    speedOverlimit60: 'ความเร็วเกิน 60 กม/ชม.',
    SpeedNotOver: 'ความเร็วไม่เกิน (กม./ชม.)',
    speedOverLimit: 'ความเร็วเกินกำหนด',
    speedOverLimitTime: 'ความเร็วเกินกำหนด (ครั้ง)',
    speedOverLimitDate: 'ความเร็วเกินกำหนด (เวลา)',
    speedOverLimitByDriver: 'ความเร็วเกินกำหนดตามพนักงานขับขี่',
    speedOverLimitByVehicleGroup: 'ความเร็วเกินกำหนดตามกลุ่มพาหนะ',
    speedOverLimitByVehicleType: 'ความเร็วเกินกำหนดตามประเภทพาหนะ',
    SpeedoverlimitsummaryReport: 'สรุปความเร็วเกินกำหนด',
    speedRange: 'ช่วงความเร็ว (กม./ชม.)',
    speedRangeNoKm: 'ช่วงความเร็ว',
    start_daily_time: 'เวลาเริ่มในแต่ละวัน',
    start_deliver_at: 'เวลาเริ่มทริป',
    startAndEndValidDateDesc: 'ช่วงวันที่อนุญาตให้ระบบนำข้อมูลพาหนะไปใช้งาน',
    startAt: 'เวลาเริ่ม',
    startAtDrivinglicensescanlog: 'เวลาในการรูดใบขับขี่',
    startDate: 'วันเริ่มต้น',
    startDeliveryAt: 'วัน-เวลาที่เริ่มทริป',
    startDeliveryDay: 'วันที่เริ่มทริป',
    startDestinationCode: 'รหัสต้นทาง',
    startDestinationName: 'ชื่อต้นทาง',
    startEndDate: 'วันที่เริ่มต้น - วันที่สิ้นสุด',
    startLocationCode: 'รหัสต้นทาง',
    startLocationName: 'ชื่อต้นทาง',
    startRefuel: 'เติมเชื้อเพลิงเมื่อ',
    startTrip: 'จุดเริ่มต้นทริป',
    startValidDate: 'วันที่เริ่มใช้พาหนะ',
    state: 'สถานะภาพ',
    status: 'สถานะ',
    statusCurrent: 'สถานะปัจจุบัน',
    status_download_file: 'สถานะการดาวน์โหลดไฟล์',
    status_engineoff: 'ดับเครื่อง',
    status_moving: 'พาหนะวิ่ง',
    status_parked: 'จอดพาหนะ',
    status_vehicle: 'สถานะพาหนะ',
    statusVehicleVideo: 'สถานะ',
    stone: 'หิน',
    stopWithEngineOff: 'จอดดับเครื่อง',
    stopWithEngineOn: 'จอดไม่ดับเครื่อง',
    submit: 'บันทึก',
    submit_name: 'ชื่อผู้ยื่นเรื่อง',
    submit_telno: 'เบอร์ติดต่อผู้ยื่นเรื่อง',
    submitName: 'ชื่อผู้ยื่นเรื่อง',
    submitTelno: 'เบอร์ติดต่อผู้ยื่นเรื่อง',
    subType: 'ประเภทย่อย',
    success: 'สำเร็จ',
    successfullyDelivered: 'จัดส่งเรียบร้อยแล้ว',
    summaryDashboard: 'แดชบอร์ดสรุป',
    SummaryiconsiamReport: 'สรุปรอบการให้บริการเรือ / รถ แบบเฉลี่ยรายวัน',
    summaryInfo: 'สรุปข้อมูล',
    SummaryKPIByDriverReport: 'KPI แยกตามพนักงานขับขี่',
    SummaryKPIReport: 'สรุปรายงาน KPI',
    support: 'สนับสนุน',
    surplus: 'เหลือ',
    salary: 'เงินเดือน',
    sentSuccessfully: 'ส่งแล้ว',
    searchBy: 'ค้นหาตาม',
    status_repair: 'สถานะการแจ้งซ่อม',
    statusGR: 'สถานะ GR',
    sumOverLimitTime: 'เวลารวมวิ่งเกินพิกัด (ชั่วโมง:นาที:วินาที)',
    setPermissions: 'กำหนดสิทธิ',
    sendInPlantArea: 'ส่งในพื้นที่ปลายทางเท่านั้น',
    seal: 'ซีลยึดคันบังคับดัมซ์',
    sideSeal: 'ซีลข้างรถ',
    stackStockAfterDumpIsDone: 'กองสต็อกหลังดัมซ์เสร็จ',
    shareFrom: 'แชร์จาก',
    systemKey1: 'กุญแจเชื่อมระบบ',
    smartScale: 'Smart Scale',
    siteGroup: 'กลุ่มหน่วยงาน',
    site: 'หน่วยงาน',
    siteGroupName: 'ชื่อกลุ่มหน่วยงาน',
    siteGroupNameIsRequired: 'กรุณากรอกชื่อกลุ่มหน่วยงาน',
    supplierNo: 'รหัส ผู้ขายวัตถุดิบ',
    subcontactNo: 'รหัส ผู้ขนส่ง',
    supplierNoRequest: 'ระบุ รหัส ผู้ขายวัตถุดิบ',
    subcontactNoRequest: 'ระบุ รหัส ผู้ขนส่ง',
    scaleBeforeSuckingTheSolution: 'สเกลก่อนดูดน้ำยา',
    scaleAfterSuckingTheSolution: 'สเกลหลังดูดน้ำยา',
    stockPickingPoint: 'กองสต็อกจุดรับ',
    stoneTransportTruckPlate: 'รถขนส่งหินทะเบียน',
    samplingBagWithInformationOnTheFrontOfTheBag:
      'ถุงเก็บตัวอย่างเห็นข้อมูลหน้าถุง',
    sendWrongDestination: 'ส่งผิดปลายทาง',
    setVariable: 'ตั้งค่าตัวแปร',
    section_code: 'รหัสแผนก',
    secondary: 'สำรอง',
    subdistrict: 'ตำบล',
    sampleImages: 'ภาพตัวอย่าง',
    subMaterialCodeIsRequired: 'ระบุ รหัสวัตถุดิบเทียบ',
    siteCode: 'รหัสไซต์',
    siteCodeIsRequired: 'กรุณาระบุ รหัสไซต์',
    siteInformation: 'ข้อมูล Site งาน',
    siteLocation: 'ตำแหน่ง Site งาน',
    subDistrictSubDistrict: 'แขวง/ตำบล',
    start: 'เริ่ม',
    smallsTruck: 'รถโม่เล็ก',
    saleOrderNo: 'หมายเลขใบสั่งขาย',
    startWork: 'วันที่เริ่มงาน',
    startTime: 'เวลาเริ่มต้น',
    saleOrder: 'กองงาน',
    selectOrder: 'เลือกงาน',
    startDateIsRequired: 'ระบุวันเริ่มต้น',
    seeAllWithinTheCompany: 'เห็นทั้งหมดในบริษัท',
    seeAllWithinTheSystem: 'เห็นทั้งหมดในระบบ',
    selfInformation: 'ข้อมูลตนเอง',
    selfAndSharedInformation: 'ข้อมูลตนเอง และที่แชร์มา',
    selectAll: 'เลือกทั้งหมด',
    siloNo: 'Silo No.',
    siloMax: 'Silo Max',
    siloMin: 'Silo Min',
    stockQuantity: 'ปริมาณวัตถุดิบคงเหลือ',
    stockBalance: 'รายการปรับวัตถุดิบคงเหลือ',
    stockDate: 'วันที่',
    siloNoIsRequired: 'ระบุ Silo No.',
    stockQuantityIsRequired: 'ระบุ ปริมาณวัตถุดิบคงเหลือ',
    settingMaterialStock: 'ตั้งค่าวัตถุดิบคงเหลือ',
    siloRequire: 'ขั้นต่ำ',
    silo: 'ไซโล',
    stockManagementDashboard: 'บริหารวัตถุดิบ',
    selectLocation: 'เลือกสถานที่',
    setUpAutomaticOrderingOfRawMaterials: 'ตั้งค่าการสั่งวัตถุดิบอัตโนมัติ',
    selectedAll: 'เลือกทั้งหมด',
    standard: 'ปริมาณตามเกณฑ์',
    specifyDestinationWeightTotal: 'ระบุน้ำหนักปลายทาง',
    source: 'ต้นแหล่ง',
    source_quality_evaluation: 'ทดสอบคุณภาพต้นแหล่ง',
    supplier_raw_material: 'คู่สัญญาวัตถุดิบ/โรงงาน',
    sampling_point: 'จุดที่เก็บตัวอย่าง',
    sieve_size: 'ขนาดตะแกรง',
    saving_data: 'กำลังบันทึกข้อมูล',
    stockBalanceHistory: 'ประวัติการปรับวัตถุดิบคงเหลือ',
    secondary: 'รอง',
    stockIsFull: 'สต็อกเต็มแล้ว',
    sourceNotFoundFromThePrimaryContract:
      'ไม่พบต้นแหล่ง จากสัญญาการขนส่ง (หลัก)',
    shippingContract: 'สัญญาการขนส่ง (ทางเรือ)',
    specifyTheRefDoNumber: 'ระบุเลขที่ใบงานอ้างอิง',
    shippingDashboard: 'การขนส่งวัตถุดิบ (ทางเรือ)',
    sandTestResults: 'ผลการทดสอบทราย',
    stoneTestResults: 'ผลการทดสอบหิน',
    suggest: 'แนะนำ',
    source_quality_evaluation_dashboard: 'สรุปผลคุณภาพวัตถุดิบ (ต้นแหล่ง)',
    ship: 'เรือ',
    sandOriginLocation: 'ต้นแหล่งทราย',
    supportsQuotaSystem: 'รองรับระบบโควตา',
    supplement: 'เสริม',
    stockAdjustments: 'ปรับวัตถุดิบ',
    serviceName: 'ชื่อ',
    serviceSchedule: 'กำหนดการ',
    suggestOrder: 'จำนวนที่แนะนำ',
    siloData: 'ข้อมูลไซโล',
    sendGRSuccess: 'ส่ง GR สำเร็จ',
    sendGRError: 'ส่ง GR ไม่สำเร็จ',
    sequence: 'ลำดับ',
    samplingPoint: 'จุดเก็บตัวอย่าง',
    sendTheRawMaterialBalanceAtTheBeginningOfTheDayToBluenet:
      'ส่งยอดวัตถุดิบคงเหลือต้นวันไป Bluenet',
    successfullySent: 'ส่่งสำเร็จ',
    siloSelectionSystemForMorningSalesFromBluenet:
      'ระบบเลือกไซโลของยอดเคาะเช้าจาก Bluenet',
    sourceLocked: 'ล็อกต้นแหล่ง',
    specific: 'เจาะจง',
    sourceNo: 'รหัสต้นแหล่ง',
    stock: 'สต๊อก',
    sendMorningStockToBluenetAt: 'วันที่เวลาส่งยอดเคาะเช้า Bluenet',
    showHideLocationCodeTag: 'ป้ายรหัสโรงงาน',
    surveySourcing: 'Survey sourcing',
    specifyLocation: 'ระบุสถานที่',
    surveySouringLog: 'รายการ Survey',
    surveySourcingData: 'ข้อมูล Survey',
    safetyStock: 'Safety stock',
    signatureImage: 'รูปภาพลายเซ็น',
    signatureImageData: 'ข้อมูลรูปภาพลายเซ็น',
    showMoreDetails: 'แสดงรายละเอียดเพิ่มเติม',
    subContractor: 'ผู้ขนส่งย่อย',
    showEnabledOnly: 'แสดงเฉพาะที่เปิดใช้งาน',
    siloPeripheralVolume: 'ปริมาณต่อพ่วงไซโล',
    sourceReadiness: 'ยืนยันความพร้อมในการจ่ายวัตถุดิบ',
    setAdditionalAutoOrderConditions: 'ตั้งค่าเงื่อนไข Auto order เพิ่มเติม',
    savingData: 'กำลังบันทึกข้อมูล',
    someFilesFailedToUpload: 'บางไฟล์อัปโหลดไม่สำเร็จ',
    saveDataFailed: 'บันทึกข้อมูลไม่สำเร็จ',
    submitResult: 'ส่งทดสอบ',
    submissionDate: 'วันที่ส่งผลทดสอบ',
    safe: 'ปลอดภัย',
    secondaryContract: 'สัญญารอง',
    ssaTooCoarseHint: 'เกณฑ์มาตรฐาน SSA ไม่ต่ำกว่า',
    ssaTooFineHint: 'เกณฑ์มาตรฐาน SSA ไม่เกิน',
    safetyStockMorningLine: 'Safety เช้า',
    safetyStockEveningLine: 'Safety บ่าย',
  },
  scheduleReport: {
    excel: 'Excel',
    pdf: 'PDF',
    report_comparevehiclescco: 'ทั่วไป >> รายงาน เปรียบเทียบพาหนะ SCCO',
    report_dailyiconsiam: 'ทั่วไป >> รายงานการให้บริการเรือ / รถ แบบรายวัน',
    report_distfromlastmaintenance:
      'ทั่วไป >> รายงานพาหนะที่มีระยะทางวิ่งสะสมล่าสุด',
    report_dozeoffrisk: 'ทั่วไป >> รายงานเสี่ยงหลับใน',
    report_driverinformation: 'ทั่วไป >> รายงานข้อมูลพนักงานขับขี่',
    report_drivingdistance: 'ทั่วไป >> รายงานระยะทางการวิ่ง',
    report_drivinghour: 'ทั่วไป >> รายงานพฤติกรรมการขับขี่',
    report_event: 'ทั่วไป >> รายงานเหตุการณ์พาหนะรายคัน',
    report_maintenance: 'ทั่วไป >> รายงานพาหนะที่ต้องบำรุงรักษา',
    report_numberofdaysworked: 'ทั่วไป >> รายงานจำนวนวันที่พาหนะวิ่งงาน',
    report_parking: 'ทั่วไป >> รายงานจุดจอดพาหนะ',
    report_summaryiconsiam:
      'ทั่วไป >> รายงานสรุปรอบการให้บริการเรือ / รถ แบบเฉลี่ยรายวัน',
    report_temperature: 'ทั่วไป >> รายงานอุณหภูมิ',
    report_truckcurrentlocation: 'ทั่วไป >> รายงานที่อยู่ปัจจุบันของพาหนะ',
    report_truckusage: 'ทั่วไป >> รายงานการใช้งานพาหนะ',
    SafetyDashboard: 'แดชบอร์ดความปลอดภัย',
    ScoresummaryReport: 'รายงาน รูปแบบการสรุปคะแนน',
    Scoresummary: 'สรุปคะแนน',
    selectVehicle: 'เลือกพาหนะ',
    sendRequest: 'ส่งใบคำขอ',
    serviceinstalldevice: 'ใบแจ้งติดตั้ง',
    sharpBend: 'โค้งหักศอก',
    sizeAndWeight: 'ขนาดและน้ำหนัก',
    SpeedNotOver: 'ความเร็วไม่เกิน (กม./ชม.)',
    startAndEndValidDateDesc: 'ช่วงวันที่อนุญาตให้ระบบนำข้อมูลพาหนะไปใช้งาน',
    startValidDate: 'วันที่เริ่มใช้พาหนะ',
    success: 'สำเร็จ',

    report_repairingreport: 'การจัดการอุปกรณ์ >> การแจ้งซ่อม',
    gpsVendorPayingReportCost: 'ค่าใช้จ่าย >> สรุปค่าบริการตาม GPS Vendor',
    gpsVendorPayingSummaryReport: 'ค่าใช้จ่าย >> สรุปค่าบริการ GPS ทั้งหมด',
    partnerPerformReport: 'ค่าใช้จ่าย >> สรุปเรียกเก็บเงินตามผู้รับเหมา',
    NumberofdaysworkedReport: 'ทั่วไป >> รายงานจำนวนวันที่พาหนะวิ่งงาน',
    concreteTrip: 'ทริป >> การส่งคอนกรีต',
    DrivingdistanceReport: 'ทั่วไป >> สรุประยะทางการวิ่งประจำวัน',
    TruckusageReport: 'ทั่วไป >> รายงานการใช้งานพาหนะ',
    ParkingReport: 'ทั่วไป >> รายงานจุดจอดพาหนะ',
    repairingReport: 'การจัดการอุปกรณ์ >> การแจ้งซ่อม',
  },
  sku: {
    from_uom: 'จากหน่วยนับ',
    from_uom_require: 'กรุณาเลือกจากหน่วยนับ',
    quality: 'จากจำนวน',
    quality_require: 'กรุณากรอกจากจำนวน',
    uom_require: 'กรุณาเลือกหน่วยนับ',
    weight: 'น้ำหนัก',
    weight_require: 'กรุณากรอกน้ำหนัก',
  },
  t: {
    typeNotesAndPressEnter: 'พิมพ์หมายเหตุ แล้วกด Enter',
    typeVehicel: 'ประเภทรถ',
    todysDeliveryTotal: 'ยอดจัดส่งวันนี้',
    tooMuchZoom: 'ซูมออกเกินกำหนด',
    timeToArrive: 'เวลาที่จะถึง',
    timeStamp: 'เวลาที่ลงข้อมูล',
    ticketNumber: 'หมายเลขตั๋ว',
    timeMinute: 'เวลา/นาที',
    timeSpitConcrete: 'เวลาคายปูน (ชั่วโมง:นาที)',
    tourStep1: 'ยินดีต้อนรับสู่การเปิดเผยข้อมูล เมนูนี้ประกอบด้วยสองส่วนหลัก',
    tourStep2: 'อย่างแรก ส่วนของต้นไม้',
    tourStep3: 'ประการที่สอง ส่วนรายละเอียด',
    tourStep4: 'นี่คือโหนดรูท',
    tourStep5: 'คลิกเพื่อเพิ่มโหนดย่อย',
    tourStep6: 'โหนดย่อย',
    tourStep7: 'คุณสามารถลากมาที่นี่เพื่อเปลี่ยนเส้นทางของโหนด',
    tourStep8: 'คลิกเพื่อลบโหนดนี้และรายการย่อย',
    tourStep9: 'คลิกเพื่อเพิ่มโหนดย่อย',
    tourStep10: 'คลิกเพื่อเลือกโหนดนี้',
    tourStep11: 'ชื่อของโหนดที่เลือก ซึ่งจะแสดงขึ้นหลังจากที่คุณคลิก',
    tourStep12: 'คุณสามารถเลือกรายละเอียดสำหรับโหนดที่เลือกได้',
    tourStep13: 'คลิกเพื่อบันทึกการเปลี่ยนแปลง',
    totalDividedBy2: 'รวมหาร2',
    totalKm: 'รวม(กม.)',
    take_time_to_clean_the_car: 'ใช้เวลาทำความสะอาดรถ (นาที)',
    ticket_cancellation_code: 'รหัสยกเลิกตั๋ว',
    total_duration: 'ระยะเวลาทั้งหมด (ชั่วโมง)',
    time_to_leave_job_site: 'เวลาออกจากไซต์งาน',
    time_end_cement: 'จบการเทปูน',
    time_start_cement: 'เริ่มเทปูน',
    time_before_start_cement: 'ระยะเวลาก่อนเริ่มเทปูน (ชั่วโมง)',
    time_to_visit_job_site_according_to_plan: 'เวลาเข้าไซต์งานตามแผน',
    time_to_arrive_job_site: 'เวลาถึงไซต์งาน',
    time_from_plant_to_Site: 'ระยะเวลาจากแพลนต์ถึงไซต์งาน (ชั่วโมง)',
    time_to_leave_plant: 'เวลาออกจากแพลนต์',
    truckNumber: 'เบอร์รถ',
    total: 'รวม',
    toSection: 'ถึงหน่วยงาน',
    turnOnTurnOffEngine: 'เปิดปิดเครื่องยนต์',
    truck_id: 'รหัสรถ',
    trip: 'เที่ยว',
    typeoftruck: 'ประเภทรถโม่',
    truckGoesBack: 'จำนวนรถโม่เดินทางกลับ',
    truckOnTheWayAndOnSite: 'รถโม่กำลังเดินทางและอยู่หน้างาน',
    truckIsReadyToUse: 'รถพร้อมใช้งาน',
    truckIsNotReadyToUse: 'รถไม่พร้อมใช้งาน',
    truckStatusDashboardMain: 'สถานะแดชบอร์ด',
    truckstatusdashboard: 'แดชบอร์ดภาพรวมการขนส่งคอนกรีต',
    tagID: 'รหัสแท็ก',
    taxiMeter: 'Taxi Meter',
    taxNo: 'Tax No.',
    technician: 'ช่าง',
    telnoAE: 'เบอร์โทรศัพท์ AE',
    temperature: 'อุณหภูมิ',
    temperature1: 'อุณหภูมิ 1',
    temperature2: 'อุณหภูมิ 2',
    TemperatureReport: 'อุณหภูมิ',
    temporaryTracking: 'การติดตามรถชั่วคราว',
    theDayThatTheCarPulled: 'วันที่ดึงพาหนะจม',
    theDriverIsIicenseReportHasExpired: 'ใบขับขี่หมดอายุ',
    theNumberOfWorkCompleted: 'จำนวนงานที่เสร็จสิ้น',
    theRoute: 'เส้นทาง',
    theStatusOfVehiclesThatReceiveDailyJobs: 'การติดตามวัตถุดิบ',
    TheUsualRoute: 'เส้นทางปกติ',
    theWaitingQueue: 'รอเรียกคิว',
    thisItemHasBeenDiscontinued: 'รายการนี้ถูกยกเลิกแล้ว',
    thisItemHasBeenInactive: 'รายการนี้ถูกยกเลิกใช้งานแล้ว',
    thisLocationCodeIsAlreadyInTheSystem: 'รหัสสถานที่นี้อยู่ในระบบแล้ว',
    thisMonth: 'เดือนนี้',
    thisNationalIDNumberIsAlreadyInTheSystem:
      'เลขประจำตัวประชาชนนี้ มีอยู่ในระบบแล้ว',
    thisYear: 'ปีนี้',
    ticket: 'ตั๋ว',
    ticketNumber: 'เลขที่ตั๋ว',
    time: 'เวลา',
    time_1440: '24 ชั่วโมง',
    time_15: '15 นาที',
    time_180: '3 ชั่วโมง',
    time_30: '30 นาที',
    time_300: '5 ชั่วโมง',
    time_420: '7 ชั่วโมง',
    time_60: '1 ชั่วโมง',
    time_720: '12 ชั่วโมง',
    time_entry: 'เวลาเข้า',
    time_out: 'เวลาออก',
    time_period: 'ช่วงระยะเวลา',
    time_travel: 'เวลาเดินทาง',
    time_use_in_location: 'เวลาที่อยู่ในสถานี',
    timeGoToLocation: 'เวลาแผนเข้า-ออกสถานที่',
    timeRange: 'ช่วงเวลา',
    times: 'ครั้ง',
    timeThatCanBeUsed: 'ระยะเวลาที่สามารถใช้งานระบบ',
    timeZone: 'Time Zone',
    tire: 'จำนวนยาง',
    title: 'คำนำหน้า',
    titleAccount: 'บัญชีผู้ใช้',
    to: ' ถึง ',
    to_email: 'ส่งถึง',
    today: 'วันนี้',
    toggleHeatMap: 'Toggle Heat Map',
    tokenExpired: 'เซสชันหมดอายุ',
    tons: 'ตัน',
    tool: 'เครื่องมือ',
    tooLong20: ' ไม่ควรยาวเกิน 20 ตัวอักษร',
    tooLong25: ' ไม่ควรยาวเกิน 25 ตัวอักษร',
    tooLong50: ' ไม่ควรยาวเกิน 50 ตัวอักษร',
    tools: 'เครื่องมือ',
    tooShot8: ' ไม่ควรสั้นกว่า 8 ตัวอักษร',
    top5AlertReportsOfEachTypeDividedByMonthlyTimePeriod:
      'Alert 5 อันดับแรกของแต่ละประเภทแบ่งตามช่วงเวลารายเดือน',
    topCustomer: 'Top Customer',
    topEarning: 'Top Earning',
    toSiteDistance: 'ระยะทางขาไป',
    total: 'ทั้งหมด',
    TotalFuel: 'ปริมาณน้ำมันรวม (ลิตร)',
    totalDistance: 'ระยะทางรวม (กิโลเมตร)',
    totalDuration: 'ระยะเวลารวม (วัน:ชั่วโมง:นาที)',
    totalEmergencyCase: 'กรณีฉุกเฉินทั้งหมด',
    totalExpenses: 'ค่าใช้จ่ายทั้งหมด (บาท)',
    totalNumberofMinutesEnteredSlowly: 'จำนวนนาทีเข้าช้ารวม (นาที)',
    totalPrice: 'ราคารวม',
    totalPrice_baht: 'ราคารวม (บาท)',
    totalTime: 'เวลารวม',
    totalTimeHHMM: 'เวลาทั้งหมด (ชม./นาที)',
    tracking: 'ติดตามยานพาหนะ',
    TrackingdataReport: 'รายละเอียดพิกัดพาหนะ',
    trackingNo: 'หมายเลขการติดตาม',
    trainer: 'ผู้ฝึกอบรม',
    trainingDate: 'วันที่อบรม',
    traininglist: 'รายการฝึกอบรม',
    transportationPerformanceDashboard: 'ประสิทธิภาพการขนส่งวัตถุดิบ',
    transportContractor: 'ผรม.ขนส่ง',
    traveling: 'กำลังเดินทาง',
    travelingTooLong: 'เดินทางนานเกินกำหนด',
    trip: 'การขนส่ง',
    trip_menu: 'ทริป',
    trip_date: 'ช่วงเวลาเริ่ม-สิ้นสุดทริป',
    trip_duration: 'ช่วงเวลาเริ่ม-สิ้นสุดทริป',
    trip_report_menu: 'ทริป',
    TripbyengineoffonReport: 'การเดินทางแยกประเภทตามการเปิด-ปิดเครื่องยนต์',
    tripCannotEditDueToOverTime:
      'ไม่สามารถแก้ไขสถานที่ได้เนื่องจากเกินเวลาเริ่มทริปไปแล้ว',
    tripCode: 'รหัสทริป',
    tripCodeDup: 'รหัสทริปมีในระบบแล้ว',
    tripInfo: 'ข้อมูลทริป',
    tripInfoDateTime: 'ข้อมูลทริป วันที่/เวลา',
    tripIsupply: 'เที่ยว',
    tripStartAt: 'เวลาเริ่มทริป',
    tripStatus: 'สถานะทริป',
    TripsumbylocationReport: 'สรุปจำนวนงานตามสถานที่',
    TripsumbyvehReport: 'สรุปการวิ่งแยกตามพาหนะ',
    TripsummaryReport: 'สรุปการวิ่งแยกตามทริป',
    TriptemperatureReport: 'สรุปอุณหภูมิแยกตามทริป',
    truckCategory: 'ประเภทรถบรรทุก',
    TruckcurrentlocationReport: 'ที่อยู่ปัจจุบันของพาหนะ',
    truckDriverMatching: 'จับคู่พนักงานขับขี่',
    TruckengineoffReport: 'พาหนะไม่ติดเครื่อง',
    TruckengineonReport: 'พาหนะติดเครื่อง',
    TrucknotuseReport: 'จำนวนวันที่พาหนะไม่ได้วิ่งงาน',
    truckType: 'ชนิดรถบรรทุก',
    TruckusageReport: 'การใช้งานพาหนะ',
    type: 'ประเภท',
    type_duration: 'ตามช่วงเวลา',
    type_person: 'รายบุคคล',
    type_problem: 'อาการของปัญหา',
    type_report: 'ประเภทรายงาน',
    type_trip: 'รายทริป',
    typeLocation: 'ชนิดของสถานที่',
    typeMaintenance: 'ประเภท',
    truckAvailable: 'รถพร้อมใช้งาน',
    totalFleet: 'กองรถทั้งหมด',
    theCost: 'ค่าใช้จ่าย',
    totalFilesMustBeSmallerThan20MB: 'ไฟล์ทั้งหมดต้องมีขนาดเล็กกว่า 20MB!',
    totalUsageTime: 'รวมเวลาการใช้งาน (วัน:ชั่วโมง:นาที)',
    totalParkingTime: 'รวมเวลาจอดรถ (วัน:ชั่วโมง:นาที)',
    totalIdleTime: 'รวมเวลาเดินเบา (วัน:ชั่วโมง:นาที)',
    totalRunningTime: 'รวมเวลารถวิ่ง (วัน:ชั่วโมง:นาที)',
    totalTimeHHMMSS: 'รวมเวลา (ชั่วโมง:นาที:วินาที)',
    tonsPerTrip: 'จำนวนตัน/เที่ยว',
    thisDoNumberExistsinTheSystem: 'Do Numer นี้มีอยู่ในระบบ',
    tooShort: 'สั้นเกินไป!',
    tooLong: 'ยาวเกินไป!',
    turnLeft: 'เลี้ยวซ้าย',
    turnRight: 'เลี้ยวขวา',
    thereIsaMaterialCodeAlreadyInTheSystem: 'มีรหัสวัตถุดิบนี้แล้วในระบบ',
    timeToWeigh: 'เวลาชั่งน้ำหนัก',
    thisSubMaterialIsAlreadyInTheSystem: 'วัตถุดิบย่อยนี้มีอยู่ในระบบแล้ว',
    typesOfVehiclesThatCanBeCarried: 'ประเภทพาหนะที่บรรทุกได้',
    typesOfMaterialThatCanBeCarried: 'ประเภทวัตถุดิบที่บรรทุกได้',
    truckTypeno: 'หมายเลขประเภทรถ',
    theDestinationAreaIsNotCovered: 'พื้นที่ปลายทางไม่ครอบคลุม',
    theOriginAreaIsNotCovered: 'พื้นที่ต้นทางไม่ครอบคลุม',
    takePhotosOutsideTheArea: 'ถ่ายรูปนอกพื้นที่',
    ticketCreationDate: 'วันที่ออกตั๋ว',
    theFrontOfTheCarSawTheLicensePlate: 'หน้ารถเห็นป้ายทะเบียน',
    takeAPhotoForward: 'ถ่ายไปข้างหน้า',
    takeAPhotoOnTheRight: 'ถ่ายด้านขวา',
    takeAPhotoNextToTheCar: 'ถ่ายข้างตัวรถ',
    testResult: 'ผล Test',
    takePhotosForWorkOutsideTheArea: 'ถ่ายรูปส่งงานนอกพื้นที่',
    thisIsCorrectAlreadyUsedAt: 'ถูกใช้ที่ใช้ที่ปลายทาง',
    thereIsInformationInTheSystem: 'มีข้อมูลในระบบแล้ว',
    thisComparativeMaterialCodeAlreadyExistsInTheSystem:
      'รหัสวัตถุดิบเปรียบเทียบนี้มีอยู่แล้วในระบบ',
    thisContractOfCarriageAlreadyInTheSystem:
      'สัญญาการขนส่งนี้ มีอยู่ในระบบแล้ว',
    theVehicleWasNotFoundInTheTERMINUSSystem: 'ไม่พบพาหนะในระบบ TERMINUS',
    truckPickupCard: 'บัตรแข็ง',
    thisCardNumberIsAlreadyInTheSystem: 'มีเลขบัตรนี้แล้วในระบบ',
    totalVehicle: 'รถทั้งหมด',
    telno: 'โทรศัพท์',
    theEndTimeMustBeGreaterThanTheStartTime:
      'เวลาสิ้นสุดต้องมากกว่าเวลาเริ่มต้น',
    theQuotationIsAlreadyInTheSystem: 'ใบเสนอราคา มีอยู่แล้วในระบบ',
    thereIsUpdatedStockByBlueNet:
      'ตรวจพบรายการยอดเคาะเช้าจากระบบ Bluenet หากต้องการปรับยอดใหม่ กรุณาปรับผ่านระบบ Bluenet',
    thereIsStockBalaceAlreadyInTheSystem: 'มีข้อมูลสต๊อกนี้แล้วในระบบ',
    totalUsage: 'ยอดใช้ทั้งหมด',
    tomorrow: '(พรุ่งนี้)',
    tomorrowsReserve: 'ยอดจองวันพรุ่งนี้',
    testedDate: 'วันที่ทดสอบ',
    tester: 'ผู้ทดสอบ',
    theInputMustBeNumber: 'ข้อมูลที่ระบุต้องเป็นตัวเลข',
    tested_time: 'เวลาทดสอบ',
    theInputMustBePositiveNumber: 'ข้อมูลที่ระบุต้องเป็นตัวเลขตั้งแต่ 0 ขึ้นไป',
    theInputMustBeMoreThanZero: 'ข้อมูลที่ระบุต้องมากกว่า 0',
    theInputMustBeNOTMoreThan: 'ข้อมูลที่ระบุต้องไม่เกิน',
    theDefaultValueOfRemainingRawMaterials:
      'ไม่พบค่าตั้งต้นของ วัตถุดิบคงเหลือ',
    testResultEvaluation: 'ผลการทดสอบ',
    tableView: 'มุมมองตาราง',
    tooMuchDataToImport: 'ข้อมูลมากเกินไป',
    theMaximumNumberOfTicketMustBeGreaterThan0: 'จำนวนเที่ยวต้องมากกว่า 0',
    testedBy: 'ทดสอบโดย',
    takePhotoOfReceivingTheProduct: 'ถ่ายภาพรับสินค้า',
    thisRawMaterialOrderListMustWaitForAdministrativeApprovalFirst:
      'รายการสั่งวัตถุดิบนี้ ต้องรอทางธุรการอนุมัติก่อน',
    theInputMustBeMoreThanQuotaApproved:
      'ข้อมูลที่ระบุต้องมากกว่าโควตาที่จัดรถแล้ว',
    theInputNotLessThanApprovedQuota:
      'ข้อมูลที่ระบุต้องไม่น้อยกว่าโควตาที่จัดรถแล้ว',
    todayRemaining: 'Today remaining',
    tmrDemand: 'TMR demand',
    todayAction: 'รายการที่สร้างวันนี้',
    ticketList: 'รายการตั๋ว',
    temporaryInactive: 'ปิดใช้งานสถานที่ชั่วคราว',
    thisTicketWillAlsoBeDeletedConfirmOrNot:
      'ใบงานนี้จะถูกลบด้วย ยืนยันหรือไม่',
    theInputMustBeLessThan: 'ข้อมูลที่ระบุต้องน้อยกว่า',
    theInputMustNotExceed: 'ข้อมูลที่ระบุต้องไม่เกิน',
    typeOfSearch: 'ประเภทการค้นหา',
    tank: 'ถัง',
    ticketListToday: 'จัดส่งวันนี้',
    temporaryMainContract: 'สัญญาหลักชั่วคราว',
    tooShort: 'สั้นเกินไป!',
    tooLong: 'ยาวเกินไป!',
    timeToArriveAtDestination: 'เวลาที่จะถึงปลายทาง',
    truckSharing: 'Truck Sharing',
    temporarilyClosed: 'ปิดชั่วคราว',
    ticketStatus: 'สถานะตั๋ว',
    ticketInactive: 'ยกเลิกใช้งาน',
    ticketActive: 'ใช้งาน',
    theContractorDoesNotArrangeTheVehicleWithin1Hour:
      'ผู้ขนส่งไม่จัดรถภายใน 1 ชม.',
    theContractorDoesNotArrangeTheVehicleWithinTime:
      'ผู้ขนส่งไม่จัดรถภายในเวลา',
    testResultApprovalDate: 'วันที่รับรองผลการทดสอบ',
    tomorrowsReserves: 'ยอดจอง (พรุ่งนี้)',
    token: 'โทเค็น',
    tokenActive: 'ใช้งานได้',
    tokenExpireds: 'โทเค็นหมดอายุ',
  },
  trip_import: {
    TripCodeAlreadyExistsSystem: 'รหัสทริปนี้มีอยู่แล้วในระบบ',
    confirm_send_require: 'กรุณากรอกยืนยันการส่งโดย(เข้าจุด/ออกจุด)',
    date_arrive_at_require: 'กรุณากรอกวันที่ควรถึงจุดส่งสินค้า/จุดโหลดสินค้า',
    date_out_at_require: 'กรุณากรอกวันที่ควรออกจากจุดส่งสินค้า/จุดโหลดสินค้า',
    date_start_trip_at_require: 'กรุณากรอกวันที่เริ่มทริป',
    do_number_require: 'กรุณากรอกเลขที่ใบส่งสินค้า',
    error_import: 'มีข้อผิดพลาดเกิดขึ้น',
    location_code_not_find:
      'รหัสจุดส่งสินค้า/จุดโหลดสินค้านี้ไม่มีอยู่ในระบบ :',
    location_code_require: 'กรุณากรอกรหัสจุดส่งสินค้า/จุดโหลดสินค้า',
    location_name_require: 'กรุณากรอกชื่อจุดส่งสินค้า/จุดโหลดสินค้า',
    product_code_not_find: 'รหัสสินค้านี้ไม่มีอยู่ในระบบ :',
    product_code_require: 'กรุณากรอกรหัสสินค้า',
    product_name_require: 'กรุณากรอกสินค้า',
    quality_require: 'กรุณากรอกจำนวน',
    sku_not_find: 'หน่วยนับสินค้านี้ไม่มีอยู่ในระบบ :',
    sku_require: 'กรุณากรอกหน่วยนับ',
    time_arrive_at_require: 'กรุณากรอกเวลาที่ควรถึงจุดส่งสินค้า/จุดโหลดสินค้า',
    time_out_at_require: 'กรุณากรอกเวลาที่ควรออกจากจุดส่งสินค้า/จุดโหลดสินค้า',
    time_start_trip_at_require: 'กรุณากรอกเวลาที่เริ่มทริป',
    trip_code_require: 'กรุณากรอกรหัสทริป',
    vehicle_code_not_find: 'รหัสพาหนะนี้ไม่มีอยู่ในระบบ :',
    vehicle_code_not_install: 'รหัสพาหนะนี้ยังไม่ได้ติดตั้งในระบบ :',
    vehicle_code_require: 'กรุณากรอกรหัสพาหนะ',

    date_out_at_format_incorrect:
      'กรุณากรอกวันที่ควรออกจากจุดส่งสินค้า/จุดโหลดสินค้าให้ถูกรูปแบบ :',
    time_out_at_format_incorrect:
      'กรุณากรอกเวลาที่ควรออกจากจุดส่งสินค้า/จุดโหลดสินค้าให้ถูกรูปแบบ :',
    date_start_trip_at_format_incorrect:
      'กรุณากรอกวันที่เริ่มทริปให้ถูกรูปแบบ :',
    time_start_trip_at_format_incorrect:
      'กรุณากรอกเวลาที่เริ่มทริปให้ถูกรูปแบบ :',
    time_arrive_at_format_incorrect:
      'กรุณากรอกเวลาที่ควรถึงจุดส่งสินค้า/จุดโหลดสินค้าให้ถูกรูปแบบ :',
    date_arrive_at_format_incorrect:
      'กรุณากรอกวันที่ควรถึงจุดส่งสินค้า/จุดโหลดสินค้าให้ถูกรูปแบบ :',

    remark_more_than_50: 'หมายเหตุต้องไม่เกิน 50 ตัวอักษร',
    takeAPhotoNextToTheCar: 'take A pPhoto Next To The Car',
  },
  u: {
    unlockAccount: 'ปลดล็อกบัญชี',
    unlockAccountFail: 'ปลดล็อกบัญชีไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
    unlockAccountNoPermission: 'คุณไม่มีสิทธิ์ปลดล็อกบัญชี',
    unlockAccountSuccess: 'ปลดล็อกบัญชีสำเร็จ ผู้ใช้ต้องเปลี่ยนรหัสผ่านเมื่อเข้าสู่ระบบครั้งถัดไป',
    unlockAccountHint:
      'ระบบสร้างรหัสผ่านชั่วคราวให้แล้ว กด "ปลดล็อกบัญชี" แล้วคัดลอกไปแจ้งผู้ใช้ ผู้ใช้ต้องเปลี่ยนรหัสผ่านใหม่เมื่อเข้าสู่ระบบ',
    unlockTemporaryPassword: 'รหัสผ่านชั่วคราว',
    unlockCopy: 'คัดลอก',
    unlockCopyUsernameLabel: 'ชื่อผู้ใช้งาน',
    unlockCopyPasswordLabel: 'รหัสผ่าน',
    unlockCopied: 'คัดลอกชื่อผู้ใช้งานและรหัสผ่านแล้ว',
    unlockCopyFail: 'คัดลอกไม่สำเร็จ กรุณาเลือกข้อความแล้วคัดลอกเอง',
    unlockRegenerate: 'สุ่มใหม่',
    unlockDoneHint: 'ส่งรหัสผ่านชั่วคราวนี้ให้ผู้ใช้ รหัสนี้จะไม่แสดงอีกเมื่อปิดหน้าต่าง',
    unlockClose: 'ปิด',
    resetPassword: 'รีเซ็ตรหัสผ่าน',
    resetPasswordHint:
      'ระบบสร้างรหัสผ่านชั่วคราวให้แล้ว กด "รีเซ็ตรหัสผ่าน" แล้วคัดลอกไปแจ้งผู้ใช้ รหัสผ่านเดิมจะใช้ไม่ได้ และผู้ใช้ต้องเปลี่ยนรหัสผ่านใหม่เมื่อเข้าสู่ระบบ',
    resetPasswordSuccess: 'รีเซ็ตรหัสผ่านสำเร็จ ผู้ใช้ต้องเปลี่ยนรหัสผ่านเมื่อเข้าสู่ระบบครั้งถัดไป',
    resetPasswordFail: 'รีเซ็ตรหัสผ่านไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
    resetPasswordNoPermission: 'คุณไม่มีสิทธิ์รีเซ็ตรหัสผ่าน',
    lockedPasswordEditTitle: 'บัญชีนี้ถูกล็อกอยู่ จึงเปลี่ยนรหัสผ่านที่หน้านี้ไม่ได้',
    lockedPasswordEditHint:
      'ปลดล็อกได้ที่หน้ารายละเอียดผู้ใช้งาน (ระบบจะตั้งรหัสผ่านชั่วคราวให้)',
    unBalanceStock: 'แจ้งเตือนวัตถุดิบล้นสต๊อค',
    usedQuantity: 'ปริมาณใช้',
    underFactory: 'สังกัดโรงงาน',
    underDepartment: 'สังกัดภาค',
    underSection: 'สังกัดแผนก',
    underDivision: 'สังกัดกิจการ',
    unassign: 'Unassign',
    unBroken: 'ไม่เสีย',
    uninstall: 'ถอด',
    unitPrice: 'หน่วยละ (บาท)',
    unknown: 'ไม่ระบุ',
    unLoadCount: 'จำนวนรอบที่เท',
    unloadOutsideTheArea: 'เทนอกพื้นที่',
    unloadOutsideThePourPoint: '',
    unloadPoint: 'จุดเท',
    unloadPointCode: 'รหัสจุดเท',
    unloadPointName: 'ชื่อจุดเท',
    unMatch: 'ยกเลิกการจับคู่',
    uom: 'หน่วยนับ (UOM)',
    uom_description: 'รายละเอียดหน่วยนับ',
    uom_name: 'ชื่อหน่วยนับ',
    uom_name_duplicate_require: 'ชื่อหน่วยนับนี้มีอยู่แล้วในระบบ',
    uom_name_require: 'กรุณากรอกชื่อหน่วยนับ',
    uom_smallest: 'หน่วยนับเล็กสุด',
    updatedAt: 'แก้ไขเมื่อ',
    updated: 'อัปเดต',
    updatedBy: 'แก้ไขโดย',
    updateLocation: 'อัปเดตตำแหน่ง',
    updateOnlyTheInformationEntered: 'อัปเดตเฉพาะข้อมูลที่ใส่',
    updatePictures: 'อัปเดตรูปภาพ',
    upload: 'Upload',
    uploaderIsRequired: ' กรุณาอัปโหลดไฟล์',
    uploadFile: 'อัปโหลดไฟล์',
    uploadYourFile: 'อัปโหลดไฟล์ของคุณ',
    uploadFileOfRegistrationPage: 'อัปโหลดไฟล์หน้าเล่มทะเบียน',
    use_account_name: 'ผู้ใช้งาน',
    use_date_time: 'วันเวลาที่ใช้',
    user: 'ผู้ใช้งาน',
    userClose: 'ผู้ใช้งานปิดเคส',
    userExpire: 'ระยะเวลาสิ้นสุดการใช้งาน',
    userExpireAt: 'ผู้ใช้งานสามารถใช้ระบบได้ถึง',
    userGroup: 'กลุ่มผู้ใช้งาน',
    userGroupPremission: 'กลุ่มผู้ใช้งาน',
    userName: 'ชื่อผู้ใช้งาน',
    userProfile: 'ข้อมูลผู้ใช้',
    updatetSuccess: 'แก้ไขข้อมูลสำเร็จ',
    unit: 'หน่วย',
    updateimei: 'อัปเดต Imei',
    updatevehicle: 'อัปเดตพาหนะ',
    useTheQueueSystem: 'ใช้งานระบบคิว',
    usernameMustContain: 'ชื่อผู้ใช้ต้องมี',
    underStandard: 'ปริมาณต่ำกว่าเกณฑ์',
    uploadingImage: 'กำลังอัปโหลดรูปภาพ',
    updateAt: 'แก้ไขเมื่อ',
    updateBy: 'แก้ไขโดย',
    updateSuccess: 'แก้ไขข้อมูลสำเร็จ',
    updateFail: 'แก้ไขข้อมูลไม่สำเร็จ',
    updateFailed: 'แก้ไขข้อมูลไม่สำเร็จ',
    unlimited: 'ไม่จำกัด',
    useStock: 'จ่ายออก',
    usageStatus: 'สถานะการใช้งาน',
    unlock: 'ปลดล็อค',
    urgentOrder: 'เร่งด่วน',
    urlType: 'ประเภท URL',
    userTypeName: 'ประเภทผู้ใช้งาน',
    userRights: 'สิทธิผู้ใช้งาน',
    uploadingFile: 'กำลังอัปโหลดไฟล์',
    userThatCreatedTheToken: 'ผู้ใช้งานที่ถูกสร้างโทเค็น',
  },
  v: {
    valueFromSystem: 'ค่าจากระบบ',
    valueFromSystemHint: 'รับจากระบบภายนอก · แก้ไขไม่ได้',
    vehicleNumber: 'หมายเลขพาหนะ',
    validDate: 'Valid Date',
    valueIsRequired: 'กรุณากรอกข้อมูลให้ครบถ้วน',
    vehicle: 'พาหนะ',
    vehicle_type: 'ประเภทพาหนะ',
    vehicle_typeIsRequired: 'กรุณาระบุ ประเภทพาหนะ',
    vehicle_type_code: 'รหัสประเภทพาหนะ',
    vehicleAndDriver: 'พาหนะและพนักงานขับขี่',
    vehicleBlacklist: 'พาหนะห้ามเข้าพื้นที่',
    vehicleCertNumber: 'หมายเลขใบอนุญาติขับรถ',
    vehicleCode: 'รหัสพาหนะ',
    vehicleColor: 'สีพาหนะ',
    vehicleDetail: 'ข้อมูลรายละเอียดพาหนะ',
    vehicleGroup: 'กลุ่มพาหนะ',
    vehicleGroupName: 'ชื่อกลุ่มพาหนะ',
    vehicleID: 'รหัสพาหนะ',
    VehicleinareaReport: 'พาหนะเข้าพื้นที่',
    VehicleinformationdltReport: 'ข้อมูลการเดินรถ DLT',
    vehicleModel: 'รุ่นพาหนะ',
    VehicleperformanceconcludeReport: 'สรุปประสิทธิภาพพาหนะรายคัน',
    vehicleRegisterType: 'Vehicle Register Type',
    vehicleRegistrationBookFile: 'หน้าเล่มทะเบียนยานพาหนะ',
    vehicleSharing: 'แชร์พาหนะ',
    vehicleStatus: 'สถานะพาหนะ',
    vehicleType: 'ประเภทพาหนะ',
    VelocitysummaryReport: 'สรุปความเร็วเกิน',
    vendor: 'Vendor',
    vendorIsupply: 'ผู้ขนส่ง',
    verifyYourEmailAddress: 'ยืนยันที่อยู่อีเมลของคุณ',
    version: 'เวอร์ชั่น',
    video: 'วิดีโอเรียลไทม์ MDVR',
    video_type: 'ประเภทวิดีโอ',
    videoDownload: 'ดาวน์โหลดวิดีโอ',
    videospecial: 'MDVR Live Stream (พิเศษ)(วิดีโอเรียลไทม์จาก MDVR)',
    view: 'ดู',
    vnCode: 'รหัสพาหนะ',
    voluntary: 'ประกันภัยรถยนต์ภาคสมัครใจ',
    volumn: 'ปริมาณ',
    vehicle_maintenancedevice_duplicate:
      'พาหนะทะเบียน/รหัสนี้มีการแจ้งซ่อมเข้ามาในระบบแล้ว',
    visibilityOfThisUser: 'สิทธิ์การมองเห็นของผู้ใช้รายนี้',
    visibilityOfThis: 'สิทธิ์การมองเห็นของ',
    vendorCodeIsRequired: 'ระบุ รหัสผู้ขนส่ง',
    vehicleInformation: 'ข้อมูลพาหนะ',
    vehicleUsageData: 'ข้อมูลการใช้รถ',
    vehicleLists: 'รายการรถ',
    vehicleView: 'มุมมองพาหนะ',
    vehicleIsNotAvailable: 'พาหนะไม่พร้อมใช้งาน',
    vehicleTypeIsRequired: 'ระบุประเภทพาหนะ',
    valueIsInValid: 'กรุณากรอกข้อมูลให้ถูกต้อง',
    valueMustNotExceed: 'ค่าต้องไม่เกิน',
    valueMustNotLessThan: 'ค่าต้องไม่น้อยกว่า',
    vehicleTypeThatCanBeEntered: 'ประเภทพาหนะที่สามารถเข้าได้',
    vehiclesUsedMustNotExceedTheNumberOfTickets:
      'จำนวนรถที่เลือกต้องไม่เกินจำนวนตั๋ว',
    vehiclesUsedMustNotExceedContractorQuota:
      'จำนวนรถที่เลือกต้องไม่เกินโควตาของผู้รับเหมา',
    videoMenu: 'วิดีโอ',
    variance: 'Variance',
  },
  variable: {
    abnormal_behavior: 'พฤติกรรมการขับขี่ไม่ปลอดภัย',
    abnormal_temperature: 'อุณหภูมิผิดปกติ',
    boom: 'BOOM',
    compulsory_motor_insurance: 'ประกันภัยรถยนต์ภาคบังคับ',
    driving: 'ขับพาหนะ',
    driving_hour: 'ชั่วโมงการขับขี่',
    engine_oil: 'น้ำมันเครื่อง',
    event: 'เหตุการณ์',
    fuel: 'เชื้อเพลิง',
    high: 'สูง',
    insurance: 'ประกันภัย',
    invalidCredentials: 'ข้อมูลเซสชันไม่ถูกต้อง',
    invalidOldPassword: 'รหัสผ่านไม่ถูกต้อง',
    low: 'ต่ำ',
    maintenance_vehicle: 'พาหนะ',
    medium: 'กลาง',
    No: 'ไม่',
    no_entry: 'เข้าพื้นที่',
    no_exit: 'ออกพื้นที่',
    off: 'ปิด',
    on: 'เปิด',
    parking: 'จอดพาหนะ',
    parking_area: 'จุดจอด',
    passwordPolicyViolation: 'รหัสผ่านใหม่ไม่ตรงตามเงื่อนไข',
    prohibited_area: 'พื้นที่',
    pto_door: 'เปิด PTO/ประตู',
    safety: 'ความปลอดภัย',
    sensor: 'เซ็นเซอร์',
    sos: 'SOS',
    speed: 'ความเร็ว',
    speed_limit: 'ความเร็ว',
    speed_limit_area: 'ความเร็วในพื้นที่',
    stop: 'จอดรถทั่วไป',
    stop_engine_on: 'จอดรถติดเครื่องทั่วไป',
    stop_engine_on_long_time: 'จอดรถติดเครื่องนาน (ครั้้ง)',
    stop_engine_on_long_date: 'จอดรถติดเครื่องนาน (เวลา)',
    stop_engine_on_with_area: 'จอดรถติดเครื่องระบุพื้นที่',
    stop_with_area: 'จอดรถทั่วไประบุพื้นที่',
    stop_with_engine_off: 'จอดรถดับเครื่อง',
    stop_with_engine_off_long_time: 'จอดรถดับเครื่องนาน (ครั้ง)',
    success: 'สำเร็จ',
    suspension: 'ช่วงล่าง',
    taxi: 'Taxi',
    temperature: 'อุณภูมิ',
    timeline_aggressive_acceleration: 'ออกตัวกระชาก',
    timeline_aggressive_acceleration_time: 'ออกตัวกระชาก (ครั้ง)',
    timeline_speed_over: 'ความเร็วเกินกำหนด',
    timeline_suddenly_break: 'เบรคกะทันหัน',
    timeline_vehicle_stop_with_engine_on: 'จอดรถติดเครื่อง',
    tire: 'ยาง',
    voluntary_motor_insurance: 'ประกันภัยรถยนต์ภาคสมัครใจ',
    Yes: 'ใช่',
  },
  vehicleType: {
    backhoe: 'รถแบคโฮ',
    bulk_cargo: 'เรือสินค้าเทกอง',
    bus: 'รถเมล์',
    car_6wheelers_trailer: 'รถ 6 ล้อ เทรลเลอร์',
    caravan_10wheelers: 'รถพ่วง 10 ล้อ',
    cargo_ship: 'เรือ',
    cash_transporter_cmc01: 'รถขนส่งเงิน - CMC 01',
    cash_transporter_cmc02: 'รถขนส่งเงิน - CMC 02',
    cash_transporter_g45: 'รถขนส่งเงิน - G4S',
    cash_transporter_lrd130: 'รถขนส่งเงิน - LRD130',
    cash_transporter_test01: 'รถขนส่งเงิน - Test 01',
    cement_bags_transporter_10wheelers: 'รถขนส่งปูนถุง 10 ล้อ',
    cement_powder_banana_shaped_trailer: 'รถปูนผง กล้วยหอม',
    cement_powder_full_trailer: 'รถปูนผง พ่วงเต้า',
    concrete_pump: 'ปั๊มลาก อาคารสูงตั้งแต่ ชั้น 1-7',
    container_truck_10wheelers: 'รถตู้คอนเทนเนอร์ 10 ล้อ',
    container_truck_6wheelers: 'รถตู้คอนเทนเนอร์ 6 ล้อ',
    drive_10wheelers: 'รถ 10 ล้อ',
    drive_12wheelers: 'รถ 12 ล้อ',
    drive_18wheelers: 'รถ 18 ล้อ',
    drive_3wheelers: 'รถ 3 ล้อ',
    drive_6wheelers: 'รถ 6 ล้อ',
    dump_truck: 'รถดั๊ม',
    express_4wheelers: '4 ล้อ เอ็กเพรส',
    fjsldk: 'fjsldk',
    flatbed_car: 'รถพื้นเรียบ',
    forage_transporter_10wheelers: 'รถขนอาหารสัตว์ 10 ล้อ',
    forage_transporter_12wheelers: 'รถขนอาหารสัตว์ 12 ล้อ',
    forage_transporter_18wheelers: 'รถขนอาหารสัตว์ 18 ล้อ',
    forage_transporter_22wheelers: 'รถขนอาหารสัตว์ 22 ล้อ',
    forage_transporter_trailer: 'รถขนอาหารสัตว์ เทรลเลอร์',
    forklift: 'รถยก',
    freeze_truck_4wheelers: 'รถตู้เย็น 4 ล้อ',
    freeze_truck_6wheelers: 'รถตู้เย็น 6 ล้อ',
    harvestar: 'รถเก็บเกี่ยว',
    hazardous_materials_10wheelers: 'รถบรรทุกวัตถุอันตราย 10 ล้อ',
    hazardous_materials_trailer: 'รถบรรทุกวัตถุอันตราย เทรลเลอร์',
    high_4wheelers: '4 ล้อสูง',
    isuzu: 'อีซูซุ',
    jumbo_4wheelers: '4 ล้อจัมโบ้',
    mini_4wheelers: '4 ล้อ มินิ',
    mix_trailer: 'เทรเลอร์มิกซ์',
    motorcycle: 'รถจักรยานยนต์',
    ngv_10wheelers: 'NGV 10 ล้อ',
    pickup_4wheelers: 'รถกระบะ 4 ล้อ',
    pickup_truck_10wheelers: 'รถกระบะ 10 ล้อ',
    pickup_truck_12wheelers: 'รถกระบะ 12 ล้อ',
    pickup_truck_14wheelers: 'รถกระบะ 14 ล้อ',
    pickup_truck_4bigwheelers: 'รถกระบะ 4 ล้อใหญ่',
    pickup_truck_4wheelers: 'รถกระบะ 4 ล้อ',
    pickup_truck_4wheelers25: 'รถกระบะ 4 ล้อ(2.5)',
    pickup_truck_6wheelers: 'รถกระบะ 6 ล้อ',
    pre_cast: 'PreCast',
    pump: 'Pump',
    rmx_truck_10wheelers: 'รถบรรทุก RMX 10 ล้อ',
    rmx_truck_4wheelers: 'รถบรรทุก RMX 4 ล้อ',
    rmx_truck_6wheelers: 'รถบรรทุก RMX 6 ล้อ',
    sedan: 'รถเก๋ง',
    semi_trailer: 'รถกึ่งพ่วง',
    semi_trailer_18wheelers: 'กึ่งพ่วง 18 ล้อ',
    semi_trailer_22wheelers_less_than_6m: 'รถกึ่งพ่วง 22 ล้อ < 6 ม.',
    semi_trailer_22wheelers_less_than_7m: 'รถกึ่งพ่วง 22 ล้อ < 7 ม.',
    semi_trailer_22wheelers_less_than_8m: 'รถกึ่งพ่วง 22 ล้อ < 8 ม.',
    semi_trailer_22wheelers_over_8m: 'รถกึ่งพ่วง 22 ล้อ > 8 ม.',
    semi_trailer_24wheelers: 'กึ่งพ่วง 24 ล้อ',
    semi_trailer_20wheelers: 'กึ่งพ่วง 20 ล้อ',
    truck_4wheel: 'รถบรรทุก 4 ล้อ',
    truck_6wheel: 'รถบรรทุก 6 ล้อ',
    truck_10wheel: 'รถบรรทุก 10 ล้อ',
    truck_12wheel: 'รถบรรทุก 12 ล้อ',
    truck_14wheel: 'รถบรรทุก 14 ล้อ',
    tail: 'หาง',
    taxi: 'รถแท็กซี่',
    tractor: 'รถไถ',
    trailer_18wheelers: 'รถพ่วง 18 ล้อ',
    trailer_20wheelers: 'รถพ่วง 20 ล้อ',
    trailer_22wheelers: 'รถพ่วง 22 ล้อ',
    trailer_24wheelers: 'รถพ่วง 24 ล้อ',
    type_test: 'ทดสอบ',
    van: 'รถตู้',
    van_dont_send_department: 'รถตู้(ไม่ส่งกรม)',
    van_tpt: 'รถตู้ TPT',
    banana_shaped_trailer: 'รถกล้วยหอม',
    tao_pune_car: 'รถเต้า',
    tao_pune_trailer_car: 'รถเต้าพ่วง',
    cranes50: 'รถเครน (50)',
    hydraulicWheelCrane: 'รถปั้นจั่นไฮดรอลิคล้อยาง',
    crawlerWheelCranes: 'รถปั้นจั่นล้อตีนตะขาบ',
    craneBoat: 'เรือปั้นจั่น',
    bigTruck: 'รถบรรทุกใหญ่ 10 ล้อ (60)',
    togo: 'TOGO',
    easy_pump: 'อีซี่ปั๊ม',
    trailer_24wheelers_50: 'พ่วง 7 เพลา 24 ล้อ (50.5 ตัน)',
    boom_pump: 'ปั๊มบูม 32 เมตร',
    boom_pump_33: 'ปั๊มบูม 33 เมตร',
    boom_pump_37: 'ปั๊มบูม 37 เมตร',
    boom_pump_40: 'ปั๊มบูม 40 เมตร',
    boom_pump_42: 'ปั๊มบูม 42 เมตร',
    boom_pump_43: 'ปั๊มบูม 43 เมตร',
    concret_epump: 'ปั๊มลาก อาคารสูงตั้งแต่ ชั้น 1-7',
    concrete_pump_8_15: 'ปั๊มลาก อาคารสูงตั้งแต่ ชั้น 8-15',
    concrete_pump_16_20: 'ปั๊มลาก อาคารสูงตั้งแต่ ชั้น 16-20',
    concrete_pump_21_30: 'ปั๊มลาก อาคารสูงตั้งแต่ ชั้น 21-30',
    tugboat: 'เรือลากจูง',
  },
  w: {
    waiting_for_ticket: 'รอออกตั๋ว',
    finished_ticket: 'ออกตั๋วเสร็จ/รอเริ่มผลิต',
    arrive: 'ถึงหน่วยงาน',
    start_pouring: 'เริ่มเท',
    finished_pouring: 'เทเสร็จสิ้นแล้ว',
    carry_out_production: 'กำลังผลิต/รอออกจากแพลนต์',
    out_of_plant: 'กำลังเดินทางไปหน่วยงาน',
    waiting_for_the_next_job: 'รอการรับงานครั้งต่อไป (นาที)',
    work_order_number: 'หมายเลขใบสั่งงาน',
    working_day: 'จำนวนวันวิ่งงาน',
    working_days: 'ชั่วโมงการทำงานทั้งหมด',
    working_hour: 'ชั่วโมง GPS ใช้งานได้',
    wrongPoint: 'เข้าผิดจุด',
    wrongPointDetail:
      'กรณีที่รถเข้าผิดหน่วยงานหรือผ่านจุดที่ไม่ใช่ของตัวเองเป็นระยะเวลา 1 นาที',
    waitProduction: 'รถโม่จอดรอผลิต',
    wait: 'รอ',
    w_friday: 'ศุกร์',
    w_monday: 'จันทร์',
    w_saturday: 'เสาร์',
    w_sunday: 'อาทิตย์',
    w_thursday: 'พฤหัสบดี',
    w_tuesday: 'อังคาร',
    w_wednesday: 'พุธ',
    waitAssessment: 'รอประเมิน',
    waitForEmailChecking: 'รอการบืน Email',
    waitingConfirm: 'รอยืนยัน',
    waitingForDelivery: 'รอจัดส่ง',
    waitingForJob: 'รองาน',
    waitingForUnloading: 'รอเท',
    wall: 'ผนัง',
    warrantyEnd: 'สิ้นสุดการรับประกัน',
    week: 'สัปดาห์',
    weekly: 'รายสัปดาห์',
    weightIn: 'นน.ชั่งเบา',
    weightInDateTime: 'วันที่เวลาชั่งเบา',
    weightInDestinationDateTime: 'วันที่เวลาชั่งเบาปลายทาง',
    weightInAt: 'เวลาชั่งเบา',
    weightInStatus: 'ชั่งเบา',
    weightInDestination: 'นน.ชั่งเบาปลายทาง',
    weightOut: 'ชั่งหนัก',
    weightOutAt: 'เวลาชั่งหนัก',
    weightOutAtDateTime: 'วันที่เวลาชั่งหนัก',
    weightOutStatus: 'ชั่งหนัก',
    weWillContactYouAtTheTelephoneNumberProvided:
      'เราจะติดต่อคุณตามหมายเลขโทรศัพท์ที่แจ้งไว้',
    wheel: 'จำนวนวงล้อ',
    whenEventOccurred: 'ลักษณะการแจ้งเตือน',
    whichMayHaveToContactTheAppointmentLocationAgain:
      'โดยอาจจะมีการติดต่อสถานที่นัดอีกครั้งได้',
    wigth: 'กว้าง',
    workNow: 'งานปัจจุบัน',
    working: 'เวลาวิ่ง',
    workingTime: 'เวลาวิ่งงาน',
    workingTime_dd_hr__mm: 'เวลาวิ่งงาน (วัน:ชม:นาที)',
    workingTimeActual_dd_hr__mm: 'เวลาวิ่งงานจริง (วัน:ชม:นาที)',
    workingTimeActual: 'เวลาวิ่งงานจริง',
    workOverTime: 'ปฏิบัติงานเกินช่วงเวลา',
    withinTimeLimit: 'จัดส่งตรงเวลา',
    weight: 'น้ำหนัก (ตัน)',
    wheretheQRCodeIsScanned: 'ตำแหน่งสแกน QR Code',
    weighingHistoryReport: 'ประวัติการชั่งน้ำหนัก',
    wouldYouLikeToRejectThisItem: 'คุณต้องการปฏิเสธรายการนี้หรือไม่',
    wouldYouLikeToApproveThisItem: 'คุณต้องการอนุมัติรายการนี้หรือไม่',
    weightGainType: 'ประเภทการรับค่าน้ำหนัก',
    weightMode: 'ประเภทการชั่งน้ำหนัก',
    weightSource: 'แหล่งที่มาของน้ำหนัก',
    weighingFormat: 'รูปแบบการชั่งน้ำหนัก',
    weighingRandomConditions: 'เงื่อนไขการสุ่มชั่งน้ำหนัก',
    weighedAt: 'ชั่งน้ำหนักที่',
    website: 'เว็บไซต์',
    wouldYouLikeToCloseTheseItems: 'คุณต้องการปิดงานรายการเหล่านี้หรือไม่',
    weightAccordingToWorksheet: 'น้ำหนักตามใบงาน',
    weightInImgAt: 'เวลาถ่ายรูปชั่งเบา',
    weightInImgDateTime: 'วันที่เวลาถ่ายรูปชั่งเบา',
    weightOutImgAt: 'เวลาถ่ายรูปชั่งหนัก',
    weightOutImgDateTime: 'วันที่เวลาถ่ายรูปชั่งหนัก',
    wouldYouLikeToConfirmTheseBookings:
      'คุณต้องการยืนยันการจองรายการเหล่านี้หรือไม่',
    workSchedule: 'ปฏิทินงานกองรถ',
    weightInterfaceAt: 'เวลาที่ได้รับน้ำหนักจากเครื่องชั่ง',
    weightFromScale: 'น้ำหนักจากเครื่องชั่ง',
    water: 'น้ำ',
    weightSourceDriver: 'พนักงานขับ',
    weigh: 'น้ำหนัก',
    Weigh: 'ชั่งน้ำหนัก',
    waitingForInformation: 'รอส่งข้อมูล',
    wt_ret: 'น้ำหนัก (กก.)',
    waitingForWeight: 'รอยืนยันน้ำหนัก',
    waitingForResponse: 'รอการตอบกลับ',
    waitingSend: 'รอส่ง',
    web_login_redirect: 'web login redirect',
    weight_from: 'น้ำหนักจาก',
    warning: 'แจ้งเตือน',
    waitingTestAt: 'วันที่ร้องขอผลทดสอบ',
    waitingApproveAt: 'วันที่อัปโหลดผลทดสอบ',
  },
  weight_uom: {
    g: 'กรัม',
    kg: 'กิโลกรัม',
    weight_uom: 'หน่วยของน้ำหนัก',
    weight_uom_require: 'กรุณาเลือกหน่วยของน้ำหนัก',
  },
  weight_mode: {
    in: 'ชั่งเบา',
    out: 'ชั่งหนัก',
    total: 'ชั่งสุทธิ',
  },
  x: {},
  y: {
    yourLocation: 'ตำแหน่งของคุณ',
    year: 'ปี',
    yearly: 'รายปี',
    yes: 'ใช่',
    you: 'คุณ',
    youCanOonlyUploadExcelFile: 'คุณสามารถอัปโหลดไฟล์ EXCEL ได้เท่านั้น',
    youCanOonlyUploadPdfFile: 'คุณสามารถอัปโหลดไฟล์ PDF ได้เท่านั้น',
    youCanOnlyUploadPNGorPDFfiles:
      'คุณสามารถอัปโหลดไฟล์ PNG, JPG, JPEG, PDF ได้เท่านั้น',
    youWantToEnableTheLocation: 'คุณต้องการเปิดใช้สถานที่ หรือไม่',
  },
  z: {
    zone: 'พื้นที่',
    zoneName: 'ชื่อพื้นที่',
    zoneNameIsRequired: 'กรุณากรอกชื่อพื้นที่',
    zoomIn: 'ขยายเข้า',
    zoomInForMoreInfo: 'ซูมเข้าเพื่อใช้งานฟีเจอร์',
    zoomOut: 'ขยายออก',
  },

  notifytype: {
    speed_over_limit: 'ความเร็วเกินกำหนด',
    driving_time_4_hrs: 'ขับต่อเนื่อง > 4 ชม.',
    working_time_10_hrs: 'ปฏิบัติงาน > 10 ชม. / วัน',
    aggressive_turn: 'เลี้ยวกระทันหัน',
    aggressive_acceleration_break: 'ออกตัวกระชาก/เบรคกระทันหัน',
    parking_on_road_side: 'จอดไหล่ทาง',
    no_parking_engine_on: 'จอดในที่ห้ามจอด(ไม่ดับเครื่อง)',
    no_parking_engine_off: 'จอดในที่ห้ามจอด(ดับเครื่อง)',
    unload_outside_location: 'เทนอกหน่วยงาน',
    delivery_over_3_hrs: 'จัดส่งนานเกิน 3 ชั่วโมง',
  },

  maintenance: {
    appointment_place: 'สถานที่นัด/แพลนต์',
    appointment_place_require: 'กรุณากรอกสถานที่นัด/แพลนต์',
    type_problem_require: 'กรุณาเลือกอาการปัญหา',
    comment_require: 'กรุณากรอกรายละเอียดเพิ่มเติม',

    province: 'จังหวัด',
    province_require: 'กรุณาเลือกจังหวัด',
    district_require: 'กรุณาเลือกเขต/อำเภอ',
    district: 'เขต/อำเภอ',
    vehicle_require: 'กรุณาเลือกรถ',
  },

  quantityUnit: {
    litre: 'ลิตร',
    ton: 'ตัน',
    tonne: 'ตัน',
    job: 'งาน',
    hour: 'ชั่วโมง',
    kg: 'กก.',
  },

  quantityCaptitalLetterUnit: {
    litre: 'LITRE',
    ton: 'TON',
    tonne: 'TON',
    job: 'JOB',
    hour: 'HOUR',
    kg: 'KG',
  },

  deliveryStatus: {
    delivered: 'ส่งสำเร็จ',
    unloading: 'กำลังปล่อยซีเมนต์',
    arrived: 'ถึงปลายทาง',
    'in-transit': 'กำลังเดินทาง',
    load: 'กำลังบรรจุ',
  },

  visibility: {
    vehicle: 'พาหนะ',
    vehicle_group: 'กลุ่มพาหนะ',
    location_group: 'กลุ่มสถานที่',
    location: 'สถานที่',
    user: 'ผู้ใช้งาน',
  },
  replayVehicleStatus: {
    จอดไม่ดับเครื่อง: 'จอดไม่ดับเครื่อง',
    วิ่ง: 'วิ่ง',
    คายคอนกรีต: 'คายคอนกรีต',
    ดับเครื่อง: 'ดับเครื่อง',
  },
  unit: {
    gainSquareMeter: 'เม็ด / ตารางเมตร',
    cue: 'คิว',
  },
  stockList: {
    stoneSand: 'หิน/ทราย',
    cement: 'ซีเมนต์',
    mixture: 'น้ำยา',
    water: 'น้ำ',
    chemicalSolution: 'น้ำยา',
    stone: 'หิน',
    sand: 'ทราย',
    rock: 'หิน',
  },
  notesOnStockAdjustmentsList: {
    valveLeak: 'วาล์วรั่ว',
    spilled: 'หกหล่น',
    supportingStoneUnderTheScale: 'หินหนุนเครื่องชั่ง',
    weighingSystemError: 'Error ระบบชั่ง',
    other: 'อื่นๆ',
    startStock: 'ตั้งยอด',
  },
  rawMaterialDeliveryStatus: {
    success: 'จัดส่งเรียบร้อยแล้ว',
    in_progress: 'ระหว่างการจัดส่ง',
  },
  material_type: {
    rock: 'หิน',
    sand: 'ทราย',
    cement: 'ซีเมนต์',
    water: 'น้ำ',
    chemical_solution_d: 'น้ำยา D',
    chemical_solution_f: 'น้ำยา F',
    humus: 'ดินดำ',
    loess: 'ดินเหลือง',
    pfa: 'PFA',
    etc: 'อื่นๆ',
  },
  material_quota: {
    recommend: 'แนะนำ',
    other: 'อื่นๆ',
  },
  msgError: {
    contract_not_found: 'ไม่พบข้อมูลสัญญาการขนส่ง',
  },
  contractorDayOff: {
    monday: 'จ',
    tuesday: 'อ',
    wednesday: 'พ',
    thursday: 'พฤ',
    friday: 'ศ',
    saturday: 'ส',
    sunday: 'อา',
  },
  menuHierarchy: {
    sourceQualityLog: 'บันทึกผลทดสอบต้นแหล่ง',
    dashboard: 'แดชบอร์ด',
    fleetManagement: 'ระบบจัดการกองรถ',
    monitoring: 'ระบบติดตาม',
    materialQuotaManagement: 'บริหารโควตาวัตถุดิบ',
    trip: 'ทริป',
    history: 'ประวัติ',
    management: 'การจัดการ',
    masterdata: 'ข้อมูลหลัก',
    location: 'สถานที่',
    vehicle: 'พาหนะ',
    driver: 'พนักงานขับขี่',
    material: 'วัตถุดิบ',
    carRental: 'รถเช่า',
    video: 'วิดีโอ',
    mdvr: 'MDVR',
    general: 'ทั่วไป',
    behavior: 'พฤติกรรม',
    alertAndAlarm: 'Alert & Alarm',
    performance: 'ประสิทธิภาพ',
    policy: 'นโยบาย',
    energy: 'พลังงาน',
    theCost: 'ค่าใช้จ่าย',
    maintenanceDevice: 'การจัดการอุปกรณ์',
    truckSharing: 'แชร์พาหนะ',
    precast: 'Precast',
    deliver: 'การจัดส่ง',
    help: 'ช่วยเหลือ',
    setting: 'ตั้งค่า',
    internalOperation: 'การจัดการภายใน',
    etc: 'อื่นๆ',
    announcement: 'ประกาศ',
    insurance: 'ประกันภัย',

    stockMaterial: 'Stock วัตถุดิบ', // New node menu
    orderReceiveMaterialDeliverTracking: 'สั่ง - รับ - ติดตามการขนส่งวัตถุดิบ', // New node menu
    materialQuality: 'คุณภาพวัตถุดิบ', // New node menu
    report: 'รายงาน', // New node menu
    setting: 'การตั้งค่า', // New node menu

    realtimeStock: 'Realtime Stock',
    materialManagementAdministrator: 'บริหารวัตถุดิบ (ธุรการ)',
    enterMorningStock: 'กรอก Stok เช้า',
    orderReceiveDeliverTracking: 'สั่ง - รับ - ติดตามการขนส่ง',
    orderReceiveMaterialDeliverTracking: 'สั่ง - รับ - ติดตามการขนส่งวัตถุดิบ',
    qualityPeriodic: 'คุณภาพประจำงวด',
    originSourceQuality: 'คุณภาพต้นแหล่ง',
    dailyQuality: 'คุณภาพประจำวัน',
  },
}

export { th }
